// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
    width: 100%
}
.pointer-events-none {
    pointer-events: none
}
.visible {
    visibility: visible
}
.fixed {
    position: fixed
}
.\\!absolute {
    position: absolute !important
}
.absolute {
    position: absolute
}
.relative {
    position: relative
}
.sticky {
    position: sticky
}
.\\!left-1\\/2 {
    left: 50% !important
}
.\\!top-\\[var\\(--header-height\\)\\] {
    top: var(--header-height) !important
}
.-bottom-\\[10px\\] {
    bottom: -10px
}
.-bottom-\\[160px\\] {
    bottom: -160px
}
.-bottom-\\[2px\\] {
    bottom: -2px
}
.-bottom-\\[60px\\] {
    bottom: -60px
}
.-left-\\[105px\\] {
    left: -105px
}
.-left-\\[10px\\] {
    left: -10px
}
.-left-\\[30px\\] {
    left: -30px
}
.-left-\\[45px\\] {
    left: -45px
}
.-left-\\[50px\\] {
    left: -50px
}
.-left-\\[70px\\] {
    left: -70px
}
.-left-\\[7px\\] {
    left: -7px
}
.-right-\\[105px\\] {
    right: -105px
}
.-right-\\[50px\\] {
    right: -50px
}
.-right-\\[70px\\] {
    right: -70px
}
.-top-\\[10\\%\\] {
    top: -10%
}
.-top-\\[100px\\] {
    top: -100px
}
.-top-\\[150px\\] {
    top: -150px
}
.-top-\\[15px\\] {
    top: -15px
}
.-top-\\[1px\\] {
    top: -1px
}
.-top-\\[20px\\] {
    top: -20px
}
.-top-\\[25px\\] {
    top: -25px
}
.-top-\\[40px\\] {
    top: -40px
}
.-top-\\[50px\\] {
    top: -50px
}
.-top-\\[7\\%\\] {
    top: -7%
}
.-top-\\[70px\\] {
    top: -70px
}
.-top-\\[90px\\] {
    top: -90px
}
.bottom-0 {
    bottom: 0px
}
.bottom-\\[-100px\\] {
    bottom: -100px
}
.bottom-\\[-10px\\] {
    bottom: -10px
}
.bottom-\\[-110px\\] {
    bottom: -110px
}
.bottom-\\[-20px\\] {
    bottom: -20px
}
.bottom-\\[-250px\\] {
    bottom: -250px
}
.bottom-\\[-25px\\] {
    bottom: -25px
}
.bottom-\\[-285px\\] {
    bottom: -285px
}
.bottom-\\[-32px\\] {
    bottom: -32px
}
.bottom-\\[-35px\\] {
    bottom: -35px
}
.bottom-\\[-40px\\] {
    bottom: -40px
}
.bottom-\\[-420px\\] {
    bottom: -420px
}
.bottom-\\[-45px\\] {
    bottom: -45px
}
.bottom-\\[-50px\\] {
    bottom: -50px
}
.bottom-\\[-55px\\] {
    bottom: -55px
}
.bottom-\\[-95px\\] {
    bottom: -95px
}
.bottom-\\[0px\\] {
    bottom: 0px
}
.bottom-\\[100px\\] {
    bottom: 100px
}
.bottom-\\[150px\\] {
    bottom: 150px
}
.bottom-\\[15px\\] {
    bottom: 15px
}
.bottom-\\[160px\\] {
    bottom: 160px
}
.bottom-\\[20px\\] {
    bottom: 20px
}
.bottom-\\[230px\\] {
    bottom: 230px
}
.bottom-\\[25px\\] {
    bottom: 25px
}
.bottom-\\[2px\\] {
    bottom: 2px
}
.bottom-\\[30\\%\\] {
    bottom: 30%
}
.bottom-\\[30px\\] {
    bottom: 30px
}
.bottom-\\[35px\\] {
    bottom: 35px
}
.bottom-\\[40\\%\\] {
    bottom: 40%
}
.bottom-\\[40px\\] {
    bottom: 40px
}
.bottom-\\[45px\\] {
    bottom: 45px
}
.bottom-\\[50px\\] {
    bottom: 50px
}
.bottom-\\[55px\\] {
    bottom: 55px
}
.bottom-\\[63px\\] {
    bottom: 63px
}
.bottom-\\[70px\\] {
    bottom: 70px
}
.bottom-\\[80px\\] {
    bottom: 80px
}
.left-0 {
    left: 0px
}
.left-1\\/2 {
    left: 50%
}
.left-5 {
    left: 1.25rem
}
.left-\\[-110px\\] {
    left: -110px
}
.left-\\[-115px\\] {
    left: -115px
}
.left-\\[-15px\\] {
    left: -15px
}
.left-\\[-50px\\] {
    left: -50px
}
.left-\\[-70px\\] {
    left: -70px
}
.left-\\[-85px\\] {
    left: -85px
}
.left-\\[-90px\\] {
    left: -90px
}
.left-\\[0px\\] {
    left: 0px
}
.left-\\[100px\\] {
    left: 100px
}
.left-\\[10px\\] {
    left: 10px
}
.left-\\[15\\%\\] {
    left: 15%
}
.left-\\[155px\\] {
    left: 155px
}
.left-\\[15px\\] {
    left: 15px
}
.left-\\[20\\%\\] {
    left: 20%
}
.left-\\[200px\\] {
    left: 200px
}
.left-\\[25px\\] {
    left: 25px
}
.left-\\[30px\\] {
    left: 30px
}
.left-\\[40\\%\\] {
    left: 40%
}
.left-\\[40px\\] {
    left: 40px
}
.left-\\[415px\\] {
    left: 415px
}
.left-\\[50px\\] {
    left: 50px
}
.left-\\[64px\\] {
    left: 64px
}
.left-\\[65px\\] {
    left: 65px
}
.left-\\[calc\\(15\\%-220px\\)\\] {
    left: calc(15% - 220px)
}
.left-auto {
    left: auto
}
.right-0 {
    right: 0px
}
.right-1\\/2 {
    right: 50%
}
.right-\\[-10px\\] {
    right: -10px
}
.right-\\[-125px\\] {
    right: -125px
}
.right-\\[-20px\\] {
    right: -20px
}
.right-\\[-225px\\] {
    right: -225px
}
.right-\\[-265px\\] {
    right: -265px
}
.right-\\[-50px\\] {
    right: -50px
}
.right-\\[-70px\\] {
    right: -70px
}
.right-\\[-85px\\] {
    right: -85px
}
.right-\\[-90px\\] {
    right: -90px
}
.right-\\[0px\\] {
    right: 0px
}
.right-\\[10px\\] {
    right: 10px
}
.right-\\[140px\\] {
    right: 140px
}
.right-\\[15\\%\\] {
    right: 15%
}
.right-\\[15px\\] {
    right: 15px
}
.right-\\[170px\\] {
    right: 170px
}
.right-\\[20\\%\\] {
    right: 20%
}
.right-\\[20px\\] {
    right: 20px
}
.right-\\[23px\\] {
    right: 23px
}
.right-\\[25px\\] {
    right: 25px
}
.right-\\[30px\\] {
    right: 30px
}
.right-\\[40px\\] {
    right: 40px
}
.right-\\[450px\\] {
    right: 450px
}
.right-\\[45px\\] {
    right: 45px
}
.right-\\[50px\\] {
    right: 50px
}
.right-\\[5px\\] {
    right: 5px
}
.right-\\[64px\\] {
    right: 64px
}
.right-\\[7\\%\\] {
    right: 7%
}
.right-\\[7px\\] {
    right: 7px
}
.right-\\[90px\\] {
    right: 90px
}
.right-\\[calc\\(50\\%-650px\\)\\] {
    right: calc(50% - 650px)
}
.right-auto {
    right: auto
}
.right-full {
    right: 100%
}
.top-0 {
    top: 0px
}
.top-1\\/2 {
    top: 50%
}
.top-1\\/4 {
    top: 25%
}
.top-\\[-1px\\] {
    top: -1px
}
.top-\\[-20px\\] {
    top: -20px
}
.top-\\[-25px\\] {
    top: -25px
}
.top-\\[-30px\\] {
    top: -30px
}
.top-\\[-3px\\] {
    top: -3px
}
.top-\\[-5px\\] {
    top: -5px
}
.top-\\[-70px\\] {
    top: -70px
}
.top-\\[-80px\\] {
    top: -80px
}
.top-\\[0\\] {
    top: 0
}
.top-\\[0px\\] {
    top: 0px
}
.top-\\[100px\\] {
    top: 100px
}
.top-\\[115\\%\\] {
    top: 115%
}
.top-\\[12px\\] {
    top: 12px
}
.top-\\[130px\\] {
    top: 130px
}
.top-\\[1px\\] {
    top: 1px
}
.top-\\[20px\\] {
    top: 20px
}
.top-\\[23px\\] {
    top: 23px
}
.top-\\[25px\\] {
    top: 25px
}
.top-\\[30px\\] {
    top: 30px
}
.top-\\[35px\\] {
    top: 35px
}
.top-\\[38\\%\\] {
    top: 38%
}
.top-\\[3px\\] {
    top: 3px
}
.top-\\[40px\\] {
    top: 40px
}
.top-\\[47\\%\\] {
    top: 47%
}
.top-\\[48\\%\\] {
    top: 48%
}
.top-\\[50px\\] {
    top: 50px
}
.top-\\[5px\\] {
    top: 5px
}
.top-\\[60px\\] {
    top: 60px
}
.top-\\[70px\\] {
    top: 70px
}
.top-\\[8\\%\\] {
    top: 8%
}
.top-\\[calc\\(25\\%\\+100px\\)\\] {
    top: calc(25% + 100px)
}
.top-\\[calc\\(50\\%-25px\\)\\] {
    top: calc(50% - 25px)
}
.top-\\[var\\(--header-height\\)\\] {
    top: var(--header-height)
}
.top-auto {
    top: auto
}
.\\!z-\\[1\\] {
    z-index: 1 !important
}
.-z-10 {
    z-index: -10
}
.-z-\\[1\\] {
    z-index: -1
}
.z-0 {
    z-index: 0
}
.z-10 {
    z-index: 10
}
.z-20 {
    z-index: 20
}
.z-\\[-2\\] {
    z-index: -2
}
.z-\\[-3\\] {
    z-index: -3
}
.z-\\[100\\] {
    z-index: 100
}
.z-\\[11\\] {
    z-index: 11
}
.z-\\[15\\] {
    z-index: 15
}
.z-\\[16\\] {
    z-index: 16
}
.z-\\[1\\] {
    z-index: 1
}
.z-\\[20\\] {
    z-index: 20
}
.z-\\[2\\] {
    z-index: 2
}
.z-\\[3\\] {
    z-index: 3
}
.z-\\[5\\] {
    z-index: 5
}
.z-\\[999\\] {
    z-index: 999
}
.order-1 {
    order: 1
}
.order-2 {
    order: 2
}
.order-3 {
    order: 3
}
.order-4 {
    order: 4
}
.order-5 {
    order: 5
}
.order-first {
    order: -9999
}
.order-last {
    order: 9999
}
.col-auto {
    grid-column: auto
}
.float-left {
    float: left
}
.m-0 {
    margin: 0px
}
.m-\\[10px\\] {
    margin: 10px
}
.m-\\[5px\\] {
    margin: 5px
}
.m-auto {
    margin: auto
}
.\\!-mx-\\[15px\\] {
    margin-left: -15px !important;
    margin-right: -15px !important
}
.\\!mx-\\[-15px\\] {
    margin-left: -15px !important;
    margin-right: -15px !important
}
.mx-0 {
    margin-left: 0px;
    margin-right: 0px
}
.mx-3 {
    margin-left: 0.75rem;
    margin-right: 0.75rem
}
.mx-\\[-5px\\] {
    margin-left: -5px;
    margin-right: -5px
}
.mx-\\[10px\\] {
    margin-left: 10px;
    margin-right: 10px
}
.mx-\\[15px\\] {
    margin-left: 15px;
    margin-right: 15px
}
.mx-\\[20px\\] {
    margin-left: 20px;
    margin-right: 20px
}
.mx-\\[3px\\] {
    margin-left: 3px;
    margin-right: 3px
}
.mx-\\[4\\%\\] {
    margin-left: 4%;
    margin-right: 4%
}
.mx-\\[40px\\] {
    margin-left: 40px;
    margin-right: 40px
}
.mx-\\[5px\\] {
    margin-left: 5px;
    margin-right: 5px
}
.mx-\\[7\\%\\] {
    margin-left: 7%;
    margin-right: 7%
}
.mx-\\[80px\\] {
    margin-left: 80px;
    margin-right: 80px
}
.mx-auto {
    margin-left: auto;
    margin-right: auto
}
.my-0 {
    margin-top: 0px;
    margin-bottom: 0px
}
.my-10 {
    margin-top: 2.5rem;
    margin-bottom: 2.5rem
}
.my-12 {
    margin-top: 3rem;
    margin-bottom: 3rem
}
.my-14 {
    margin-top: 3.5rem;
    margin-bottom: 3.5rem
}
.my-20 {
    margin-top: 5rem;
    margin-bottom: 5rem
}
.my-8 {
    margin-top: 2rem;
    margin-bottom: 2rem
}
.my-\\[10\\.5rem\\] {
    margin-top: 10.5rem;
    margin-bottom: 10.5rem
}
.my-\\[15px\\] {
    margin-top: 15px;
    margin-bottom: 15px
}
.my-\\[20px\\] {
    margin-top: 20px;
    margin-bottom: 20px
}
.my-\\[25px\\] {
    margin-top: 25px;
    margin-bottom: 25px
}
.my-\\[30px\\] {
    margin-top: 30px;
    margin-bottom: 30px
}
.my-\\[4\\.5rem\\] {
    margin-top: 4.5rem;
    margin-bottom: 4.5rem
}
.my-\\[40px\\] {
    margin-top: 40px;
    margin-bottom: 40px
}
.my-\\[4rem\\] {
    margin-top: 4rem;
    margin-bottom: 4rem
}
.my-\\[5\\.5rem\\] {
    margin-top: 5.5rem;
    margin-bottom: 5.5rem
}
.my-\\[6\\.5rem\\] {
    margin-top: 6.5rem;
    margin-bottom: 6.5rem
}
.my-\\[60px\\] {
    margin-top: 60px;
    margin-bottom: 60px
}
.my-auto {
    margin-top: auto;
    margin-bottom: auto
}
.\\!mb-\\[20px\\] {
    margin-bottom: 20px !important
}
.\\!ml-\\[13px\\] {
    margin-left: 13px !important
}
.\\!ml-\\[4px\\] {
    margin-left: 4px !important
}
.\\!ml-\\[5px\\] {
    margin-left: 5px !important
}
.\\!ml-\\[8px\\] {
    margin-left: 8px !important
}
.\\!mr-\\[8px\\] {
    margin-right: 8px !important
}
.-mb-\\[30px\\] {
    margin-bottom: -30px
}
.-ml-\\[12vw\\] {
    margin-left: -12vw
}
.-ml-\\[30vw\\] {
    margin-left: -30vw
}
.-ml-\\[40vw\\] {
    margin-left: -40vw
}
.-mr-8 {
    margin-right: -2rem
}
.-mr-\\[15px\\] {
    margin-right: -15px
}
.-mr-\\[25px\\] {
    margin-right: -25px
}
.-mr-\\[30vw\\] {
    margin-right: -30vw
}
.-mr-\\[35px\\] {
    margin-right: -35px
}
.-mr-\\[50vw\\] {
    margin-right: -50vw
}
.-mt-20 {
    margin-top: -5rem
}
.mb-0 {
    margin-bottom: 0px
}
.mb-10 {
    margin-bottom: 2.5rem
}
.mb-12 {
    margin-bottom: 3rem
}
.mb-14 {
    margin-bottom: 3.5rem
}
.mb-16 {
    margin-bottom: 4rem
}
.mb-20 {
    margin-bottom: 5rem
}
.mb-24 {
    margin-bottom: 6rem
}
.mb-28 {
    margin-bottom: 7rem
}
.mb-32 {
    margin-bottom: 8rem
}
.mb-36 {
    margin-bottom: 9rem
}
.mb-4 {
    margin-bottom: 1rem
}
.mb-40 {
    margin-bottom: 10rem
}
.mb-6 {
    margin-bottom: 1.5rem
}
.mb-7 {
    margin-bottom: 1.75rem
}
.mb-8 {
    margin-bottom: 2rem
}
.mb-\\[-14vw\\] {
    margin-bottom: -14vw
}
.mb-\\[-15px\\] {
    margin-bottom: -15px
}
.mb-\\[-220px\\] {
    margin-bottom: -220px
}
.mb-\\[-60px\\] {
    margin-bottom: -60px
}
.mb-\\[0\\] {
    margin-bottom: 0
}
.mb-\\[0px\\] {
    margin-bottom: 0px
}
.mb-\\[1\\%\\] {
    margin-bottom: 1%
}
.mb-\\[100px\\] {
    margin-bottom: 100px
}
.mb-\\[105px\\] {
    margin-bottom: 105px
}
.mb-\\[107px\\] {
    margin-bottom: 107px
}
.mb-\\[108px\\] {
    margin-bottom: 108px
}
.mb-\\[10px\\] {
    margin-bottom: 10px
}
.mb-\\[12\\%\\] {
    margin-bottom: 12%
}
.mb-\\[12px\\] {
    margin-bottom: 12px
}
.mb-\\[130px\\] {
    margin-bottom: 130px
}
.mb-\\[150px\\] {
    margin-bottom: 150px
}
.mb-\\[15px\\] {
    margin-bottom: 15px
}
.mb-\\[165px\\] {
    margin-bottom: 165px
}
.mb-\\[188px\\] {
    margin-bottom: 188px
}
.mb-\\[2\\.5rem\\] {
    margin-bottom: 2.5rem
}
.mb-\\[200px\\] {
    margin-bottom: 200px
}
.mb-\\[20px\\] {
    margin-bottom: 20px
}
.mb-\\[22px\\] {
    margin-bottom: 22px
}
.mb-\\[24px\\] {
    margin-bottom: 24px
}
.mb-\\[25px\\] {
    margin-bottom: 25px
}
.mb-\\[26px\\] {
    margin-bottom: 26px
}
.mb-\\[28px\\] {
    margin-bottom: 28px
}
.mb-\\[2px\\] {
    margin-bottom: 2px
}
.mb-\\[3\\.5rem\\] {
    margin-bottom: 3.5rem
}
.mb-\\[30px\\] {
    margin-bottom: 30px
}
.mb-\\[32px\\] {
    margin-bottom: 32px
}
.mb-\\[35\\%\\] {
    margin-bottom: 35%
}
.mb-\\[35px\\] {
    margin-bottom: 35px
}
.mb-\\[4\\%\\] {
    margin-bottom: 4%
}
.mb-\\[4\\.5rem\\] {
    margin-bottom: 4.5rem
}
.mb-\\[40px\\] {
    margin-bottom: 40px
}
.mb-\\[42px\\] {
    margin-bottom: 42px
}
.mb-\\[45px\\] {
    margin-bottom: 45px
}
.mb-\\[46px\\] {
    margin-bottom: 46px
}
.mb-\\[47px\\] {
    margin-bottom: 47px
}
.mb-\\[49px\\] {
    margin-bottom: 49px
}
.mb-\\[5\\%\\] {
    margin-bottom: 5%
}
.mb-\\[5\\.5rem\\] {
    margin-bottom: 5.5rem
}
.mb-\\[50px\\] {
    margin-bottom: 50px
}
.mb-\\[55px\\] {
    margin-bottom: 55px
}
.mb-\\[56px\\] {
    margin-bottom: 56px
}
.mb-\\[5px\\] {
    margin-bottom: 5px
}
.mb-\\[6\\%\\] {
    margin-bottom: 6%
}
.mb-\\[6\\.5rem\\] {
    margin-bottom: 6.5rem
}
.mb-\\[60px\\] {
    margin-bottom: 60px
}
.mb-\\[65px\\] {
    margin-bottom: 65px
}
.mb-\\[7\\%\\] {
    margin-bottom: 7%
}
.mb-\\[7\\.4rem\\] {
    margin-bottom: 7.4rem
}
.mb-\\[7\\.5rem\\] {
    margin-bottom: 7.5rem
}
.mb-\\[70px\\] {
    margin-bottom: 70px
}
.mb-\\[72px\\] {
    margin-bottom: 72px
}
.mb-\\[74px\\] {
    margin-bottom: 74px
}
.mb-\\[75px\\] {
    margin-bottom: 75px
}
.mb-\\[77px\\] {
    margin-bottom: 77px
}
.mb-\\[78px\\] {
    margin-bottom: 78px
}
.mb-\\[7px\\] {
    margin-bottom: 7px
}
.mb-\\[8\\%\\] {
    margin-bottom: 8%
}
.mb-\\[80px\\] {
    margin-bottom: 80px
}
.mb-\\[82px\\] {
    margin-bottom: 82px
}
.mb-\\[83px\\] {
    margin-bottom: 83px
}
.mb-\\[84px\\] {
    margin-bottom: 84px
}
.mb-\\[85px\\] {
    margin-bottom: 85px
}
.mb-\\[8px\\] {
    margin-bottom: 8px
}
.mb-\\[9\\%\\] {
    margin-bottom: 9%
}
.mb-\\[9\\.5rem\\] {
    margin-bottom: 9.5rem
}
.mb-\\[90px\\] {
    margin-bottom: 90px
}
.mb-\\[91px\\] {
    margin-bottom: 91px
}
.mb-\\[94px\\] {
    margin-bottom: 94px
}
.mb-\\[95px\\] {
    margin-bottom: 95px
}
.mb-\\[98px\\] {
    margin-bottom: 98px
}
.mb-\\[9px\\] {
    margin-bottom: 9px
}
.me-auto {
    margin-inline-end: auto
}
.ml-0 {
    margin-left: 0px
}
.ml-24 {
    margin-left: 6rem
}
.ml-3 {
    margin-left: 0.75rem
}
.ml-32 {
    margin-left: 8rem
}
.ml-4 {
    margin-left: 1rem
}
.ml-\\[10px\\] {
    margin-left: 10px
}
.ml-\\[13px\\] {
    margin-left: 13px
}
.ml-\\[15px\\] {
    margin-left: 15px
}
.ml-\\[17px\\] {
    margin-left: 17px
}
.ml-\\[20px\\] {
    margin-left: 20px
}
.ml-\\[22px\\] {
    margin-left: 22px
}
.ml-\\[23px\\] {
    margin-left: 23px
}
.ml-\\[25px\\] {
    margin-left: 25px
}
.ml-\\[30px\\] {
    margin-left: 30px
}
.ml-\\[35px\\] {
    margin-left: 35px
}
.ml-\\[4px\\] {
    margin-left: 4px
}
.ml-\\[5px\\] {
    margin-left: 5px
}
.ml-\\[6px\\] {
    margin-left: 6px
}
.ml-\\[70px\\] {
    margin-left: 70px
}
.ml-\\[97px\\] {
    margin-left: 97px
}
.ml-auto {
    margin-left: auto
}
.mr-0 {
    margin-right: 0px
}
.mr-2 {
    margin-right: 0.5rem
}
.mr-36 {
    margin-right: 9rem
}
.mr-5 {
    margin-right: 1.25rem
}
.mr-6 {
    margin-right: 1.5rem
}
.mr-8 {
    margin-right: 2rem
}
.mr-\\[-2px\\] {
    margin-right: -2px
}
.mr-\\[-30vw\\] {
    margin-right: -30vw
}
.mr-\\[0px\\] {
    margin-right: 0px
}
.mr-\\[10px\\] {
    margin-right: 10px
}
.mr-\\[14px\\] {
    margin-right: 14px
}
.mr-\\[15px\\] {
    margin-right: 15px
}
.mr-\\[16px\\] {
    margin-right: 16px
}
.mr-\\[18px\\] {
    margin-right: 18px
}
.mr-\\[19px\\] {
    margin-right: 19px
}
.mr-\\[20px\\] {
    margin-right: 20px
}
.mr-\\[24px\\] {
    margin-right: 24px
}
.mr-\\[25px\\] {
    margin-right: 25px
}
.mr-\\[30px\\] {
    margin-right: 30px
}
.mr-\\[35px\\] {
    margin-right: 35px
}
.mr-\\[38px\\] {
    margin-right: 38px
}
.mr-\\[3px\\] {
    margin-right: 3px
}
.mr-\\[42px\\] {
    margin-right: 42px
}
.mr-\\[4px\\] {
    margin-right: 4px
}
.mr-\\[50px\\] {
    margin-right: 50px
}
.mr-\\[55px\\] {
    margin-right: 55px
}
.mr-\\[5px\\] {
    margin-right: 5px
}
.mr-\\[60px\\] {
    margin-right: 60px
}
.mr-\\[6px\\] {
    margin-right: 6px
}
.mr-\\[7px\\] {
    margin-right: 7px
}
.mr-\\[8px\\] {
    margin-right: 8px
}
.mr-auto {
    margin-right: auto
}
.ms-0 {
    margin-inline-start: 0px
}
.ms-1 {
    margin-inline-start: 0.25rem
}
.ms-auto {
    margin-inline-start: auto
}
.mt-0 {
    margin-top: 0px
}
.mt-10 {
    margin-top: 2.5rem
}
.mt-12 {
    margin-top: 3rem
}
.mt-14 {
    margin-top: 3.5rem
}
.mt-16 {
    margin-top: 4rem
}
.mt-20 {
    margin-top: 5rem
}
.mt-24 {
    margin-top: 6rem
}
.mt-28 {
    margin-top: 7rem
}
.mt-32 {
    margin-top: 8rem
}
.mt-36 {
    margin-top: 9rem
}
.mt-40 {
    margin-top: 10rem
}
.mt-5 {
    margin-top: 1.25rem
}
.mt-6 {
    margin-top: 1.5rem
}
.mt-8 {
    margin-top: 2rem
}
.mt-\\[-100px\\] {
    margin-top: -100px
}
.mt-\\[10\\.5rem\\] {
    margin-top: 10.5rem
}
.mt-\\[108px\\] {
    margin-top: 108px
}
.mt-\\[10px\\] {
    margin-top: 10px
}
.mt-\\[110px\\] {
    margin-top: 110px
}
.mt-\\[118px\\] {
    margin-top: 118px
}
.mt-\\[15px\\] {
    margin-top: 15px
}
.mt-\\[1px\\] {
    margin-top: 1px
}
.mt-\\[2\\.5rem\\] {
    margin-top: 2.5rem
}
.mt-\\[20\\%\\] {
    margin-top: 20%
}
.mt-\\[200px\\] {
    margin-top: 200px
}
.mt-\\[20px\\] {
    margin-top: 20px
}
.mt-\\[25px\\] {
    margin-top: 25px
}
.mt-\\[3\\.5px\\] {
    margin-top: 3.5px
}
.mt-\\[3\\.5rem\\] {
    margin-top: 3.5rem
}
.mt-\\[30px\\] {
    margin-top: 30px
}
.mt-\\[35px\\] {
    margin-top: 35px
}
.mt-\\[38px\\] {
    margin-top: 38px
}
.mt-\\[4\\.5rem\\] {
    margin-top: 4.5rem
}
.mt-\\[40px\\] {
    margin-top: 40px
}
.mt-\\[45px\\] {
    margin-top: 45px
}
.mt-\\[4px\\] {
    margin-top: 4px
}
.mt-\\[5\\.5rem\\] {
    margin-top: 5.5rem
}
.mt-\\[50px\\] {
    margin-top: 50px
}
.mt-\\[56px\\] {
    margin-top: 56px
}
.mt-\\[5px\\] {
    margin-top: 5px
}
.mt-\\[6\\.5rem\\] {
    margin-top: 6.5rem
}
.mt-\\[60px\\] {
    margin-top: 60px
}
.mt-\\[7\\%\\] {
    margin-top: 7%
}
.mt-\\[7\\.4rem\\] {
    margin-top: 7.4rem
}
.mt-\\[7\\.5rem\\] {
    margin-top: 7.5rem
}
.mt-\\[70px\\] {
    margin-top: 70px
}
.mt-\\[75px\\] {
    margin-top: 75px
}
.mt-\\[7px\\] {
    margin-top: 7px
}
.mt-\\[8\\.5rem\\] {
    margin-top: 8.5rem
}
.mt-\\[80px\\] {
    margin-top: 80px
}
.mt-\\[82px\\] {
    margin-top: 82px
}
.mt-\\[8px\\] {
    margin-top: 8px
}
.mt-\\[9\\.5rem\\] {
    margin-top: 9.5rem
}
.mt-\\[90px\\] {
    margin-top: 90px
}
.mt-auto {
    margin-top: auto
}
.block {
    display: block
}
.inline-block {
    display: inline-block
}
.inline {
    display: inline
}
.flex {
    display: flex
}
.inline-flex {
    display: inline-flex
}
.table {
    display: table
}
.table-cell {
    display: table-cell
}
.grid {
    display: grid
}
.contents {
    display: contents
}
.hidden {
    display: none
}
.\\!h-\\[120px\\] {
    height: 120px !important
}
.h-1\\/2 {
    height: 50%
}
.h-\\[1000px\\] {
    height: 1000px
}
.h-\\[100px\\] {
    height: 100px
}
.h-\\[100vh\\] {
    height: 100vh
}
.h-\\[10px\\] {
    height: 10px
}
.h-\\[110px\\] {
    height: 110px
}
.h-\\[1200px\\] {
    height: 1200px
}
.h-\\[120px\\] {
    height: 120px
}
.h-\\[120vh\\] {
    height: 120vh
}
.h-\\[130px\\] {
    height: 130px
}
.h-\\[130vh\\] {
    height: 130vh
}
.h-\\[140px\\] {
    height: 140px
}
.h-\\[150px\\] {
    height: 150px
}
.h-\\[15px\\] {
    height: 15px
}
.h-\\[16px\\] {
    height: 16px
}
.h-\\[170px\\] {
    height: 170px
}
.h-\\[180px\\] {
    height: 180px
}
.h-\\[1px\\] {
    height: 1px
}
.h-\\[206px\\] {
    height: 206px
}
.h-\\[210px\\] {
    height: 210px
}
.h-\\[221px\\] {
    height: 221px
}
.h-\\[230px\\] {
    height: 230px
}
.h-\\[2px\\] {
    height: 2px
}
.h-\\[3\\.4rem\\] {
    height: 3.4rem
}
.h-\\[300px\\] {
    height: 300px
}
.h-\\[35px\\] {
    height: 35px
}
.h-\\[380px\\] {
    height: 380px
}
.h-\\[3px\\] {
    height: 3px
}
.h-\\[400px\\] {
    height: 400px
}
.h-\\[40px\\] {
    height: 40px
}
.h-\\[44px\\] {
    height: 44px
}
.h-\\[450px\\] {
    height: 450px
}
.h-\\[45px\\] {
    height: 45px
}
.h-\\[490px\\] {
    height: 490px
}
.h-\\[500px\\] {
    height: 500px
}
.h-\\[50px\\] {
    height: 50px
}
.h-\\[550px\\] {
    height: 550px
}
.h-\\[560px\\] {
    height: 560px
}
.h-\\[5px\\] {
    height: 5px
}
.h-\\[600px\\] {
    height: 600px
}
.h-\\[607px\\] {
    height: 607px
}
.h-\\[60px\\] {
    height: 60px
}
.h-\\[62px\\] {
    height: 62px
}
.h-\\[650px\\] {
    height: 650px
}
.h-\\[65px\\] {
    height: 65px
}
.h-\\[660px\\] {
    height: 660px
}
.h-\\[6px\\] {
    height: 6px
}
.h-\\[700px\\] {
    height: 700px
}
.h-\\[720px\\] {
    height: 720px
}
.h-\\[730px\\] {
    height: 730px
}
.h-\\[750px\\] {
    height: 750px
}
.h-\\[75px\\] {
    height: 75px
}
.h-\\[75vh\\] {
    height: 75vh
}
.h-\\[760px\\] {
    height: 760px
}
.h-\\[800px\\] {
    height: 800px
}
.h-\\[80px\\] {
    height: 80px
}
.h-\\[85px\\] {
    height: 85px
}
.h-\\[85vh\\] {
    height: 85vh
}
.h-\\[870px\\] {
    height: 870px
}
.h-\\[900px\\] {
    height: 900px
}
.h-\\[90px\\] {
    height: 90px
}
.h-\\[940px\\] {
    height: 940px
}
.h-\\[calc\\(100vh-150px\\)\\] {
    height: calc(100vh - 150px)
}
.h-\\[calc\\(100vh-var\\(--header-height\\)\\)\\] {
    height: calc(100vh - var(--header-height))
}
.h-auto {
    height: auto
}
.h-full {
    height: 100%
}
.h-px {
    height: 1px
}
.max-h-\\[36px\\] {
    max-height: 36px
}
.max-h-\\[calc\\(100\\%-160px\\)\\] {
    max-height: calc(100% - 160px)
}
.max-h-\\[calc\\(65vh-100px\\)\\] {
    max-height: calc(65vh - 100px)
}
.max-h-min {
    max-height: min-content
}
.min-h-\\[-webkit-fill-available\\] {
    min-height: -webkit-fill-available
}
.min-h-\\[15px\\] {
    min-height: 15px
}
.min-h-\\[75px\\] {
    min-height: 75px
}
.min-h-full {
    min-height: 100%
}
.\\!w-\\[120px\\] {
    width: 120px !important
}
.\\!w-\\[290px\\] {
    width: 290px !important
}
.w-1\\/2 {
    width: 50%
}
.w-11\\/12 {
    width: 91.666667%
}
.w-2\\/5 {
    width: 40%
}
.w-20 {
    width: 5rem
}
.w-3\\/4 {
    width: 75%
}
.w-3\\/5 {
    width: 60%
}
.w-4\\/5 {
    width: 80%
}
.w-\\[10\\%\\] {
    width: 10%
}
.w-\\[1000px\\] {
    width: 1000px
}
.w-\\[100px\\] {
    width: 100px
}
.w-\\[100vw\\] {
    width: 100vw
}
.w-\\[1020px\\] {
    width: 1020px
}
.w-\\[10px\\] {
    width: 10px
}
.w-\\[110px\\] {
    width: 110px
}
.w-\\[120px\\] {
    width: 120px
}
.w-\\[128px\\] {
    width: 128px
}
.w-\\[130px\\] {
    width: 130px
}
.w-\\[140px\\] {
    width: 140px
}
.w-\\[142px\\] {
    width: 142px
}
.w-\\[144px\\] {
    width: 144px
}
.w-\\[15\\%\\] {
    width: 15%
}
.w-\\[150px\\] {
    width: 150px
}
.w-\\[15px\\] {
    width: 15px
}
.w-\\[16px\\] {
    width: 16px
}
.w-\\[170px\\] {
    width: 170px
}
.w-\\[180px\\] {
    width: 180px
}
.w-\\[1px\\] {
    width: 1px
}
.w-\\[20px\\] {
    width: 20px
}
.w-\\[25\\%\\] {
    width: 25%
}
.w-\\[25px\\] {
    width: 25px
}
.w-\\[260px\\] {
    width: 260px
}
.w-\\[290px\\] {
    width: 290px
}
.w-\\[2px\\] {
    width: 2px
}
.w-\\[30\\%\\] {
    width: 30%
}
.w-\\[300px\\] {
    width: 300px
}
.w-\\[30px\\] {
    width: 30px
}
.w-\\[332px\\] {
    width: 332px
}
.w-\\[35\\%\\] {
    width: 35%
}
.w-\\[35px\\] {
    width: 35px
}
.w-\\[380px\\] {
    width: 380px
}
.w-\\[40\\%\\] {
    width: 40%
}
.w-\\[40px\\] {
    width: 40px
}
.w-\\[410px\\] {
    width: 410px
}
.w-\\[44px\\] {
    width: 44px
}
.w-\\[45\\%\\] {
    width: 45%
}
.w-\\[450px\\] {
    width: 450px
}
.w-\\[45px\\] {
    width: 45px
}
.w-\\[50\\%\\] {
    width: 50%
}
.w-\\[500px\\] {
    width: 500px
}
.w-\\[50px\\] {
    width: 50px
}
.w-\\[50vw\\] {
    width: 50vw
}
.w-\\[51\\%\\] {
    width: 51%
}
.w-\\[545px\\] {
    width: 545px
}
.w-\\[55\\%\\] {
    width: 55%
}
.w-\\[565px\\] {
    width: 565px
}
.w-\\[60\\%\\] {
    width: 60%
}
.w-\\[600px\\] {
    width: 600px
}
.w-\\[60px\\] {
    width: 60px
}
.w-\\[62px\\] {
    width: 62px
}
.w-\\[63\\%\\] {
    width: 63%
}
.w-\\[640px\\] {
    width: 640px
}
.w-\\[65\\%\\] {
    width: 65%
}
.w-\\[65px\\] {
    width: 65px
}
.w-\\[67px\\] {
    width: 67px
}
.w-\\[70\\%\\] {
    width: 70%
}
.w-\\[70px\\] {
    width: 70px
}
.w-\\[73\\%\\] {
    width: 73%
}
.w-\\[740px\\] {
    width: 740px
}
.w-\\[75\\%\\] {
    width: 75%
}
.w-\\[750px\\] {
    width: 750px
}
.w-\\[75px\\] {
    width: 75px
}
.w-\\[76\\%\\] {
    width: 76%
}
.w-\\[760px\\] {
    width: 760px
}
.w-\\[80\\%\\] {
    width: 80%
}
.w-\\[800px\\] {
    width: 800px
}
.w-\\[80px\\] {
    width: 80px
}
.w-\\[84\\%\\] {
    width: 84%
}
.w-\\[85\\%\\] {
    width: 85%
}
.w-\\[85px\\] {
    width: 85px
}
.w-\\[86\\%\\] {
    width: 86%
}
.w-\\[870px\\] {
    width: 870px
}
.w-\\[89\\%\\] {
    width: 89%
}
.w-\\[90\\%\\] {
    width: 90%
}
.w-\\[90px\\] {
    width: 90px
}
.w-\\[92\\%\\] {
    width: 92%
}
.w-\\[93\\%\\] {
    width: 93%
}
.w-\\[940px\\] {
    width: 940px
}
.w-\\[95\\%\\] {
    width: 95%
}
.w-\\[99\\%\\] {
    width: 99%
}
.w-\\[auto\\] {
    width: auto
}
.w-\\[calc\\(100\\%-50px\\)\\] {
    width: calc(100% - 50px)
}
.w-auto {
    width: auto
}
.w-full {
    width: 100%
}
.w-max {
    width: max-content
}
.min-w-\\[1170px\\] {
    min-width: 1170px
}
.min-w-\\[140px\\] {
    min-width: 140px
}
.min-w-\\[1500px\\] {
    min-width: 1500px
}
.min-w-full {
    min-width: 100%
}
.max-w-\\[200px\\] {
    max-width: 200px
}
.max-w-\\[210px\\] {
    max-width: 210px
}
.max-w-\\[300px\\] {
    max-width: 300px
}
.max-w-\\[530px\\] {
    max-width: 530px
}
.max-w-\\[750px\\] {
    max-width: 750px
}
.max-w-\\[inherit\\] {
    max-width: inherit
}
.max-w-full {
    max-width: 100%
}
.flex-1 {
    flex: 1 1
}
.flex-\\[0_0_auto\\] {
    flex: 0 0 auto
}
.flex-initial {
    flex: 0 1 auto
}
.flex-shrink-0 {
    flex-shrink: 0
}
.shrink-0 {
    flex-shrink: 0
}
.flex-grow {
    flex-grow: 1
}
.grow {
    flex-grow: 1
}
.grow-0 {
    flex-grow: 0
}
.grow-\\[1\\] {
    flex-grow: 1
}
.basis-auto {
    flex-basis: auto
}
.origin-\\[0\\] {
    transform-origin: 0
}
.-translate-x-1\\/2 {
    --tw-translate-x: -50%;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))
}
.-translate-y-1\\/2 {
    --tw-translate-y: -50%;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))
}
.translate-y-2\\/4 {
    --tw-translate-y: 50%;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))
}
.-rotate-90 {
    --tw-rotate: -90deg;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))
}
.rotate-90 {
    --tw-rotate: 90deg;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))
}
.rotate-\\[30px\\] {
    --tw-rotate: 30px;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))
}
.transform {
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))
}
.cursor-ew-resize {
    cursor: ew-resize
}
.cursor-pointer {
    cursor: pointer
}
.resize-none {
    resize: none
}
.resize {
    resize: both
}
.list-none {
    list-style-type: none
}
.grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr))
}
.grid-rows-3 {
    grid-template-rows: repeat(3, minmax(0, 1fr))
}
.flex-row {
    flex-direction: row
}
.flex-col {
    flex-direction: column
}
.flex-wrap {
    flex-wrap: wrap
}
.\\!items-start {
    align-items: flex-start !important
}
.items-start {
    align-items: flex-start
}
.items-end {
    align-items: flex-end
}
.items-center {
    align-items: center
}
.items-stretch {
    align-items: stretch
}
.justify-start {
    justify-content: flex-start
}
.justify-end {
    justify-content: flex-end
}
.justify-center {
    justify-content: center
}
.justify-between {
    justify-content: space-between
}
.justify-around {
    justify-content: space-around
}
.gap-5 {
    gap: 1.25rem
}
.gap-x-\\[15px\\] {
    column-gap: 15px
}
.gap-x-\\[35px\\] {
    column-gap: 35px
}
.gap-y-1 {
    row-gap: 0.25rem
}
.gap-y-10 {
    row-gap: 2.5rem
}
.gap-y-16 {
    row-gap: 4rem
}
.gap-y-20 {
    row-gap: 5rem
}
.gap-y-24 {
    row-gap: 6rem
}
.gap-y-5 {
    row-gap: 1.25rem
}
.gap-y-\\[10px\\] {
    row-gap: 10px
}
.gap-y-\\[15px\\] {
    row-gap: 15px
}
.gap-y-\\[2\\.2rem\\] {
    row-gap: 2.2rem
}
.gap-y-\\[25px\\] {
    row-gap: 25px
}
.gap-y-\\[30px\\] {
    row-gap: 30px
}
.gap-y-\\[4\\.5rem\\] {
    row-gap: 4.5rem
}
.gap-y-\\[40px\\] {
    row-gap: 40px
}
.gap-y-\\[5\\.5rem\\] {
    row-gap: 5.5rem
}
.gap-y-\\[50px\\] {
    row-gap: 50px
}
.gap-y-\\[5rem\\] {
    row-gap: 5rem
}
.gap-y-\\[60px\\] {
    row-gap: 60px
}
.gap-y-\\[7px\\] {
    row-gap: 7px
}
.divide-x > :not([hidden]) ~ :not([hidden]) {
    --tw-divide-x-reverse: 0;
    border-right-width: calc(1px * var(--tw-divide-x-reverse));
    border-left-width: calc(1px * calc(1 - var(--tw-divide-x-reverse)))
}
.divide-y > :not([hidden]) ~ :not([hidden]) {
    --tw-divide-y-reverse: 0;
    border-top-width: calc(1px * calc(1 - var(--tw-divide-y-reverse)));
    border-bottom-width: calc(1px * var(--tw-divide-y-reverse))
}
.divide-\\[\\#ffffff33\\] > :not([hidden]) ~ :not([hidden]) {
    border-color: #ffffff33
}
.divide-darkgray\\/20 > :not([hidden]) ~ :not([hidden]) {
    border-color: rgb(35 35 35 / 0.2)
}
.self-start {
    align-self: flex-start
}
.self-end {
    align-self: flex-end
}
.self-center {
    align-self: center
}
.overflow-hidden {
    overflow: hidden
}
.overflow-visible {
    overflow: visible
}
.overflow-y-hidden {
    overflow-y: hidden
}
.whitespace-nowrap {
    white-space: nowrap
}
.whitespace-pre {
    white-space: pre
}
.break-normal {
    overflow-wrap: normal;
    word-break: normal
}
.rounded {
    border-radius: 0.25rem
}
.rounded-\\[0\\.25rem\\] {
    border-radius: 0.25rem
}
.rounded-\\[100px\\] {
    border-radius: 100px
}
.rounded-\\[10px\\] {
    border-radius: 10px
}
.rounded-\\[1px\\] {
    border-radius: 1px
}
.rounded-\\[2px\\] {
    border-radius: 2px
}
.rounded-\\[3px\\] {
    border-radius: 3px
}
.rounded-\\[4px\\] {
    border-radius: 4px
}
.rounded-\\[50\\%\\] {
    border-radius: 50%
}
.rounded-\\[50px\\] {
    border-radius: 50px
}
.rounded-\\[5px\\] {
    border-radius: 5px
}
.rounded-\\[6px\\] {
    border-radius: 6px
}
.rounded-\\[8px\\] {
    border-radius: 8px
}
.rounded-full {
    border-radius: 9999px
}
.rounded-lg {
    border-radius: 0.5rem
}
.rounded-md {
    border-radius: 0.375rem
}
.rounded-none {
    border-radius: 0px
}
.rounded-sm {
    border-radius: 0.125rem
}
.rounded-t-md {
    border-top-left-radius: 0.375rem;
    border-top-right-radius: 0.375rem
}
.\\!border-0 {
    border-width: 0px !important
}
.border {
    border-width: 1px
}
.border-0 {
    border-width: 0px
}
.border-2 {
    border-width: 2px
}
.border-8 {
    border-width: 8px
}
.border-\\[0px\\] {
    border-width: 0px
}
.border-\\[10px\\] {
    border-width: 10px
}
.border-\\[12px\\] {
    border-width: 12px
}
.border-\\[1px\\] {
    border-width: 1px
}
.border-\\[2px\\] {
    border-width: 2px
}
.border-\\[3px\\] {
    border-width: 3px
}
.border-\\[8px\\] {
    border-width: 8px
}
.border-y {
    border-top-width: 1px;
    border-bottom-width: 1px
}
.\\!border-b-0 {
    border-bottom-width: 0px !important
}
.\\!border-l-0 {
    border-left-width: 0px !important
}
.\\!border-t-0 {
    border-top-width: 0px !important
}
.border-b {
    border-bottom-width: 1px
}
.border-b-0 {
    border-bottom-width: 0px
}
.border-b-2 {
    border-bottom-width: 2px
}
.border-b-\\[1px\\] {
    border-bottom-width: 1px
}
.border-b-\\[2px\\] {
    border-bottom-width: 2px
}
.border-b-\\[3px\\] {
    border-bottom-width: 3px
}
.border-b-\\[8px\\] {
    border-bottom-width: 8px
}
.border-l {
    border-left-width: 1px
}
.border-l-0 {
    border-left-width: 0px
}
.border-l-\\[2px\\] {
    border-left-width: 2px
}
.border-l-\\[4px\\] {
    border-left-width: 4px
}
.border-l-\\[5px\\] {
    border-left-width: 5px
}
.border-r {
    border-right-width: 1px
}
.border-r-0 {
    border-right-width: 0px
}
.border-r-\\[1px\\] {
    border-right-width: 1px
}
.border-t {
    border-top-width: 1px
}
.border-t-0 {
    border-top-width: 0px
}
.border-solid {
    border-style: solid
}
.border-dashed {
    border-style: dashed
}
.border-dotted {
    border-style: dotted
}
.border-hidden {
    border-style: hidden
}
.border-none {
    border-style: none
}
.border-\\[\\#0000001a\\] {
    border-color: #0000001a
}
.border-\\[\\#0D6EFD\\] {
    --tw-border-opacity: 1;
    border-color: rgb(13 110 253 / var(--tw-border-opacity))
}
.border-\\[\\#0ab7da\\] {
    --tw-border-opacity: 1;
    border-color: rgb(10 183 218 / var(--tw-border-opacity))
}
.border-\\[\\#198754\\] {
    --tw-border-opacity: 1;
    border-color: rgb(25 135 84 / var(--tw-border-opacity))
}
.border-\\[\\#828282\\] {
    --tw-border-opacity: 1;
    border-color: rgb(130 130 130 / var(--tw-border-opacity))
}
.border-\\[\\#8bb867\\] {
    --tw-border-opacity: 1;
    border-color: rgb(139 184 103 / var(--tw-border-opacity))
}
.border-\\[\\#DC3545\\] {
    --tw-border-opacity: 1;
    border-color: rgb(220 53 69 / var(--tw-border-opacity))
}
.border-\\[\\#b93c90\\] {
    --tw-border-opacity: 1;
    border-color: rgb(185 60 144 / var(--tw-border-opacity))
}
.border-\\[\\#ca943d66\\] {
    border-color: #ca943d66
}
.border-\\[\\#cc754c4d\\] {
    border-color: #cc754c4d
}
.border-\\[\\#d9d9d9\\] {
    --tw-border-opacity: 1;
    border-color: rgb(217 217 217 / var(--tw-border-opacity))
}
.border-\\[\\#dbdbdb\\] {
    --tw-border-opacity: 1;
    border-color: rgb(219 219 219 / var(--tw-border-opacity))
}
.border-\\[\\#dee2e6\\] {
    --tw-border-opacity: 1;
    border-color: rgb(222 226 230 / var(--tw-border-opacity))
}
.border-\\[\\#dfab11\\] {
    --tw-border-opacity: 1;
    border-color: rgb(223 171 17 / var(--tw-border-opacity))
}
.border-\\[\\#dfdfdf\\] {
    --tw-border-opacity: 1;
    border-color: rgb(223 223 223 / var(--tw-border-opacity))
}
.border-\\[\\#e8e8e8\\] {
    --tw-border-opacity: 1;
    border-color: rgb(232 232 232 / var(--tw-border-opacity))
}
.border-\\[\\#ededed\\] {
    --tw-border-opacity: 1;
    border-color: rgb(237 237 237 / var(--tw-border-opacity))
}
.border-\\[\\#f3f3f3\\] {
    --tw-border-opacity: 1;
    border-color: rgb(243 243 243 / var(--tw-border-opacity))
}
.border-\\[\\#f4f4f4\\] {
    --tw-border-opacity: 1;
    border-color: rgb(244 244 244 / var(--tw-border-opacity))
}
.border-\\[\\#f5f5f5\\] {
    --tw-border-opacity: 1;
    border-color: rgb(245 245 245 / var(--tw-border-opacity))
}
.border-\\[\\#ffeb04\\] {
    --tw-border-opacity: 1;
    border-color: rgb(255 235 4 / var(--tw-border-opacity))
}
.border-\\[\\#fff\\] {
    --tw-border-opacity: 1;
    border-color: rgb(255 255 255 / var(--tw-border-opacity))
}
.border-\\[\\#ffffff1a\\] {
    border-color: #ffffff1a
}
.border-\\[\\#ffffff26\\] {
    border-color: #ffffff26
}
.border-\\[\\#ffffff33\\] {
    border-color: #ffffff33
}
.border-\\[\\#ffffff66\\] {
    border-color: #ffffff66
}
.border-\\[rgba\\(255\\2c 255\\2c 255\\2c \\.1\\)\\] {
    border-color: rgba(255,255,255,.1)
}
.border-\\[rgba\\(255\\2c 255\\2c 255\\2c 0\\.2\\)\\] {
    border-color: rgba(255,255,255,0.2)
}
.border-black {
    --tw-border-opacity: 1;
    border-color: rgb(0 0 0 / var(--tw-border-opacity))
}
.border-darkgray {
    --tw-border-opacity: 1;
    border-color: rgb(35 35 35 / var(--tw-border-opacity))
}
.border-fastblue {
    --tw-border-opacity: 1;
    border-color: rgb(0 56 227 / var(--tw-border-opacity))
}
.border-indigo-50 {
    --tw-border-opacity: 1;
    border-color: rgb(238 242 255 / var(--tw-border-opacity))
}
.border-inherit {
    border-color: inherit
}
.border-lightgray {
    --tw-border-opacity: 1;
    border-color: rgb(247 247 247 / var(--tw-border-opacity))
}
.border-mediumgray {
    --tw-border-opacity: 1;
    border-color: rgb(228 228 228 / var(--tw-border-opacity))
}
.border-neonorange {
    --tw-border-opacity: 1;
    border-color: rgb(255 122 86 / var(--tw-border-opacity))
}
.border-transparent {
    border-color: transparent
}
.border-white {
    --tw-border-opacity: 1;
    border-color: rgb(255 255 255 / var(--tw-border-opacity))
}
.\\!border-b-\\[\\#0000001a\\] {
    border-bottom-color: #0000001a !important
}
.border-b-\\[\\#0000001a\\] {
    border-bottom-color: #0000001a
}
.bg-\\[\\#00000080\\] {
    background-color: #00000080
}
.bg-\\[\\#000000b3\\] {
    background-color: #000000b3
}
.bg-\\[\\#000\\] {
    --tw-bg-opacity: 1;
    background-color: rgb(0 0 0 / var(--tw-bg-opacity))
}
.bg-\\[\\#00b8b8\\] {
    --tw-bg-opacity: 1;
    background-color: rgb(0 184 184 / var(--tw-bg-opacity))
}
.bg-\\[\\#060606\\] {
    --tw-bg-opacity: 1;
    background-color: rgb(6 6 6 / var(--tw-bg-opacity))
}
.bg-\\[\\#0D6EFD\\] {
    --tw-bg-opacity: 1;
    background-color: rgb(13 110 253 / var(--tw-bg-opacity))
}
.bg-\\[\\#0ab7da\\] {
    --tw-bg-opacity: 1;
    background-color: rgb(10 183 218 / var(--tw-bg-opacity))
}
.bg-\\[\\#101010\\] {
    --tw-bg-opacity: 1;
    background-color: rgb(16 16 16 / var(--tw-bg-opacity))
}
.bg-\\[\\#131313\\] {
    --tw-bg-opacity: 1;
    background-color: rgb(19 19 19 / var(--tw-bg-opacity))
}
.bg-\\[\\#141414\\] {
    --tw-bg-opacity: 1;
    background-color: rgb(20 20 20 / var(--tw-bg-opacity))
}
.bg-\\[\\#17171780\\] {
    background-color: #17171780
}
.bg-\\[\\#171717bf\\] {
    background-color: #171717bf
}
.bg-\\[\\#198754\\] {
    --tw-bg-opacity: 1;
    background-color: rgb(25 135 84 / var(--tw-bg-opacity))
}
.bg-\\[\\#1e1e1ecc\\] {
    background-color: #1e1e1ecc
}
.bg-\\[\\#23262d\\] {
    --tw-bg-opacity: 1;
    background-color: rgb(35 38 45 / var(--tw-bg-opacity))
}
.bg-\\[\\#241526e6\\] {
    background-color: #241526e6
}
.bg-\\[\\#262A37\\] {
    --tw-bg-opacity: 1;
    background-color: rgb(38 42 55 / var(--tw-bg-opacity))
}
.bg-\\[\\#262b35\\] {
    --tw-bg-opacity: 1;
    background-color: rgb(38 43 53 / var(--tw-bg-opacity))
}
.bg-\\[\\#27ae60\\] {
    --tw-bg-opacity: 1;
    background-color: rgb(39 174 96 / var(--tw-bg-opacity))
}
.bg-\\[\\#333045\\] {
    --tw-bg-opacity: 1;
    background-color: rgb(51 48 69 / var(--tw-bg-opacity))
}
.bg-\\[\\#374162\\] {
    --tw-bg-opacity: 1;
    background-color: rgb(55 65 98 / var(--tw-bg-opacity))
}
.bg-\\[\\#3a285e\\] {
    --tw-bg-opacity: 1;
    background-color: rgb(58 40 94 / var(--tw-bg-opacity))
}
.bg-\\[\\#8bb867\\] {
    --tw-bg-opacity: 1;
    background-color: rgb(139 184 103 / var(--tw-bg-opacity))
}
.bg-\\[\\#969896\\] {
    --tw-bg-opacity: 1;
    background-color: rgb(150 152 150 / var(--tw-bg-opacity))
}
.bg-\\[\\#986248\\] {
    --tw-bg-opacity: 1;
    background-color: rgb(152 98 72 / var(--tw-bg-opacity))
}
.bg-\\[\\#DC3545\\] {
    --tw-bg-opacity: 1;
    background-color: rgb(220 53 69 / var(--tw-bg-opacity))
}
.bg-\\[\\#F06F42\\] {
    --tw-bg-opacity: 1;
    background-color: rgb(240 111 66 / var(--tw-bg-opacity))
}
.bg-\\[\\#bf8c4c\\] {
    --tw-bg-opacity: 1;
    background-color: rgb(191 140 76 / var(--tw-bg-opacity))
}
.bg-\\[\\#c3964e\\] {
    --tw-bg-opacity: 1;
    background-color: rgb(195 150 78 / var(--tw-bg-opacity))
}
.bg-\\[\\#c89965\\] {
    --tw-bg-opacity: 1;
    background-color: rgb(200 153 101 / var(--tw-bg-opacity))
}
.bg-\\[\\#ca7741\\] {
    --tw-bg-opacity: 1;
    background-color: rgb(202 119 65 / var(--tw-bg-opacity))
}
.bg-\\[\\#ca943d\\] {
    --tw-bg-opacity: 1;
    background-color: rgb(202 148 61 / var(--tw-bg-opacity))
}
.bg-\\[\\#cfcfcf\\] {
    --tw-bg-opacity: 1;
    background-color: rgb(207 207 207 / var(--tw-bg-opacity))
}
.bg-\\[\\#dfab11\\] {
    --tw-bg-opacity: 1;
    background-color: rgb(223 171 17 / var(--tw-bg-opacity))
}
.bg-\\[\\#e1e2e9\\] {
    --tw-bg-opacity: 1;
    background-color: rgb(225 226 233 / var(--tw-bg-opacity))
}
.bg-\\[\\#e6994e\\] {
    --tw-bg-opacity: 1;
    background-color: rgb(230 153 78 / var(--tw-bg-opacity))
}
.bg-\\[\\#ededed\\] {
    --tw-bg-opacity: 1;
    background-color: rgb(237 237 237 / var(--tw-bg-opacity))
}
.bg-\\[\\#eee7de\\] {
    --tw-bg-opacity: 1;
    background-color: rgb(238 231 222 / var(--tw-bg-opacity))
}
.bg-\\[\\#f0e6da\\] {
    --tw-bg-opacity: 1;
    background-color: rgb(240 230 218 / var(--tw-bg-opacity))
}
.bg-\\[\\#f0f2f0\\] {
    --tw-bg-opacity: 1;
    background-color: rgb(240 242 240 / var(--tw-bg-opacity))
}
.bg-\\[\\#f0f9f9\\] {
    --tw-bg-opacity: 1;
    background-color: rgb(240 249 249 / var(--tw-bg-opacity))
}
.bg-\\[\\#f1edea\\] {
    --tw-bg-opacity: 1;
    background-color: rgb(241 237 234 / var(--tw-bg-opacity))
}
.bg-\\[\\#f3f3f3\\] {
    --tw-bg-opacity: 1;
    background-color: rgb(243 243 243 / var(--tw-bg-opacity))
}
.bg-\\[\\#f4d956\\] {
    --tw-bg-opacity: 1;
    background-color: rgb(244 217 86 / var(--tw-bg-opacity))
}
.bg-\\[\\#f4f5f9\\] {
    --tw-bg-opacity: 1;
    background-color: rgb(244 245 249 / var(--tw-bg-opacity))
}
.bg-\\[\\#f5f5f5\\] {
    --tw-bg-opacity: 1;
    background-color: rgb(245 245 245 / var(--tw-bg-opacity))
}
.bg-\\[\\#f7edee\\] {
    --tw-bg-opacity: 1;
    background-color: rgb(247 237 238 / var(--tw-bg-opacity))
}
.bg-\\[\\#f7f8fc\\] {
    --tw-bg-opacity: 1;
    background-color: rgb(247 248 252 / var(--tw-bg-opacity))
}
.bg-\\[\\#f8f2eb\\] {
    --tw-bg-opacity: 1;
    background-color: rgb(248 242 235 / var(--tw-bg-opacity))
}
.bg-\\[\\#f8f4f0\\] {
    --tw-bg-opacity: 1;
    background-color: rgb(248 244 240 / var(--tw-bg-opacity))
}
.bg-\\[\\#f9f6f3\\] {
    --tw-bg-opacity: 1;
    background-color: rgb(249 246 243 / var(--tw-bg-opacity))
}
.bg-\\[\\#faf6f3\\] {
    --tw-bg-opacity: 1;
    background-color: rgb(250 246 243 / var(--tw-bg-opacity))
}
.bg-\\[\\#fafafa\\] {
    --tw-bg-opacity: 1;
    background-color: rgb(250 250 250 / var(--tw-bg-opacity))
}
.bg-\\[\\#fd961e\\] {
    --tw-bg-opacity: 1;
    background-color: rgb(253 150 30 / var(--tw-bg-opacity))
}
.bg-\\[\\#ff6437\\] {
    --tw-bg-opacity: 1;
    background-color: rgb(255 100 55 / var(--tw-bg-opacity))
}
.bg-\\[\\#ffd7c4\\] {
    --tw-bg-opacity: 1;
    background-color: rgb(255 215 196 / var(--tw-bg-opacity))
}
.bg-\\[\\#ffeb04\\] {
    --tw-bg-opacity: 1;
    background-color: rgb(255 235 4 / var(--tw-bg-opacity))
}
.bg-\\[\\#fff9f6\\] {
    --tw-bg-opacity: 1;
    background-color: rgb(255 249 246 / var(--tw-bg-opacity))
}
.bg-\\[\\#fff\\] {
    --tw-bg-opacity: 1;
    background-color: rgb(255 255 255 / var(--tw-bg-opacity))
}
.bg-\\[\\#ffffff2e\\] {
    background-color: #ffffff2e
}
.bg-\\[rgba\\(0\\2c 0\\2c 0\\2c 0\\.5\\)\\] {
    background-color: rgba(0,0,0,0.5)
}
.bg-\\[rgba\\(0\\2c 0\\2c 0\\2c 0\\.7\\)\\] {
    background-color: rgba(0,0,0,0.7)
}
.bg-black {
    --tw-bg-opacity: 1;
    background-color: rgb(0 0 0 / var(--tw-bg-opacity))
}
.bg-darkgray {
    --tw-bg-opacity: 1;
    background-color: rgb(35 35 35 / var(--tw-bg-opacity))
}
.bg-darkpurple2 {
    --tw-bg-opacity: 1;
    background-color: rgb(36 21 38 / var(--tw-bg-opacity))
}
.bg-darkslateblue {
    --tw-bg-opacity: 1;
    background-color: rgb(31 35 44 / var(--tw-bg-opacity))
}
.bg-fastblue {
    --tw-bg-opacity: 1;
    background-color: rgb(0 56 227 / var(--tw-bg-opacity))
}
.bg-gray-100 {
    --tw-bg-opacity: 1;
    background-color: rgb(243 244 246 / var(--tw-bg-opacity))
}
.bg-lightgray {
    --tw-bg-opacity: 1;
    background-color: rgb(247 247 247 / var(--tw-bg-opacity))
}
.bg-mediumgray {
    --tw-bg-opacity: 1;
    background-color: rgb(228 228 228 / var(--tw-bg-opacity))
}
.bg-neonorange {
    --tw-bg-opacity: 1;
    background-color: rgb(255 122 86 / var(--tw-bg-opacity))
}
.bg-transparent {
    background-color: transparent
}
.bg-white {
    --tw-bg-opacity: 1;
    background-color: rgb(255 255 255 / var(--tw-bg-opacity))
}
.bg-\\[radial-gradient\\(circle\\2c rgba\\(16\\2c 16\\2c 16\\2c 0\\)\\2c \\#101010\\)\\] {
    background-image: radial-gradient(circle,rgba(16,16,16,0),#101010)
}
.bg-gradient-to-b {
    background-image: linear-gradient(to bottom, var(--tw-gradient-stops))
}
.bg-gradient-to-bl {
    background-image: linear-gradient(to bottom left, var(--tw-gradient-stops))
}
.bg-gradient-to-br {
    background-image: linear-gradient(to bottom right, var(--tw-gradient-stops))
}
.bg-gradient-to-r {
    background-image: linear-gradient(to right, var(--tw-gradient-stops))
}
.bg-gradient-to-t {
    background-image: linear-gradient(to top, var(--tw-gradient-stops))
}
.bg-gradient-to-tr {
    background-image: linear-gradient(to top right, var(--tw-gradient-stops))
}
.from-\\[\\#0039e3\\] {
    --tw-gradient-from: #0039e3 var(--tw-gradient-from-position);
    --tw-gradient-to: rgb(0 57 227 / 0) var(--tw-gradient-to-position);
    --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to)
}
.from-\\[\\#040506\\] {
    --tw-gradient-from: #040506 var(--tw-gradient-from-position);
    --tw-gradient-to: rgb(4 5 6 / 0) var(--tw-gradient-to-position);
    --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to)
}
.from-\\[\\#0cd6a2\\] {
    --tw-gradient-from: #0cd6a2 var(--tw-gradient-from-position);
    --tw-gradient-to: rgb(12 214 162 / 0) var(--tw-gradient-to-position);
    --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to)
}
.from-\\[\\#232323\\] {
    --tw-gradient-from: #232323 var(--tw-gradient-from-position);
    --tw-gradient-to: rgb(35 35 35 / 0) var(--tw-gradient-to-position);
    --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to)
}
.from-\\[\\#2f0959\\] {
    --tw-gradient-from: #2f0959 var(--tw-gradient-from-position);
    --tw-gradient-to: rgb(47 9 89 / 0) var(--tw-gradient-to-position);
    --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to)
}
.from-\\[\\#374162\\] {
    --tw-gradient-from: #374162 var(--tw-gradient-from-position);
    --tw-gradient-to: rgb(55 65 98 / 0) var(--tw-gradient-to-position);
    --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to)
}
.from-\\[\\#5065da\\] {
    --tw-gradient-from: #5065da var(--tw-gradient-from-position);
    --tw-gradient-to: rgb(80 101 218 / 0) var(--tw-gradient-to-position);
    --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to)
}
.from-\\[\\#556fff\\] {
    --tw-gradient-from: #556fff var(--tw-gradient-from-position);
    --tw-gradient-to: rgb(85 111 255 / 0) var(--tw-gradient-to-position);
    --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to)
}
.from-\\[\\#5cc088\\] {
    --tw-gradient-from: #5cc088 var(--tw-gradient-from-position);
    --tw-gradient-to: rgb(92 192 136 / 0) var(--tw-gradient-to-position);
    --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to)
}
.from-\\[\\#741bd9\\] {
    --tw-gradient-from: #741bd9 var(--tw-gradient-from-position);
    --tw-gradient-to: rgb(116 27 217 / 0) var(--tw-gradient-to-position);
    --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to)
}
.from-\\[\\#975ade\\] {
    --tw-gradient-from: #975ade var(--tw-gradient-from-position);
    --tw-gradient-to: rgb(151 90 222 / 0) var(--tw-gradient-to-position);
    --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to)
}
.from-\\[\\#b783ff\\] {
    --tw-gradient-from: #b783ff var(--tw-gradient-from-position);
    --tw-gradient-to: rgb(183 131 255 / 0) var(--tw-gradient-to-position);
    --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to)
}
.from-\\[\\#b93c90\\] {
    --tw-gradient-from: #b93c90 var(--tw-gradient-from-position);
    --tw-gradient-to: rgb(185 60 144 / 0) var(--tw-gradient-to-position);
    --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to)
}
.from-\\[\\#bf8c4c\\] {
    --tw-gradient-from: #bf8c4c var(--tw-gradient-from-position);
    --tw-gradient-to: rgb(191 140 76 / 0) var(--tw-gradient-to-position);
    --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to)
}
.from-\\[\\#e42464\\] {
    --tw-gradient-from: #e42464 var(--tw-gradient-from-position);
    --tw-gradient-to: rgb(228 36 100 / 0) var(--tw-gradient-to-position);
    --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to)
}
.from-\\[\\#ec606c\\] {
    --tw-gradient-from: #ec606c var(--tw-gradient-from-position);
    --tw-gradient-to: rgb(236 96 108 / 0) var(--tw-gradient-to-position);
    --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to)
}
.from-\\[\\#f4f5f9\\] {
    --tw-gradient-from: #f4f5f9 var(--tw-gradient-from-position);
    --tw-gradient-to: rgb(244 245 249 / 0) var(--tw-gradient-to-position);
    --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to)
}
.from-\\[\\#f5bb8d\\] {
    --tw-gradient-from: #f5bb8d var(--tw-gradient-from-position);
    --tw-gradient-to: rgb(245 187 141 / 0) var(--tw-gradient-to-position);
    --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to)
}
.from-\\[\\#f7f7f7\\] {
    --tw-gradient-from: #f7f7f7 var(--tw-gradient-from-position);
    --tw-gradient-to: rgb(247 247 247 / 0) var(--tw-gradient-to-position);
    --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to)
}
.from-\\[\\#fb7f87\\] {
    --tw-gradient-from: #fb7f87 var(--tw-gradient-from-position);
    --tw-gradient-to: rgb(251 127 135 / 0) var(--tw-gradient-to-position);
    --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to)
}
.from-\\[\\#fd7f87\\] {
    --tw-gradient-from: #fd7f87 var(--tw-gradient-from-position);
    --tw-gradient-to: rgb(253 127 135 / 0) var(--tw-gradient-to-position);
    --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to)
}
.from-\\[\\#ff6052\\] {
    --tw-gradient-from: #ff6052 var(--tw-gradient-from-position);
    --tw-gradient-to: rgb(255 96 82 / 0) var(--tw-gradient-to-position);
    --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to)
}
.from-\\[\\#ff6557\\] {
    --tw-gradient-from: #ff6557 var(--tw-gradient-from-position);
    --tw-gradient-to: rgb(255 101 87 / 0) var(--tw-gradient-to-position);
    --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to)
}
.from-\\[\\#ff85a6\\] {
    --tw-gradient-from: #ff85a6 var(--tw-gradient-from-position);
    --tw-gradient-to: rgb(255 133 166 / 0) var(--tw-gradient-to-position);
    --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to)
}
.from-\\[\\#ff9e78\\] {
    --tw-gradient-from: #ff9e78 var(--tw-gradient-from-position);
    --tw-gradient-to: rgb(255 158 120 / 0) var(--tw-gradient-to-position);
    --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to)
}
.from-\\[\\#ffa996\\] {
    --tw-gradient-from: #ffa996 var(--tw-gradient-from-position);
    --tw-gradient-to: rgb(255 169 150 / 0) var(--tw-gradient-to-position);
    --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to)
}
.from-\\[\\#fff\\] {
    --tw-gradient-from: #fff var(--tw-gradient-from-position);
    --tw-gradient-to: rgb(255 255 255 / 0) var(--tw-gradient-to-position);
    --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to)
}
.from-\\[transparent\\] {
    --tw-gradient-from: transparent var(--tw-gradient-from-position);
    --tw-gradient-to: rgb(0 0 0 / 0) var(--tw-gradient-to-position);
    --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to)
}
.from-darkgray {
    --tw-gradient-from: #232323 var(--tw-gradient-from-position);
    --tw-gradient-to: rgb(35 35 35 / 0) var(--tw-gradient-to-position);
    --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to)
}
.from-purple-500 {
    --tw-gradient-from: #a855f7 var(--tw-gradient-from-position);
    --tw-gradient-to: rgb(168 85 247 / 0) var(--tw-gradient-to-position);
    --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to)
}
.from-transparent {
    --tw-gradient-from: transparent var(--tw-gradient-from-position);
    --tw-gradient-to: rgb(0 0 0 / 0) var(--tw-gradient-to-position);
    --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to)
}
.via-\\[\\#232323\\] {
    --tw-gradient-to: rgb(35 35 35 / 0)  var(--tw-gradient-to-position);
    --tw-gradient-stops: var(--tw-gradient-from), #232323 var(--tw-gradient-via-position), var(--tw-gradient-to)
}
.via-\\[\\#56de9c\\] {
    --tw-gradient-to: rgb(86 222 156 / 0)  var(--tw-gradient-to-position);
    --tw-gradient-stops: var(--tw-gradient-from), #56de9c var(--tw-gradient-via-position), var(--tw-gradient-to)
}
.via-\\[\\#5c2359\\] {
    --tw-gradient-to: rgb(92 35 89 / 0)  var(--tw-gradient-to-position);
    --tw-gradient-stops: var(--tw-gradient-from), #5c2359 var(--tw-gradient-via-position), var(--tw-gradient-to)
}
.via-\\[\\#5e28dd\\] {
    --tw-gradient-to: rgb(94 40 221 / 0)  var(--tw-gradient-to-position);
    --tw-gradient-stops: var(--tw-gradient-from), #5e28dd var(--tw-gradient-via-position), var(--tw-gradient-to)
}
.via-\\[\\#741bd9\\] {
    --tw-gradient-to: rgb(116 27 217 / 0)  var(--tw-gradient-to-position);
    --tw-gradient-stops: var(--tw-gradient-from), #741bd9 var(--tw-gradient-via-position), var(--tw-gradient-to)
}
.via-\\[\\#a92a96\\] {
    --tw-gradient-to: rgb(169 42 150 / 0)  var(--tw-gradient-to-position);
    --tw-gradient-stops: var(--tw-gradient-from), #a92a96 var(--tw-gradient-via-position), var(--tw-gradient-to)
}
.via-\\[\\#af63d2\\] {
    --tw-gradient-to: rgb(175 99 210 / 0)  var(--tw-gradient-to-position);
    --tw-gradient-stops: var(--tw-gradient-from), #af63d2 var(--tw-gradient-via-position), var(--tw-gradient-to)
}
.via-\\[\\#b263e4\\] {
    --tw-gradient-to: rgb(178 99 228 / 0)  var(--tw-gradient-to-position);
    --tw-gradient-stops: var(--tw-gradient-from), #b263e4 var(--tw-gradient-via-position), var(--tw-gradient-to)
}
.via-\\[\\#c557ad\\] {
    --tw-gradient-to: rgb(197 87 173 / 0)  var(--tw-gradient-to-position);
    --tw-gradient-stops: var(--tw-gradient-from), #c557ad var(--tw-gradient-via-position), var(--tw-gradient-to)
}
.via-\\[\\#d473c0\\] {
    --tw-gradient-to: rgb(212 115 192 / 0)  var(--tw-gradient-to-position);
    --tw-gradient-stops: var(--tw-gradient-from), #d473c0 var(--tw-gradient-via-position), var(--tw-gradient-to)
}
.via-\\[\\#e05fc4\\] {
    --tw-gradient-to: rgb(224 95 196 / 0)  var(--tw-gradient-to-position);
    --tw-gradient-stops: var(--tw-gradient-from), #e05fc4 var(--tw-gradient-via-position), var(--tw-gradient-to)
}
.via-\\[\\#e355ff\\] {
    --tw-gradient-to: rgb(227 85 255 / 0)  var(--tw-gradient-to-position);
    --tw-gradient-stops: var(--tw-gradient-from), #e355ff var(--tw-gradient-via-position), var(--tw-gradient-to)
}
.via-\\[\\#ed6c4d\\] {
    --tw-gradient-to: rgb(237 108 77 / 0)  var(--tw-gradient-to-position);
    --tw-gradient-stops: var(--tw-gradient-from), #ed6c4d var(--tw-gradient-via-position), var(--tw-gradient-to)
}
.via-\\[\\#ee6362\\] {
    --tw-gradient-to: rgb(238 99 98 / 0)  var(--tw-gradient-to-position);
    --tw-gradient-stops: var(--tw-gradient-from), #ee6362 var(--tw-gradient-via-position), var(--tw-gradient-to)
}
.via-\\[\\#ee6757\\] {
    --tw-gradient-to: rgb(238 103 87 / 0)  var(--tw-gradient-to-position);
    --tw-gradient-stops: var(--tw-gradient-from), #ee6757 var(--tw-gradient-via-position), var(--tw-gradient-to)
}
.via-\\[\\#fbfbfb\\] {
    --tw-gradient-to: rgb(251 251 251 / 0)  var(--tw-gradient-to-position);
    --tw-gradient-stops: var(--tw-gradient-from), #fbfbfb var(--tw-gradient-via-position), var(--tw-gradient-to)
}
.via-\\[\\#fc8a82\\] {
    --tw-gradient-to: rgb(252 138 130 / 0)  var(--tw-gradient-to-position);
    --tw-gradient-stops: var(--tw-gradient-from), #fc8a82 var(--tw-gradient-via-position), var(--tw-gradient-to)
}
.via-\\[\\#fdfdfd\\] {
    --tw-gradient-to: rgb(253 253 253 / 0)  var(--tw-gradient-to-position);
    --tw-gradient-stops: var(--tw-gradient-from), #fdfdfd var(--tw-gradient-via-position), var(--tw-gradient-to)
}
.via-\\[\\#feb399\\] {
    --tw-gradient-to: rgb(254 179 153 / 0)  var(--tw-gradient-to-position);
    --tw-gradient-stops: var(--tw-gradient-from), #feb399 var(--tw-gradient-via-position), var(--tw-gradient-to)
}
.via-\\[\\#ff4271\\] {
    --tw-gradient-to: rgb(255 66 113 / 0)  var(--tw-gradient-to-position);
    --tw-gradient-stops: var(--tw-gradient-from), #ff4271 var(--tw-gradient-via-position), var(--tw-gradient-to)
}
.via-\\[\\#ff4e68\\] {
    --tw-gradient-to: rgb(255 78 104 / 0)  var(--tw-gradient-to-position);
    --tw-gradient-stops: var(--tw-gradient-from), #ff4e68 var(--tw-gradient-via-position), var(--tw-gradient-to)
}
.via-\\[\\#ff6557\\] {
    --tw-gradient-to: rgb(255 101 87 / 0)  var(--tw-gradient-to-position);
    --tw-gradient-stops: var(--tw-gradient-from), #ff6557 var(--tw-gradient-via-position), var(--tw-gradient-to)
}
.via-\\[\\#ff77dd\\] {
    --tw-gradient-to: rgb(255 119 221 / 0)  var(--tw-gradient-to-position);
    --tw-gradient-stops: var(--tw-gradient-from), #ff77dd var(--tw-gradient-via-position), var(--tw-gradient-to)
}
.via-\\[\\#ff798e\\] {
    --tw-gradient-to: rgb(255 121 142 / 0)  var(--tw-gradient-to-position);
    --tw-gradient-stops: var(--tw-gradient-from), #ff798e var(--tw-gradient-via-position), var(--tw-gradient-to)
}
.via-\\[\\#ff9979\\] {
    --tw-gradient-to: rgb(255 153 121 / 0)  var(--tw-gradient-to-position);
    --tw-gradient-stops: var(--tw-gradient-from), #ff9979 var(--tw-gradient-via-position), var(--tw-gradient-to)
}
.via-\\[\\#ffaea8\\] {
    --tw-gradient-to: rgb(255 174 168 / 0)  var(--tw-gradient-to-position);
    --tw-gradient-stops: var(--tw-gradient-from), #ffaea8 var(--tw-gradient-via-position), var(--tw-gradient-to)
}
.to-\\[\\#0039e3\\] {
    --tw-gradient-to: #0039e3 var(--tw-gradient-to-position)
}
.to-\\[\\#130e3e\\] {
    --tw-gradient-to: #130e3e var(--tw-gradient-to-position)
}
.to-\\[\\#141414\\] {
    --tw-gradient-to: #141414 var(--tw-gradient-to-position)
}
.to-\\[\\#1f232c\\] {
    --tw-gradient-to: #1f232c var(--tw-gradient-to-position)
}
.to-\\[\\#232323\\] {
    --tw-gradient-to: #232323 var(--tw-gradient-to-position)
}
.to-\\[\\#374162\\] {
    --tw-gradient-to: #374162 var(--tw-gradient-to-position)
}
.to-\\[\\#445a58\\] {
    --tw-gradient-to: #445a58 var(--tw-gradient-to-position)
}
.to-\\[\\#556fff\\] {
    --tw-gradient-to: #556fff var(--tw-gradient-to-position)
}
.to-\\[\\#741bd9\\] {
    --tw-gradient-to: #741bd9 var(--tw-gradient-to-position)
}
.to-\\[\\#8600d4\\] {
    --tw-gradient-to: #8600d4 var(--tw-gradient-to-position)
}
.to-\\[\\#951a9d\\] {
    --tw-gradient-to: #951a9d var(--tw-gradient-to-position)
}
.to-\\[\\#b783ff\\] {
    --tw-gradient-to: #b783ff var(--tw-gradient-to-position)
}
.to-\\[\\#c7da26\\] {
    --tw-gradient-to: #c7da26 var(--tw-gradient-to-position)
}
.to-\\[\\#dda556\\] {
    --tw-gradient-to: #dda556 var(--tw-gradient-to-position)
}
.to-\\[\\#e65f9a\\] {
    --tw-gradient-to: #e65f9a var(--tw-gradient-to-position)
}
.to-\\[\\#e66176\\] {
    --tw-gradient-to: #e66176 var(--tw-gradient-to-position)
}
.to-\\[\\#e6686f\\] {
    --tw-gradient-to: #e6686f var(--tw-gradient-to-position)
}
.to-\\[\\#eb7242\\] {
    --tw-gradient-to: #eb7242 var(--tw-gradient-to-position)
}
.to-\\[\\#eb7274\\] {
    --tw-gradient-to: #eb7274 var(--tw-gradient-to-position)
}
.to-\\[\\#f0f2f0\\] {
    --tw-gradient-to: #f0f2f0 var(--tw-gradient-to-position)
}
.to-\\[\\#f3aaca\\] {
    --tw-gradient-to: #f3aaca var(--tw-gradient-to-position)
}
.to-\\[\\#f767a6\\] {
    --tw-gradient-to: #f767a6 var(--tw-gradient-to-position)
}
.to-\\[\\#f7aa80\\] {
    --tw-gradient-to: #f7aa80 var(--tw-gradient-to-position)
}
.to-\\[\\#f7f7f7\\] {
    --tw-gradient-to: #f7f7f7 var(--tw-gradient-to-position)
}
.to-\\[\\#fd7956\\] {
    --tw-gradient-to: #fd7956 var(--tw-gradient-to-position)
}
.to-\\[\\#fea499\\] {
    --tw-gradient-to: #fea499 var(--tw-gradient-to-position)
}
.to-\\[\\#ff367c\\] {
    --tw-gradient-to: #ff367c var(--tw-gradient-to-position)
}
.to-\\[\\#ff7357\\] {
    --tw-gradient-to: #ff7357 var(--tw-gradient-to-position)
}
.to-\\[\\#ff767e\\] {
    --tw-gradient-to: #ff767e var(--tw-gradient-to-position)
}
.to-\\[\\#ff798e\\] {
    --tw-gradient-to: #ff798e var(--tw-gradient-to-position)
}
.to-\\[\\#ff85a6\\] {
    --tw-gradient-to: #ff85a6 var(--tw-gradient-to-position)
}
.to-\\[\\#ff9393\\] {
    --tw-gradient-to: #ff9393 var(--tw-gradient-to-position)
}
.to-\\[\\#fff\\] {
    --tw-gradient-to: #fff var(--tw-gradient-to-position)
}
.to-darkgray {
    --tw-gradient-to: #232323 var(--tw-gradient-to-position)
}
.to-pink-500 {
    --tw-gradient-to: #ec4899 var(--tw-gradient-to-position)
}
.to-transparent {
    --tw-gradient-to: transparent var(--tw-gradient-to-position)
}
.bg-cover {
    background-size: cover
}
.bg-fixed {
    background-attachment: fixed
}
.bg-clip-text {
    -webkit-background-clip: text;
            background-clip: text
}
.\\!bg-\\[50\\%_0\\] {
    background-position: 50% 0 !important
}
.bg-\\[bottom_240px_right_-10px\\] {
    background-position: bottom 240px right -10px
}
.bg-\\[center_center\\] {
    background-position: center center
}
.bg-\\[center_top\\] {
    background-position: center top
}
.bg-\\[right_-40px_center\\] {
    background-position: right -40px center
}
.bg-\\[right_25px_bottom_-35px\\] {
    background-position: right 25px bottom -35px
}
.bg-\\[right_5px_bottom_-25px\\] {
    background-position: right 5px bottom -25px
}
.bg-\\[right_top\\] {
    background-position: right top
}
.bg-\\[top_-45px_left\\] {
    background-position: top -45px left
}
.bg-\\[top_110px_left\\] {
    background-position: top 110px left
}
.bg-bottom {
    background-position: bottom
}
.bg-center {
    background-position: center
}
.bg-left {
    background-position: left
}
.bg-left-bottom {
    background-position: left bottom
}
.bg-right {
    background-position: right
}
.bg-right-bottom {
    background-position: right bottom
}
.bg-top {
    background-position: top
}
.bg-no-repeat {
    background-repeat: no-repeat
}
.fill-transparent {
    fill: transparent
}
.object-cover {
    object-fit: cover
}
.p-0 {
    padding: 0px
}
.p-12 {
    padding: 3rem
}
.p-14 {
    padding: 3.5rem
}
.p-16 {
    padding: 4rem
}
.p-20 {
    padding: 5rem
}
.p-24 {
    padding: 6rem
}
.p-28 {
    padding: 7rem
}
.p-32 {
    padding: 8rem
}
.p-40 {
    padding: 10rem
}
.p-6 {
    padding: 1.5rem
}
.p-\\[0px\\] {
    padding: 0px
}
.p-\\[100px\\] {
    padding: 100px
}
.p-\\[10px\\] {
    padding: 10px
}
.p-\\[130px\\] {
    padding: 130px
}
.p-\\[15\\%\\] {
    padding: 15%
}
.p-\\[15px\\] {
    padding: 15px
}
.p-\\[20px\\] {
    padding: 20px
}
.p-\\[2px\\] {
    padding: 2px
}
.p-\\[3\\.9rem\\] {
    padding: 3.9rem
}
.p-\\[30px\\] {
    padding: 30px
}
.p-\\[35px\\] {
    padding: 35px
}
.p-\\[38px\\] {
    padding: 38px
}
.p-\\[4\\.5rem\\] {
    padding: 4.5rem
}
.p-\\[40px\\] {
    padding: 40px
}
.p-\\[45px\\] {
    padding: 45px
}
.p-\\[49px\\] {
    padding: 49px
}
.p-\\[5\\.5rem\\] {
    padding: 5.5rem
}
.p-\\[50px\\] {
    padding: 50px
}
.p-\\[5px\\] {
    padding: 5px
}
.p-\\[6\\.5rem\\] {
    padding: 6.5rem
}
.p-\\[60px\\] {
    padding: 60px
}
.p-\\[63px\\] {
    padding: 63px
}
.p-\\[7\\.5rem\\] {
    padding: 7.5rem
}
.p-\\[8\\.5rem\\] {
    padding: 8.5rem
}
.p-\\[84px\\] {
    padding: 84px
}
.\\!px-0 {
    padding-left: 0px !important;
    padding-right: 0px !important
}
.\\!px-\\[18px\\] {
    padding-left: 18px !important;
    padding-right: 18px !important
}
.\\!py-\\[10px\\] {
    padding-top: 10px !important;
    padding-bottom: 10px !important
}
.\\!py-\\[13px\\] {
    padding-top: 13px !important;
    padding-bottom: 13px !important
}
.\\!py-\\[4px\\] {
    padding-top: 4px !important;
    padding-bottom: 4px !important
}
.\\!py-\\[7px\\] {
    padding-top: 7px !important;
    padding-bottom: 7px !important
}
.px-0 {
    padding-left: 0px;
    padding-right: 0px
}
.px-10 {
    padding-left: 2.5rem;
    padding-right: 2.5rem
}
.px-12 {
    padding-left: 3rem;
    padding-right: 3rem
}
.px-14 {
    padding-left: 3.5rem;
    padding-right: 3.5rem
}
.px-16 {
    padding-left: 4rem;
    padding-right: 4rem
}
.px-2 {
    padding-left: 0.5rem;
    padding-right: 0.5rem
}
.px-20 {
    padding-left: 5rem;
    padding-right: 5rem
}
.px-24 {
    padding-left: 6rem;
    padding-right: 6rem
}
.px-28 {
    padding-left: 7rem;
    padding-right: 7rem
}
.px-32 {
    padding-left: 8rem;
    padding-right: 8rem
}
.px-36 {
    padding-left: 9rem;
    padding-right: 9rem
}
.px-40 {
    padding-left: 10rem;
    padding-right: 10rem
}
.px-8 {
    padding-left: 2rem;
    padding-right: 2rem
}
.px-9 {
    padding-left: 2.25rem;
    padding-right: 2.25rem
}
.px-\\[0px\\] {
    padding-left: 0px;
    padding-right: 0px
}
.px-\\[10\\%\\] {
    padding-left: 10%;
    padding-right: 10%
}
.px-\\[10\\.5rem\\] {
    padding-left: 10.5rem;
    padding-right: 10.5rem
}
.px-\\[100px\\] {
    padding-left: 100px;
    padding-right: 100px
}
.px-\\[105px\\] {
    padding-left: 105px;
    padding-right: 105px
}
.px-\\[10px\\] {
    padding-left: 10px;
    padding-right: 10px
}
.px-\\[10rem\\] {
    padding-left: 10rem;
    padding-right: 10rem
}
.px-\\[11\\%\\] {
    padding-left: 11%;
    padding-right: 11%
}
.px-\\[12\\%\\] {
    padding-left: 12%;
    padding-right: 12%
}
.px-\\[130px\\] {
    padding-left: 130px;
    padding-right: 130px
}
.px-\\[13px\\] {
    padding-left: 13px;
    padding-right: 13px
}
.px-\\[147px\\] {
    padding-left: 147px;
    padding-right: 147px
}
.px-\\[15px\\] {
    padding-left: 15px;
    padding-right: 15px
}
.px-\\[16\\%\\] {
    padding-left: 16%;
    padding-right: 16%
}
.px-\\[16px\\] {
    padding-left: 16px;
    padding-right: 16px
}
.px-\\[180px\\] {
    padding-left: 180px;
    padding-right: 180px
}
.px-\\[18px\\] {
    padding-left: 18px;
    padding-right: 18px
}
.px-\\[20\\%\\] {
    padding-left: 20%;
    padding-right: 20%
}
.px-\\[20px\\] {
    padding-left: 20px;
    padding-right: 20px
}
.px-\\[22px\\] {
    padding-left: 22px;
    padding-right: 22px
}
.px-\\[24px\\] {
    padding-left: 24px;
    padding-right: 24px
}
.px-\\[25px\\] {
    padding-left: 25px;
    padding-right: 25px
}
.px-\\[26px\\] {
    padding-left: 26px;
    padding-right: 26px
}
.px-\\[28px\\] {
    padding-left: 28px;
    padding-right: 28px
}
.px-\\[3\\.5rem\\] {
    padding-left: 3.5rem;
    padding-right: 3.5rem
}
.px-\\[30px\\] {
    padding-left: 30px;
    padding-right: 30px
}
.px-\\[32px\\] {
    padding-left: 32px;
    padding-right: 32px
}
.px-\\[35px\\] {
    padding-left: 35px;
    padding-right: 35px
}
.px-\\[38px\\] {
    padding-left: 38px;
    padding-right: 38px
}
.px-\\[3rem\\] {
    padding-left: 3rem;
    padding-right: 3rem
}
.px-\\[4\\%\\] {
    padding-left: 4%;
    padding-right: 4%
}
.px-\\[4\\.5rem\\] {
    padding-left: 4.5rem;
    padding-right: 4.5rem
}
.px-\\[40px\\] {
    padding-left: 40px;
    padding-right: 40px
}
.px-\\[44px\\] {
    padding-left: 44px;
    padding-right: 44px
}
.px-\\[45px\\] {
    padding-left: 45px;
    padding-right: 45px
}
.px-\\[5\\%\\] {
    padding-left: 5%;
    padding-right: 5%
}
.px-\\[5\\.5rem\\] {
    padding-left: 5.5rem;
    padding-right: 5.5rem
}
.px-\\[50px\\] {
    padding-left: 50px;
    padding-right: 50px
}
.px-\\[55px\\] {
    padding-left: 55px;
    padding-right: 55px
}
.px-\\[5px\\] {
    padding-left: 5px;
    padding-right: 5px
}
.px-\\[5rem\\] {
    padding-left: 5rem;
    padding-right: 5rem
}
.px-\\[6\\%\\] {
    padding-left: 6%;
    padding-right: 6%
}
.px-\\[6\\.5rem\\] {
    padding-left: 6.5rem;
    padding-right: 6.5rem
}
.px-\\[60px\\] {
    padding-left: 60px;
    padding-right: 60px
}
.px-\\[64px\\] {
    padding-left: 64px;
    padding-right: 64px
}
.px-\\[6rem\\] {
    padding-left: 6rem;
    padding-right: 6rem
}
.px-\\[7\\%\\] {
    padding-left: 7%;
    padding-right: 7%
}
.px-\\[7\\.5rem\\] {
    padding-left: 7.5rem;
    padding-right: 7.5rem
}
.px-\\[70px\\] {
    padding-left: 70px;
    padding-right: 70px
}
.px-\\[73px\\] {
    padding-left: 73px;
    padding-right: 73px
}
.px-\\[75px\\] {
    padding-left: 75px;
    padding-right: 75px
}
.px-\\[7rem\\] {
    padding-left: 7rem;
    padding-right: 7rem
}
.px-\\[8\\%\\] {
    padding-left: 8%;
    padding-right: 8%
}
.px-\\[8\\.5rem\\] {
    padding-left: 8.5rem;
    padding-right: 8.5rem
}
.px-\\[84px\\] {
    padding-left: 84px;
    padding-right: 84px
}
.px-\\[8px\\] {
    padding-left: 8px;
    padding-right: 8px
}
.px-\\[9\\%\\] {
    padding-left: 9%;
    padding-right: 9%
}
.px-\\[9\\.5rem\\] {
    padding-left: 9.5rem;
    padding-right: 9.5rem
}
.px-\\[90px\\] {
    padding-left: 90px;
    padding-right: 90px
}
.px-\\[9px\\] {
    padding-left: 9px;
    padding-right: 9px
}
.py-0 {
    padding-top: 0px;
    padding-bottom: 0px
}
.py-10 {
    padding-top: 2.5rem;
    padding-bottom: 2.5rem
}
.py-12 {
    padding-top: 3rem;
    padding-bottom: 3rem
}
.py-14 {
    padding-top: 3.5rem;
    padding-bottom: 3.5rem
}
.py-16 {
    padding-top: 4rem;
    padding-bottom: 4rem
}
.py-2 {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem
}
.py-20 {
    padding-top: 5rem;
    padding-bottom: 5rem
}
.py-24 {
    padding-top: 6rem;
    padding-bottom: 6rem
}
.py-28 {
    padding-top: 7rem;
    padding-bottom: 7rem
}
.py-32 {
    padding-top: 8rem;
    padding-bottom: 8rem
}
.py-36 {
    padding-top: 9rem;
    padding-bottom: 9rem
}
.py-40 {
    padding-top: 10rem;
    padding-bottom: 10rem
}
.py-52 {
    padding-top: 13rem;
    padding-bottom: 13rem
}
.py-7 {
    padding-top: 1.75rem;
    padding-bottom: 1.75rem
}
.py-8 {
    padding-top: 2rem;
    padding-bottom: 2rem
}
.py-\\[0px\\] {
    padding-top: 0px;
    padding-bottom: 0px
}
.py-\\[10\\.5rem\\] {
    padding-top: 10.5rem;
    padding-bottom: 10.5rem
}
.py-\\[100px\\] {
    padding-top: 100px;
    padding-bottom: 100px
}
.py-\\[10px\\] {
    padding-top: 10px;
    padding-bottom: 10px
}
.py-\\[10rem\\] {
    padding-top: 10rem;
    padding-bottom: 10rem
}
.py-\\[11\\%\\] {
    padding-top: 11%;
    padding-bottom: 11%
}
.py-\\[119px\\] {
    padding-top: 119px;
    padding-bottom: 119px
}
.py-\\[12\\%\\] {
    padding-top: 12%;
    padding-bottom: 12%
}
.py-\\[120px\\] {
    padding-top: 120px;
    padding-bottom: 120px
}
.py-\\[12px\\] {
    padding-top: 12px;
    padding-bottom: 12px
}
.py-\\[130px\\] {
    padding-top: 130px;
    padding-bottom: 130px
}
.py-\\[13px\\] {
    padding-top: 13px;
    padding-bottom: 13px
}
.py-\\[140px\\] {
    padding-top: 140px;
    padding-bottom: 140px
}
.py-\\[14px\\] {
    padding-top: 14px;
    padding-bottom: 14px
}
.py-\\[15px\\] {
    padding-top: 15px;
    padding-bottom: 15px
}
.py-\\[160px\\] {
    padding-top: 160px;
    padding-bottom: 160px
}
.py-\\[16px\\] {
    padding-top: 16px;
    padding-bottom: 16px
}
.py-\\[170px\\] {
    padding-top: 170px;
    padding-bottom: 170px
}
.py-\\[18px\\] {
    padding-top: 18px;
    padding-bottom: 18px
}
.py-\\[19px\\] {
    padding-top: 19px;
    padding-bottom: 19px
}
.py-\\[2\\.5rem\\] {
    padding-top: 2.5rem;
    padding-bottom: 2.5rem
}
.py-\\[200px\\] {
    padding-top: 200px;
    padding-bottom: 200px
}
.py-\\[20px\\] {
    padding-top: 20px;
    padding-bottom: 20px
}
.py-\\[250px\\] {
    padding-top: 250px;
    padding-bottom: 250px
}
.py-\\[25px\\] {
    padding-top: 25px;
    padding-bottom: 25px
}
.py-\\[28px\\] {
    padding-top: 28px;
    padding-bottom: 28px
}
.py-\\[2px\\] {
    padding-top: 2px;
    padding-bottom: 2px
}
.py-\\[3\\%\\] {
    padding-top: 3%;
    padding-bottom: 3%
}
.py-\\[3\\.5rem\\] {
    padding-top: 3.5rem;
    padding-bottom: 3.5rem
}
.py-\\[30px\\] {
    padding-top: 30px;
    padding-bottom: 30px
}
.py-\\[35px\\] {
    padding-top: 35px;
    padding-bottom: 35px
}
.py-\\[3px\\] {
    padding-top: 3px;
    padding-bottom: 3px
}
.py-\\[3rem\\] {
    padding-top: 3rem;
    padding-bottom: 3rem
}
.py-\\[4\\%\\] {
    padding-top: 4%;
    padding-bottom: 4%
}
.py-\\[4\\.5rem\\] {
    padding-top: 4.5rem;
    padding-bottom: 4.5rem
}
.py-\\[40px\\] {
    padding-top: 40px;
    padding-bottom: 40px
}
.py-\\[42px\\] {
    padding-top: 42px;
    padding-bottom: 42px
}
.py-\\[49px\\] {
    padding-top: 49px;
    padding-bottom: 49px
}
.py-\\[4px\\] {
    padding-top: 4px;
    padding-bottom: 4px
}
.py-\\[5\\%\\] {
    padding-top: 5%;
    padding-bottom: 5%
}
.py-\\[5\\.5rem\\] {
    padding-top: 5.5rem;
    padding-bottom: 5.5rem
}
.py-\\[50px\\] {
    padding-top: 50px;
    padding-bottom: 50px
}
.py-\\[55px\\] {
    padding-top: 55px;
    padding-bottom: 55px
}
.py-\\[5px\\] {
    padding-top: 5px;
    padding-bottom: 5px
}
.py-\\[5rem\\] {
    padding-top: 5rem;
    padding-bottom: 5rem
}
.py-\\[6\\%\\] {
    padding-top: 6%;
    padding-bottom: 6%
}
.py-\\[60px\\] {
    padding-top: 60px;
    padding-bottom: 60px
}
.py-\\[65px\\] {
    padding-top: 65px;
    padding-bottom: 65px
}
.py-\\[6px\\] {
    padding-top: 6px;
    padding-bottom: 6px
}
.py-\\[6rem\\] {
    padding-top: 6rem;
    padding-bottom: 6rem
}
.py-\\[7\\%\\] {
    padding-top: 7%;
    padding-bottom: 7%
}
.py-\\[7\\.5rem\\] {
    padding-top: 7.5rem;
    padding-bottom: 7.5rem
}
.py-\\[70px\\] {
    padding-top: 70px;
    padding-bottom: 70px
}
.py-\\[7px\\] {
    padding-top: 7px;
    padding-bottom: 7px
}
.py-\\[7rem\\] {
    padding-top: 7rem;
    padding-bottom: 7rem
}
.py-\\[8\\%\\] {
    padding-top: 8%;
    padding-bottom: 8%
}
.py-\\[80px\\] {
    padding-top: 80px;
    padding-bottom: 80px
}
.py-\\[8px\\] {
    padding-top: 8px;
    padding-bottom: 8px
}
.py-\\[8rem\\] {
    padding-top: 8rem;
    padding-bottom: 8rem
}
.py-\\[9\\%\\] {
    padding-top: 9%;
    padding-bottom: 9%
}
.py-\\[9\\.5rem\\] {
    padding-top: 9.5rem;
    padding-bottom: 9.5rem
}
.py-\\[90px\\] {
    padding-top: 90px;
    padding-bottom: 90px
}
.py-\\[95px\\] {
    padding-top: 95px;
    padding-bottom: 95px
}
.py-\\[9px\\] {
    padding-top: 9px;
    padding-bottom: 9px
}
.\\!pl-0 {
    padding-left: 0px !important
}
.\\!pl-\\[12px\\] {
    padding-left: 12px !important
}
.\\!pl-\\[15px\\] {
    padding-left: 15px !important
}
.\\!pl-\\[22px\\] {
    padding-left: 22px !important
}
.\\!pl-\\[25px\\] {
    padding-left: 25px !important
}
.\\!pl-\\[7px\\] {
    padding-left: 7px !important
}
.\\!pl-\\[90px\\] {
    padding-left: 90px !important
}
.\\!pr-0 {
    padding-right: 0px !important
}
.\\!pr-\\[12px\\] {
    padding-right: 12px !important
}
.\\!pr-\\[175px\\] {
    padding-right: 175px !important
}
.\\!pr-\\[30px\\] {
    padding-right: 30px !important
}
.\\!pr-\\[35px\\] {
    padding-right: 35px !important
}
.\\!pr-\\[50px\\] {
    padding-right: 50px !important
}
.\\!pr-\\[70px\\] {
    padding-right: 70px !important
}
.\\!pt-0 {
    padding-top: 0px !important
}
.pb-0 {
    padding-bottom: 0px
}
.pb-12 {
    padding-bottom: 3rem
}
.pb-20 {
    padding-bottom: 5rem
}
.pb-28 {
    padding-bottom: 7rem
}
.pb-36 {
    padding-bottom: 9rem
}
.pb-4 {
    padding-bottom: 1rem
}
.pb-40 {
    padding-bottom: 10rem
}
.pb-\\[10\\%\\] {
    padding-bottom: 10%
}
.pb-\\[100px\\] {
    padding-bottom: 100px
}
.pb-\\[105px\\] {
    padding-bottom: 105px
}
.pb-\\[10px\\] {
    padding-bottom: 10px
}
.pb-\\[118px\\] {
    padding-bottom: 118px
}
.pb-\\[12px\\] {
    padding-bottom: 12px
}
.pb-\\[130px\\] {
    padding-bottom: 130px
}
.pb-\\[140px\\] {
    padding-bottom: 140px
}
.pb-\\[15px\\] {
    padding-bottom: 15px
}
.pb-\\[160px\\] {
    padding-bottom: 160px
}
.pb-\\[17px\\] {
    padding-bottom: 17px
}
.pb-\\[190px\\] {
    padding-bottom: 190px
}
.pb-\\[19px\\] {
    padding-bottom: 19px
}
.pb-\\[200px\\] {
    padding-bottom: 200px
}
.pb-\\[20px\\] {
    padding-bottom: 20px
}
.pb-\\[210px\\] {
    padding-bottom: 210px
}
.pb-\\[23px\\] {
    padding-bottom: 23px
}
.pb-\\[240px\\] {
    padding-bottom: 240px
}
.pb-\\[250px\\] {
    padding-bottom: 250px
}
.pb-\\[255px\\] {
    padding-bottom: 255px
}
.pb-\\[2px\\] {
    padding-bottom: 2px
}
.pb-\\[30px\\] {
    padding-bottom: 30px
}
.pb-\\[310px\\] {
    padding-bottom: 310px
}
.pb-\\[325px\\] {
    padding-bottom: 325px
}
.pb-\\[32px\\] {
    padding-bottom: 32px
}
.pb-\\[350px\\] {
    padding-bottom: 350px
}
.pb-\\[384px\\] {
    padding-bottom: 384px
}
.pb-\\[4\\.5rem\\] {
    padding-bottom: 4.5rem
}
.pb-\\[400px\\] {
    padding-bottom: 400px
}
.pb-\\[40px\\] {
    padding-bottom: 40px
}
.pb-\\[430px\\] {
    padding-bottom: 430px
}
.pb-\\[5\\%\\] {
    padding-bottom: 5%
}
.pb-\\[500px\\] {
    padding-bottom: 500px
}
.pb-\\[50px\\] {
    padding-bottom: 50px
}
.pb-\\[5px\\] {
    padding-bottom: 5px
}
.pb-\\[6\\%\\] {
    padding-bottom: 6%
}
.pb-\\[60px\\] {
    padding-bottom: 60px
}
.pb-\\[632px\\] {
    padding-bottom: 632px
}
.pb-\\[65px\\] {
    padding-bottom: 65px
}
.pb-\\[6px\\] {
    padding-bottom: 6px
}
.pb-\\[70px\\] {
    padding-bottom: 70px
}
.pb-\\[8\\%\\] {
    padding-bottom: 8%
}
.pb-\\[80px\\] {
    padding-bottom: 80px
}
.pb-\\[9\\%\\] {
    padding-bottom: 9%
}
.pe-0 {
    padding-inline-end: 0px
}
.pl-0 {
    padding-left: 0px
}
.pl-12 {
    padding-left: 3rem
}
.pl-14 {
    padding-left: 3.5rem
}
.pl-16 {
    padding-left: 4rem
}
.pl-24 {
    padding-left: 6rem
}
.pl-28 {
    padding-left: 7rem
}
.pl-36 {
    padding-left: 9rem
}
.pl-40 {
    padding-left: 10rem
}
.pl-\\[10\\%\\] {
    padding-left: 10%
}
.pl-\\[15px\\] {
    padding-left: 15px
}
.pl-\\[17px\\] {
    padding-left: 17px
}
.pl-\\[18px\\] {
    padding-left: 18px
}
.pl-\\[19px\\] {
    padding-left: 19px
}
.pl-\\[20px\\] {
    padding-left: 20px
}
.pl-\\[25px\\] {
    padding-left: 25px
}
.pl-\\[290px\\] {
    padding-left: 290px
}
.pl-\\[3\\.5rem\\] {
    padding-left: 3.5rem
}
.pl-\\[30px\\] {
    padding-left: 30px
}
.pl-\\[35px\\] {
    padding-left: 35px
}
.pl-\\[40px\\] {
    padding-left: 40px
}
.pl-\\[49px\\] {
    padding-left: 49px
}
.pl-\\[50px\\] {
    padding-left: 50px
}
.pl-\\[55px\\] {
    padding-left: 55px
}
.pl-\\[65px\\] {
    padding-left: 65px
}
.pl-\\[8px\\] {
    padding-left: 8px
}
.pl-\\[90px\\] {
    padding-left: 90px
}
.pr-0 {
    padding-right: 0px
}
.pr-10 {
    padding-right: 2.5rem
}
.pr-12 {
    padding-right: 3rem
}
.pr-20 {
    padding-right: 5rem
}
.pr-36 {
    padding-right: 9rem
}
.pr-8 {
    padding-right: 2rem
}
.pr-\\[145px\\] {
    padding-right: 145px
}
.pr-\\[15px\\] {
    padding-right: 15px
}
.pr-\\[17px\\] {
    padding-right: 17px
}
.pr-\\[190px\\] {
    padding-right: 190px
}
.pr-\\[25px\\] {
    padding-right: 25px
}
.pr-\\[30px\\] {
    padding-right: 30px
}
.pr-\\[36px\\] {
    padding-right: 36px
}
.pr-\\[39px\\] {
    padding-right: 39px
}
.pr-\\[40px\\] {
    padding-right: 40px
}
.pr-\\[5\\%\\] {
    padding-right: 5%
}
.pr-\\[50px\\] {
    padding-right: 50px
}
.pr-\\[55px\\] {
    padding-right: 55px
}
.pr-\\[60px\\] {
    padding-right: 60px
}
.pr-\\[70px\\] {
    padding-right: 70px
}
.pr-\\[7px\\] {
    padding-right: 7px
}
.ps-0 {
    padding-inline-start: 0px
}
.pt-0 {
    padding-top: 0px
}
.pt-10 {
    padding-top: 2.5rem
}
.pt-20 {
    padding-top: 5rem
}
.pt-24 {
    padding-top: 6rem
}
.pt-32 {
    padding-top: 8rem
}
.pt-36 {
    padding-top: 9rem
}
.pt-8 {
    padding-top: 2rem
}
.pt-\\[0px\\] {
    padding-top: 0px
}
.pt-\\[1\\%\\] {
    padding-top: 1%
}
.pt-\\[100px\\] {
    padding-top: 100px
}
.pt-\\[10px\\] {
    padding-top: 10px
}
.pt-\\[120px\\] {
    padding-top: 120px
}
.pt-\\[126px\\] {
    padding-top: 126px
}
.pt-\\[130px\\] {
    padding-top: 130px
}
.pt-\\[15px\\] {
    padding-top: 15px
}
.pt-\\[160px\\] {
    padding-top: 160px
}
.pt-\\[177px\\] {
    padding-top: 177px
}
.pt-\\[18px\\] {
    padding-top: 18px
}
.pt-\\[190px\\] {
    padding-top: 190px
}
.pt-\\[200px\\] {
    padding-top: 200px
}
.pt-\\[20px\\] {
    padding-top: 20px
}
.pt-\\[22px\\] {
    padding-top: 22px
}
.pt-\\[25px\\] {
    padding-top: 25px
}
.pt-\\[40px\\] {
    padding-top: 40px
}
.pt-\\[420px\\] {
    padding-top: 420px
}
.pt-\\[5\\%\\] {
    padding-top: 5%
}
.pt-\\[50px\\] {
    padding-top: 50px
}
.pt-\\[5px\\] {
    padding-top: 5px
}
.pt-\\[6\\%\\] {
    padding-top: 6%
}
.pt-\\[6\\.5rem\\] {
    padding-top: 6.5rem
}
.pt-\\[65px\\] {
    padding-top: 65px
}
.pt-\\[6px\\] {
    padding-top: 6px
}
.pt-\\[7\\.5rem\\] {
    padding-top: 7.5rem
}
.pt-\\[70px\\] {
    padding-top: 70px
}
.pt-\\[8\\%\\] {
    padding-top: 8%
}
.pt-\\[80px\\] {
    padding-top: 80px
}
.pt-\\[9\\%\\] {
    padding-top: 9%
}
.pt-\\[90px\\] {
    padding-top: 90px
}
.text-left {
    text-align: left
}
.text-center {
    text-align: center
}
.text-right {
    text-align: right
}
.text-justify {
    text-align: justify
}
.text-start {
    text-align: start
}
.text-end {
    text-align: end
}
.align-top {
    vertical-align: top
}
.align-middle {
    vertical-align: middle
}
.align-bottom {
    vertical-align: bottom
}
.font-sans {
    font-family: Roboto, sans-serif
}
.font-serif {
    font-family: Poppins, sans-serif
}
.\\!text-\\[13px\\] {
    font-size: 13px !important
}
.\\!text-\\[47px\\] {
    font-size: 47px !important
}
.\\!text-\\[50px\\] {
    font-size: 50px !important
}
.\\!text-md {
    font-size: 14px !important;
    line-height: 20px !important
}
.\\!text-sm {
    font-size: 13px !important;
    line-height: 22px !important
}
.\\!text-xs {
    font-size: 12px !important;
    line-height: 16px !important
}
.text-\\[100px\\] {
    font-size: 100px
}
.text-\\[10px\\] {
    font-size: 10px
}
.text-\\[11px\\] {
    font-size: 11px
}
.text-\\[11rem\\] {
    font-size: 11rem
}
.text-\\[124px\\] {
    font-size: 124px
}
.text-\\[12px\\] {
    font-size: 12px
}
.text-\\[130px\\] {
    font-size: 130px
}
.text-\\[13px\\] {
    font-size: 13px
}
.text-\\[14px\\] {
    font-size: 14px
}
.text-\\[150px\\] {
    font-size: 150px
}
.text-\\[154px\\] {
    font-size: 154px
}
.text-\\[15px\\] {
    font-size: 15px
}
.text-\\[16px\\] {
    font-size: 16px
}
.text-\\[17px\\] {
    font-size: 17px
}
.text-\\[18px\\] {
    font-size: 18px
}
.text-\\[19px\\] {
    font-size: 19px
}
.text-\\[2\\.3rem\\] {
    font-size: 2.3rem
}
.text-\\[2\\.85rem\\] {
    font-size: 2.85rem
}
.text-\\[200px\\] {
    font-size: 200px
}
.text-\\[20px\\] {
    font-size: 20px
}
.text-\\[21px\\] {
    font-size: 21px
}
.text-\\[230px\\] {
    font-size: 230px
}
.text-\\[235px\\] {
    font-size: 235px
}
.text-\\[24px\\] {
    font-size: 24px
}
.text-\\[255px\\] {
    font-size: 255px
}
.text-\\[25px\\] {
    font-size: 25px
}
.text-\\[26px\\] {
    font-size: 26px
}
.text-\\[28px\\] {
    font-size: 28px
}
.text-\\[3\\.4rem\\] {
    font-size: 3.4rem
}
.text-\\[3\\.9rem\\] {
    font-size: 3.9rem
}
.text-\\[300px\\] {
    font-size: 300px
}
.text-\\[30px\\] {
    font-size: 30px
}
.text-\\[310px\\] {
    font-size: 310px
}
.text-\\[32px\\] {
    font-size: 32px
}
.text-\\[34px\\] {
    font-size: 34px
}
.text-\\[35px\\] {
    font-size: 35px
}
.text-\\[36px\\] {
    font-size: 36px
}
.text-\\[37px\\] {
    font-size: 37px
}
.text-\\[40px\\] {
    font-size: 40px
}
.text-\\[42px\\] {
    font-size: 42px
}
.text-\\[47px\\] {
    font-size: 47px
}
.text-\\[50px\\] {
    font-size: 50px
}
.text-\\[55px\\] {
    font-size: 55px
}
.text-\\[60px\\] {
    font-size: 60px
}
.text-\\[67px\\] {
    font-size: 67px
}
.text-\\[70px\\] {
    font-size: 70px
}
.text-\\[80px\\] {
    font-size: 80px
}
.text-\\[81px\\] {
    font-size: 81px
}
.text-\\[85px\\] {
    font-size: 85px
}
.text-\\[8px\\] {
    font-size: 8px
}
.text-\\[90px\\] {
    font-size: 90px
}
.text-\\[9px\\] {
    font-size: 9px
}
.text-base {
    font-size: 15px;
    line-height: 30px
}
.text-lg {
    font-size: 18px;
    line-height: 22px
}
.text-md {
    font-size: 14px;
    line-height: 20px
}
.text-sm {
    font-size: 13px;
    line-height: 22px
}
.text-xlg {
    font-size: 20px;
    line-height: 28px
}
.text-xmd {
    font-size: 16px;
    line-height: 28px
}
.text-xs {
    font-size: 12px;
    line-height: 16px
}
.text-xxs {
    font-size: 11px;
    line-height: 14px
}
.\\!font-normal {
    font-weight: 400 !important
}
.\\!font-semibold {
    font-weight: 600 !important
}
.font-bold {
    font-weight: 700
}
.font-extrabold {
    font-weight: 800
}
.font-extralight {
    font-weight: 200
}
.font-light {
    font-weight: 300
}
.font-medium {
    font-weight: 500
}
.font-normal {
    font-weight: 400
}
.font-semibold {
    font-weight: 600
}
.font-thin {
    font-weight: 100
}
.uppercase {
    text-transform: uppercase
}
.capitalize {
    text-transform: capitalize
}
.\\!leading-\\[1\\.7\\] {
    line-height: 1.7 !important
}
.\\!leading-\\[18px\\] {
    line-height: 18px !important
}
.\\!leading-\\[20px\\] {
    line-height: 20px !important
}
.\\!leading-\\[22px\\] {
    line-height: 22px !important
}
.\\!leading-\\[25px\\] {
    line-height: 25px !important
}
.\\!leading-\\[30px\\] {
    line-height: 30px !important
}
.leading-10 {
    line-height: 2.5rem
}
.leading-4 {
    line-height: 1rem
}
.leading-5 {
    line-height: 1.25rem
}
.leading-6 {
    line-height: 1.5rem
}
.leading-9 {
    line-height: 2.25rem
}
.leading-\\[0\\] {
    line-height: 0
}
.leading-\\[100px\\] {
    line-height: 100px
}
.leading-\\[11px\\] {
    line-height: 11px
}
.leading-\\[11rem\\] {
    line-height: 11rem
}
.leading-\\[120px\\] {
    line-height: 120px
}
.leading-\\[12px\\] {
    line-height: 12px
}
.leading-\\[13px\\] {
    line-height: 13px
}
.leading-\\[140px\\] {
    line-height: 140px
}
.leading-\\[14px\\] {
    line-height: 14px
}
.leading-\\[154px\\] {
    line-height: 154px
}
.leading-\\[15px\\] {
    line-height: 15px
}
.leading-\\[16px\\] {
    line-height: 16px
}
.leading-\\[170px\\] {
    line-height: 170px
}
.leading-\\[17px\\] {
    line-height: 17px
}
.leading-\\[18px\\] {
    line-height: 18px
}
.leading-\\[19px\\] {
    line-height: 19px
}
.leading-\\[1\\] {
    line-height: 1
}
.leading-\\[200px\\] {
    line-height: 200px
}
.leading-\\[20px\\] {
    line-height: 20px
}
.leading-\\[22px\\] {
    line-height: 22px
}
.leading-\\[230px\\] {
    line-height: 230px
}
.leading-\\[235px\\] {
    line-height: 235px
}
.leading-\\[23px\\] {
    line-height: 23px
}
.leading-\\[24px\\] {
    line-height: 24px
}
.leading-\\[250px\\] {
    line-height: 250px
}
.leading-\\[255px\\] {
    line-height: 255px
}
.leading-\\[25px\\] {
    line-height: 25px
}
.leading-\\[260px\\] {
    line-height: 260px
}
.leading-\\[26px\\] {
    line-height: 26px
}
.leading-\\[28px\\] {
    line-height: 28px
}
.leading-\\[3\\.4rem\\] {
    line-height: 3.4rem
}
.leading-\\[300px\\] {
    line-height: 300px
}
.leading-\\[30px\\] {
    line-height: 30px
}
.leading-\\[32px\\] {
    line-height: 32px
}
.leading-\\[33px\\] {
    line-height: 33px
}
.leading-\\[34px\\] {
    line-height: 34px
}
.leading-\\[35px\\] {
    line-height: 35px
}
.leading-\\[36px\\] {
    line-height: 36px
}
.leading-\\[38px\\] {
    line-height: 38px
}
.leading-\\[3rem\\] {
    line-height: 3rem
}
.leading-\\[4\\.2rem\\] {
    line-height: 4.2rem
}
.leading-\\[40px\\] {
    line-height: 40px
}
.leading-\\[42px\\] {
    line-height: 42px
}
.leading-\\[44px\\] {
    line-height: 44px
}
.leading-\\[45px\\] {
    line-height: 45px
}
.leading-\\[46px\\] {
    line-height: 46px
}
.leading-\\[49px\\] {
    line-height: 49px
}
.leading-\\[50px\\] {
    line-height: 50px
}
.leading-\\[62px\\] {
    line-height: 62px
}
.leading-\\[65px\\] {
    line-height: 65px
}
.leading-\\[70px\\] {
    line-height: 70px
}
.leading-\\[71px\\] {
    line-height: 71px
}
.leading-\\[72px\\] {
    line-height: 72px
}
.leading-\\[80px\\] {
    line-height: 80px
}
.leading-\\[85px\\] {
    line-height: 85px
}
.leading-\\[86px\\] {
    line-height: 86px
}
.leading-\\[90px\\] {
    line-height: 90px
}
.leading-\\[95px\\] {
    line-height: 95px
}
.leading-\\[initial\\] {
    line-height: initial
}
.leading-none {
    line-height: 1
}
.leading-normal {
    line-height: 1.5
}
.\\!tracking-\\[\\.5px\\] {
    letter-spacing: .5px !important
}
.\\!tracking-\\[0px\\] {
    letter-spacing: 0px !important
}
.\\!tracking-normal {
    letter-spacing: 0em !important
}
.-tracking-\\[\\.5px\\] {
    letter-spacing: -.5px
}
.-tracking-\\[0\\.5px\\] {
    letter-spacing: -0.5px
}
.-tracking-\\[10px\\] {
    letter-spacing: -10px
}
.-tracking-\\[12px\\] {
    letter-spacing: -12px
}
.-tracking-\\[1px\\] {
    letter-spacing: -1px
}
.-tracking-\\[2px\\] {
    letter-spacing: -2px
}
.-tracking-\\[3px\\] {
    letter-spacing: -3px
}
.-tracking-\\[4px\\] {
    letter-spacing: -4px
}
.-tracking-\\[5px\\] {
    letter-spacing: -5px
}
.-tracking-\\[6px\\] {
    letter-spacing: -6px
}
.-tracking-\\[7px\\] {
    letter-spacing: -7px
}
.-tracking-\\[8px\\] {
    letter-spacing: -8px
}
.tracking-\\[-\\.5px\\] {
    letter-spacing: -.5px
}
.tracking-\\[-0\\.5px\\] {
    letter-spacing: -0.5px
}
.tracking-\\[-10px\\] {
    letter-spacing: -10px
}
.tracking-\\[-12px\\] {
    letter-spacing: -12px
}
.tracking-\\[-1px\\] {
    letter-spacing: -1px
}
.tracking-\\[-2px\\] {
    letter-spacing: -2px
}
.tracking-\\[-3px\\] {
    letter-spacing: -3px
}
.tracking-\\[-4px\\] {
    letter-spacing: -4px
}
.tracking-\\[-5px\\] {
    letter-spacing: -5px
}
.tracking-\\[-6px\\] {
    letter-spacing: -6px
}
.tracking-\\[-7px\\] {
    letter-spacing: -7px
}
.tracking-\\[\\.5px\\] {
    letter-spacing: .5px
}
.tracking-\\[0\\.5px\\] {
    letter-spacing: 0.5px
}
.tracking-\\[19px\\] {
    letter-spacing: 19px
}
.tracking-\\[1px\\] {
    letter-spacing: 1px
}
.tracking-\\[2px\\] {
    letter-spacing: 2px
}
.tracking-\\[3px\\] {
    letter-spacing: 3px
}
.tracking-\\[4px\\] {
    letter-spacing: 4px
}
.tracking-\\[5px\\] {
    letter-spacing: 5px
}
.tracking-normal {
    letter-spacing: 0em
}
.tracking-tight {
    letter-spacing: -0.025em
}
.\\!text-fastblue {
    --tw-text-opacity: 1 !important;
    color: rgb(0 56 227 / var(--tw-text-opacity)) !important
}
.text-\\[\\#000\\] {
    --tw-text-opacity: 1;
    color: rgb(0 0 0 / var(--tw-text-opacity))
}
.text-\\[\\#0038e2\\] {
    --tw-text-opacity: 1;
    color: rgb(0 56 226 / var(--tw-text-opacity))
}
.text-\\[\\#00aced\\] {
    --tw-text-opacity: 1;
    color: rgb(0 172 237 / var(--tw-text-opacity))
}
.text-\\[\\#00b8b8\\] {
    --tw-text-opacity: 1;
    color: rgb(0 184 184 / var(--tw-text-opacity))
}
.text-\\[\\#212529\\] {
    --tw-text-opacity: 1;
    color: rgb(33 37 41 / var(--tw-text-opacity))
}
.text-\\[\\#262b35\\] {
    --tw-text-opacity: 1;
    color: rgb(38 43 53 / var(--tw-text-opacity))
}
.text-\\[\\#27ae60\\] {
    --tw-text-opacity: 1;
    color: rgb(39 174 96 / var(--tw-text-opacity))
}
.text-\\[\\#2ed47c\\] {
    --tw-text-opacity: 1;
    color: rgb(46 212 124 / var(--tw-text-opacity))
}
.text-\\[\\#2f2f2f\\] {
    --tw-text-opacity: 1;
    color: rgb(47 47 47 / var(--tw-text-opacity))
}
.text-\\[\\#333045\\] {
    --tw-text-opacity: 1;
    color: rgb(51 48 69 / var(--tw-text-opacity))
}
.text-\\[\\#333\\] {
    --tw-text-opacity: 1;
    color: rgb(51 51 51 / var(--tw-text-opacity))
}
.text-\\[\\#374162\\] {
    --tw-text-opacity: 1;
    color: rgb(55 65 98 / var(--tw-text-opacity))
}
.text-\\[\\#3b5998\\] {
    --tw-text-opacity: 1;
    color: rgb(59 89 152 / var(--tw-text-opacity))
}
.text-\\[\\#502e95\\] {
    --tw-text-opacity: 1;
    color: rgb(80 46 149 / var(--tw-text-opacity))
}
.text-\\[\\#728a70\\] {
    --tw-text-opacity: 1;
    color: rgb(114 138 112 / var(--tw-text-opacity))
}
.text-\\[\\#757575\\] {
    --tw-text-opacity: 1;
    color: rgb(117 117 117 / var(--tw-text-opacity))
}
.text-\\[\\#7F8082\\] {
    --tw-text-opacity: 1;
    color: rgb(127 128 130 / var(--tw-text-opacity))
}
.text-\\[\\#7e7e7e\\] {
    --tw-text-opacity: 1;
    color: rgb(126 126 126 / var(--tw-text-opacity))
}
.text-\\[\\#828282\\] {
    --tw-text-opacity: 1;
    color: rgb(130 130 130 / var(--tw-text-opacity))
}
.text-\\[\\#878787\\] {
    --tw-text-opacity: 1;
    color: rgb(135 135 135 / var(--tw-text-opacity))
}
.text-\\[\\#89af44\\] {
    --tw-text-opacity: 1;
    color: rgb(137 175 68 / var(--tw-text-opacity))
}
.text-\\[\\#8bb867\\] {
    --tw-text-opacity: 1;
    color: rgb(139 184 103 / var(--tw-text-opacity))
}
.text-\\[\\#969896\\] {
    --tw-text-opacity: 1;
    color: rgb(150 152 150 / var(--tw-text-opacity))
}
.text-\\[\\#986248\\] {
    --tw-text-opacity: 1;
    color: rgb(152 98 72 / var(--tw-text-opacity))
}
.text-\\[\\#a6aabe\\] {
    --tw-text-opacity: 1;
    color: rgb(166 170 190 / var(--tw-text-opacity))
}
.text-\\[\\#abadb7\\] {
    --tw-text-opacity: 1;
    color: rgb(171 173 183 / var(--tw-text-opacity))
}
.text-\\[\\#b7b7b7\\] {
    --tw-text-opacity: 1;
    color: rgb(183 183 183 / var(--tw-text-opacity))
}
.text-\\[\\#bf8c4c\\] {
    --tw-text-opacity: 1;
    color: rgb(191 140 76 / var(--tw-text-opacity))
}
.text-\\[\\#c3964e\\] {
    --tw-text-opacity: 1;
    color: rgb(195 150 78 / var(--tw-text-opacity))
}
.text-\\[\\#c89965\\] {
    --tw-text-opacity: 1;
    color: rgb(200 153 101 / var(--tw-text-opacity))
}
.text-\\[\\#ca7741\\] {
    --tw-text-opacity: 1;
    color: rgb(202 119 65 / var(--tw-text-opacity))
}
.text-\\[\\#ca943d\\] {
    --tw-text-opacity: 1;
    color: rgb(202 148 61 / var(--tw-text-opacity))
}
.text-\\[\\#e05fc4\\] {
    --tw-text-opacity: 1;
    color: rgb(224 95 196 / var(--tw-text-opacity))
}
.text-\\[\\#e6994e\\] {
    --tw-text-opacity: 1;
    color: rgb(230 153 78 / var(--tw-text-opacity))
}
.text-\\[\\#e6dfdf\\] {
    --tw-text-opacity: 1;
    color: rgb(230 223 223 / var(--tw-text-opacity))
}
.text-\\[\\#ea4c89\\] {
    --tw-text-opacity: 1;
    color: rgb(234 76 137 / var(--tw-text-opacity))
}
.text-\\[\\#ea9d8d\\] {
    --tw-text-opacity: 1;
    color: rgb(234 157 141 / var(--tw-text-opacity))
}
.text-\\[\\#ededed\\] {
    --tw-text-opacity: 1;
    color: rgb(237 237 237 / var(--tw-text-opacity))
}
.text-\\[\\#f18c8c\\] {
    --tw-text-opacity: 1;
    color: rgb(241 140 140 / var(--tw-text-opacity))
}
.text-\\[\\#f4d956\\] {
    --tw-text-opacity: 1;
    color: rgb(244 217 86 / var(--tw-text-opacity))
}
.text-\\[\\#fa5c47\\] {
    --tw-text-opacity: 1;
    color: rgb(250 92 71 / var(--tw-text-opacity))
}
.text-\\[\\#fb4f58\\] {
    --tw-text-opacity: 1;
    color: rgb(251 79 88 / var(--tw-text-opacity))
}
.text-\\[\\#fd961e\\] {
    --tw-text-opacity: 1;
    color: rgb(253 150 30 / var(--tw-text-opacity))
}
.text-\\[\\#fe1f49\\] {
    --tw-text-opacity: 1;
    color: rgb(254 31 73 / var(--tw-text-opacity))
}
.text-\\[\\#ff6437\\] {
    --tw-text-opacity: 1;
    color: rgb(255 100 55 / var(--tw-text-opacity))
}
.text-\\[\\#ff9c00\\] {
    --tw-text-opacity: 1;
    color: rgb(255 156 0 / var(--tw-text-opacity))
}
.text-\\[\\#ffcc2e\\] {
    --tw-text-opacity: 1;
    color: rgb(255 204 46 / var(--tw-text-opacity))
}
.text-\\[\\#ffeb04\\] {
    --tw-text-opacity: 1;
    color: rgb(255 235 4 / var(--tw-text-opacity))
}
.text-\\[\\#fff\\] {
    --tw-text-opacity: 1;
    color: rgb(255 255 255 / var(--tw-text-opacity))
}
.text-\\[\\#ffffff66\\] {
    color: #ffffff66
}
.text-\\[\\#ffffff80\\] {
    color: #ffffff80
}
.text-\\[\\#ffffff\\] {
    --tw-text-opacity: 1;
    color: rgb(255 255 255 / var(--tw-text-opacity))
}
.text-\\[\\#ffffffb3\\] {
    color: #ffffffb3
}
.text-black {
    --tw-text-opacity: 1;
    color: rgb(0 0 0 / var(--tw-text-opacity))
}
.text-coolgray {
    --tw-text-opacity: 1;
    color: rgb(214 213 213 / var(--tw-text-opacity))
}
.text-darkgray {
    --tw-text-opacity: 1;
    color: rgb(35 35 35 / var(--tw-text-opacity))
}
.text-darkslateblue {
    --tw-text-opacity: 1;
    color: rgb(31 35 44 / var(--tw-text-opacity))
}
.text-error {
    --tw-text-opacity: 1;
    color: rgb(255 0 0 / var(--tw-text-opacity))
}
.text-fastblue {
    --tw-text-opacity: 1;
    color: rgb(0 56 227 / var(--tw-text-opacity))
}
.text-gray-900 {
    --tw-text-opacity: 1;
    color: rgb(17 24 39 / var(--tw-text-opacity))
}
.text-inherit {
    color: inherit
}
.text-lightgray {
    --tw-text-opacity: 1;
    color: rgb(247 247 247 / var(--tw-text-opacity))
}
.text-neonorange {
    --tw-text-opacity: 1;
    color: rgb(255 122 86 / var(--tw-text-opacity))
}
.text-red-500 {
    --tw-text-opacity: 1;
    color: rgb(239 68 68 / var(--tw-text-opacity))
}
.text-slateblue {
    --tw-text-opacity: 1;
    color: rgb(136 144 164 / var(--tw-text-opacity))
}
.text-spanishgray {
    --tw-text-opacity: 1;
    color: rgb(147 147 147 / var(--tw-text-opacity))
}
.text-transparent {
    color: transparent
}
.text-white {
    --tw-text-opacity: 1;
    color: rgb(255 255 255 / var(--tw-text-opacity))
}
.underline {
    text-decoration-line: underline
}
.line-through {
    text-decoration-line: line-through
}
.no-underline {
    text-decoration-line: none
}
.decoration-2 {
    text-decoration-thickness: 2px
}
.underline-offset-1 {
    text-underline-offset: 1px
}
.underline-offset-2 {
    text-underline-offset: 3px
}
.underline-offset-4 {
    text-underline-offset: 4px
}
.underline-offset-8 {
    text-underline-offset: 8px
}
.underline-offset-\\[11px\\] {
    text-underline-offset: 11px
}
.underline-offset-\\[6px\\] {
    text-underline-offset: 6px
}
.underline-offset-auto {
    text-underline-offset: auto
}
.placeholder-\\[\\#A6A6A6\\]::placeholder {
    --tw-placeholder-opacity: 1;
    color: rgb(166 166 166 / var(--tw-placeholder-opacity))
}
.opacity-10 {
    opacity: 0.1
}
.opacity-100 {
    opacity: 1
}
.opacity-20 {
    opacity: 0.2
}
.opacity-30 {
    opacity: 0.3
}
.opacity-40 {
    opacity: 0.4
}
.opacity-50 {
    opacity: 0.5
}
.opacity-60 {
    opacity: 0.6
}
.opacity-70 {
    opacity: 0.7
}
.opacity-75 {
    opacity: 0.75
}
.opacity-80 {
    opacity: 0.8
}
.opacity-90 {
    opacity: 0.9
}
.opacity-\\[\\.1\\] {
    opacity: .1
}
.opacity-\\[\\.45\\] {
    opacity: .45
}
.opacity-\\[\\.75\\] {
    opacity: .75
}
.opacity-\\[0\\.01\\] {
    opacity: 0.01
}
.opacity-\\[0\\.5\\] {
    opacity: 0.5
}
.opacity-\\[0\\.75\\] {
    opacity: 0.75
}
.opacity-\\[1\\] {
    opacity: 1
}
.shadow {
    --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
    --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)
}
.shadow-\\[0_0_10px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.07\\)\\] {
    --tw-shadow: 0 0 10px rgba(0,0,0,0.07);
    --tw-shadow-colored: 0 0 10px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)
}
.shadow-\\[0_0_15px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.08\\)\\] {
    --tw-shadow: 0 0 15px rgba(0,0,0,0.08);
    --tw-shadow-colored: 0 0 15px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)
}
.shadow-\\[0_0_15px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.1\\)\\] {
    --tw-shadow: 0 0 15px rgba(0,0,0,0.1);
    --tw-shadow-colored: 0 0 15px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)
}
.shadow-\\[0_0_15px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.10\\)\\] {
    --tw-shadow: 0 0 15px rgba(0,0,0,0.10);
    --tw-shadow-colored: 0 0 15px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)
}
.shadow-\\[0_0_15px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.15\\)\\] {
    --tw-shadow: 0 0 15px rgba(0,0,0,0.15);
    --tw-shadow-colored: 0 0 15px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)
}
.shadow-\\[0_0_20px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.08\\)\\] {
    --tw-shadow: 0 0 20px rgba(0,0,0,0.08);
    --tw-shadow-colored: 0 0 20px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)
}
.shadow-\\[0_0_20px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.1\\)\\] {
    --tw-shadow: 0 0 20px rgba(0,0,0,0.1);
    --tw-shadow-colored: 0 0 20px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)
}
.shadow-\\[0_0_20px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.3\\)\\] {
    --tw-shadow: 0 0 20px rgba(0,0,0,0.3);
    --tw-shadow-colored: 0 0 20px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)
}
.shadow-\\[0_0_20px_rgba\\(23\\2c 23\\2c 23\\2c 0\\.25\\)\\] {
    --tw-shadow: 0 0 20px rgba(23,23,23,0.25);
    --tw-shadow-colored: 0 0 20px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)
}
.shadow-\\[0_0_25px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.08\\)\\] {
    --tw-shadow: 0 0 25px rgba(0,0,0,0.08);
    --tw-shadow-colored: 0 0 25px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)
}
.shadow-\\[0_0_30px_rgb\\(0\\2c 0\\2c 0\\2c 0\\.08\\)\\] {
    --tw-shadow: 0 0 30px rgb(0,0,0,0.08);
    --tw-shadow-colored: 0 0 30px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)
}
.shadow-\\[0_0_30px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.08\\)\\] {
    --tw-shadow: 0 0 30px rgba(0,0,0,0.08);
    --tw-shadow-colored: 0 0 30px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)
}
.shadow-\\[0_0_30px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.1\\)\\] {
    --tw-shadow: 0 0 30px rgba(0,0,0,0.1);
    --tw-shadow-colored: 0 0 30px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)
}
.shadow-\\[0_0_35px_rgba\\(40\\2c 42\\2c 54\\2c 0\\.18\\)\\] {
    --tw-shadow: 0 0 35px rgba(40,42,54,0.18);
    --tw-shadow-colored: 0 0 35px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)
}
.shadow-\\[0_0_45px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.25\\)\\] {
    --tw-shadow: 0 0 45px rgba(0,0,0,0.25);
    --tw-shadow-colored: 0 0 45px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)
}
.shadow-\\[0_0_60px_rgba\\(0\\2c 0\\2c 0\\2c 17\\%\\)\\] {
    --tw-shadow: 0 0 60px rgba(0,0,0,17%);
    --tw-shadow-colored: 0 0 60px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)
}
.shadow-\\[0_0_8px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.06\\)\\] {
    --tw-shadow: 0 0 8px rgba(0,0,0,0.06);
    --tw-shadow-colored: 0 0 8px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)
}
.shadow-lg {
    --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
    --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)
}
.shadow-md {
    --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
    --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)
}
.shadow-none {
    --tw-shadow: 0 0 #0000;
    --tw-shadow-colored: 0 0 #0000;
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)
}
.shadow-xl {
    --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
    --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)
}
.shadow-black {
    --tw-shadow-color: #000;
    --tw-shadow: var(--tw-shadow-colored)
}
.shadow-darkgray {
    --tw-shadow-color: #232323;
    --tw-shadow: var(--tw-shadow-colored)
}
.blur {
    --tw-blur: blur(8px);
    filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow)
}
.blur-\\[30px\\] {
    --tw-blur: blur(30px);
    filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow)
}
.drop-shadow {
    --tw-drop-shadow: drop-shadow(0 1px 2px rgb(0 0 0 / 0.1)) drop-shadow(0 1px 1px rgb(0 0 0 / 0.06));
    filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow)
}
.drop-shadow-2xl {
    --tw-drop-shadow: drop-shadow(0 25px 25px rgb(0 0 0 / 0.15));
    filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow)
}
.drop-shadow-\\[0_0_15px_rgb\\(0\\2c 0\\2c 0\\2c 0\\.08\\)\\] {
    --tw-drop-shadow: drop-shadow(0 0 15px rgb(0,0,0,0.08));
    filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow)
}
.drop-shadow-\\[0_0_15px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.1\\)\\] {
    --tw-drop-shadow: drop-shadow(0 0 15px rgba(0,0,0,0.1));
    filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow)
}
.drop-shadow-lg {
    --tw-drop-shadow: drop-shadow(0 10px 8px rgb(0 0 0 / 0.04)) drop-shadow(0 4px 3px rgb(0 0 0 / 0.1));
    filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow)
}
.drop-shadow-md {
    --tw-drop-shadow: drop-shadow(0 4px 3px rgb(0 0 0 / 0.07)) drop-shadow(0 2px 2px rgb(0 0 0 / 0.06));
    filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow)
}
.grayscale {
    --tw-grayscale: grayscale(100%);
    filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow)
}
.invert {
    --tw-invert: invert(100%);
    filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow)
}
.filter {
    filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow)
}
.transition {
    transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
    transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
    transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 150ms
}
.transition-all {
    transition-property: all;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 150ms
}
.duration-100 {
    transition-duration: 100ms
}
.duration-150 {
    transition-duration: 150ms
}
.will-change-transform {
    will-change: transform
}
.before\\:absolute::before {
    content: var(--tw-content);
    position: absolute
}
.before\\:bottom-\\[-5px\\]::before {
    content: var(--tw-content);
    bottom: -5px
}
.before\\:left-0::before {
    content: var(--tw-content);
    left: 0px
}
.before\\:left-\\[-2px\\]::before {
    content: var(--tw-content);
    left: -2px
}
.before\\:top-\\[4px\\]::before {
    content: var(--tw-content);
    top: 4px
}
.before\\:top-\\[7px\\]::before {
    content: var(--tw-content);
    top: 7px
}
.before\\:top-\\[8px\\]::before {
    content: var(--tw-content);
    top: 8px
}
.before\\:h-\\[12px\\]::before {
    content: var(--tw-content);
    height: 12px
}
.before\\:w-\\[2px\\]::before {
    content: var(--tw-content);
    width: 2px
}
.before\\:border-l-\\[2px\\]::before {
    content: var(--tw-content);
    border-left-width: 2px
}
.before\\:border-darkgray::before {
    content: var(--tw-content);
    --tw-border-opacity: 1;
    border-color: rgb(35 35 35 / var(--tw-border-opacity))
}
.before\\:bg-\\[\\#89af44\\]::before {
    content: var(--tw-content);
    --tw-bg-opacity: 1;
    background-color: rgb(137 175 68 / var(--tw-bg-opacity))
}
.before\\:bg-darkgray::before {
    content: var(--tw-content);
    --tw-bg-opacity: 1;
    background-color: rgb(35 35 35 / var(--tw-bg-opacity))
}
.before\\:content-\\[\\'\\'\\]::before {
    --tw-content: '';
    content: var(--tw-content)
}
.after\\:absolute::after {
    content: var(--tw-content);
    position: absolute
}
.after\\:\\!-bottom-\\[5px\\]::after {
    content: var(--tw-content);
    bottom: -5px !important
}
.after\\:right-0::after {
    content: var(--tw-content);
    right: 0px
}
.after\\:z-\\[12\\]::after {
    content: var(--tw-content);
    z-index: 12
}
.after\\:hidden::after {
    content: var(--tw-content);
    display: none
}
.after\\:h-\\[1px\\]::after {
    content: var(--tw-content);
    height: 1px
}
.after\\:h-\\[28px\\]::after {
    content: var(--tw-content);
    height: 28px
}
.after\\:h-\\[2px\\]::after {
    content: var(--tw-content);
    height: 2px
}
.after\\:w-\\[1px\\]::after {
    content: var(--tw-content);
    width: 1px
}
.after\\:border-b::after {
    content: var(--tw-content);
    border-bottom-width: 1px
}
.after\\:border-darkgray::after {
    content: var(--tw-content);
    --tw-border-opacity: 1;
    border-color: rgb(35 35 35 / var(--tw-border-opacity))
}
.after\\:bg-\\[\\#000\\]::after {
    content: var(--tw-content);
    --tw-bg-opacity: 1;
    background-color: rgb(0 0 0 / var(--tw-bg-opacity))
}
.after\\:bg-\\[\\#2ed47c\\]::after {
    content: var(--tw-content);
    --tw-bg-opacity: 1;
    background-color: rgb(46 212 124 / var(--tw-bg-opacity))
}
.after\\:bg-\\[\\#333045\\]::after {
    content: var(--tw-content);
    --tw-bg-opacity: 1;
    background-color: rgb(51 48 69 / var(--tw-bg-opacity))
}
.after\\:bg-\\[\\#374162\\]::after {
    content: var(--tw-content);
    --tw-bg-opacity: 1;
    background-color: rgb(55 65 98 / var(--tw-bg-opacity))
}
.after\\:bg-\\[\\#72717159\\]::after {
    content: var(--tw-content);
    background-color: #72717159
}
.after\\:bg-\\[\\#828282\\]::after {
    content: var(--tw-content);
    --tw-bg-opacity: 1;
    background-color: rgb(130 130 130 / var(--tw-bg-opacity))
}
.after\\:bg-\\[\\#c7da26\\]::after {
    content: var(--tw-content);
    --tw-bg-opacity: 1;
    background-color: rgb(199 218 38 / var(--tw-bg-opacity))
}
.after\\:bg-\\[\\#fff\\]::after {
    content: var(--tw-content);
    --tw-bg-opacity: 1;
    background-color: rgb(255 255 255 / var(--tw-bg-opacity))
}
.after\\:bg-black::after {
    content: var(--tw-content);
    --tw-bg-opacity: 1;
    background-color: rgb(0 0 0 / var(--tw-bg-opacity))
}
.after\\:bg-darkgray::after {
    content: var(--tw-content);
    --tw-bg-opacity: 1;
    background-color: rgb(35 35 35 / var(--tw-bg-opacity))
}
.after\\:bg-fastblue::after {
    content: var(--tw-content);
    --tw-bg-opacity: 1;
    background-color: rgb(0 56 227 / var(--tw-bg-opacity))
}
.after\\:bg-spanishgray::after {
    content: var(--tw-content);
    --tw-bg-opacity: 1;
    background-color: rgb(147 147 147 / var(--tw-bg-opacity))
}
.after\\:bg-transparent::after {
    content: var(--tw-content);
    background-color: transparent
}
.after\\:bg-white::after {
    content: var(--tw-content);
    --tw-bg-opacity: 1;
    background-color: rgb(255 255 255 / var(--tw-bg-opacity))
}
.after\\:bg-gradient-to-tr::after {
    content: var(--tw-content);
    background-image: linear-gradient(to top right, var(--tw-gradient-stops))
}
.after\\:from-\\[\\#b783ff\\]::after {
    content: var(--tw-content);
    --tw-gradient-from: #b783ff var(--tw-gradient-from-position);
    --tw-gradient-to: rgb(183 131 255 / 0) var(--tw-gradient-to-position);
    --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to)
}
.after\\:to-\\[\\#e37be0\\]::after {
    content: var(--tw-content);
    --tw-gradient-to: #e37be0 var(--tw-gradient-to-position)
}
.after\\:text-\\[500px\\]::after {
    content: var(--tw-content);
    font-size: 500px
}
.after\\:text-white::after {
    content: var(--tw-content);
    --tw-text-opacity: 1;
    color: rgb(255 255 255 / var(--tw-text-opacity))
}
.last\\:m-0:last-child {
    margin: 0px
}
.last\\:mb-0:last-child {
    margin-bottom: 0px
}
.last\\:\\!pr-\\[0px\\]:last-child {
    padding-right: 0px !important
}
.last-of-type\\:border-0:last-of-type {
    border-width: 0px
}
.placeholder-shown\\:text-black:placeholder-shown {
    --tw-text-opacity: 1;
    color: rgb(0 0 0 / var(--tw-text-opacity))
}
.hover\\:-translate-y-\\[2px\\]:hover {
    --tw-translate-y: -2px;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))
}
.hover\\:translate-y-\\[-3px\\]:hover {
    --tw-translate-y: -3px;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))
}
.hover\\:border-\\[\\#004dc0\\]:hover {
    --tw-border-opacity: 1;
    border-color: rgb(0 77 192 / var(--tw-border-opacity))
}
.hover\\:border-\\[\\#075f36\\]:hover {
    --tw-border-opacity: 1;
    border-color: rgb(7 95 54 / var(--tw-border-opacity))
}
.hover\\:border-\\[\\#08c5eb\\]:hover {
    --tw-border-opacity: 1;
    border-color: rgb(8 197 235 / var(--tw-border-opacity))
}
.hover\\:border-\\[\\#ac1221\\]:hover {
    --tw-border-opacity: 1;
    border-color: rgb(172 18 33 / var(--tw-border-opacity))
}
.hover\\:border-\\[\\#f0b609\\]:hover {
    --tw-border-opacity: 1;
    border-color: rgb(240 182 9 / var(--tw-border-opacity))
}
.hover\\:border-fastblue:hover {
    --tw-border-opacity: 1;
    border-color: rgb(0 56 227 / var(--tw-border-opacity))
}
.hover\\:border-neonorange:hover {
    --tw-border-opacity: 1;
    border-color: rgb(255 122 86 / var(--tw-border-opacity))
}
.hover\\:border-transparent:hover {
    border-color: transparent
}
.hover\\:border-white:hover {
    --tw-border-opacity: 1;
    border-color: rgb(255 255 255 / var(--tw-border-opacity))
}
.hover\\:bg-\\[\\#000\\]:hover {
    --tw-bg-opacity: 1;
    background-color: rgb(0 0 0 / var(--tw-bg-opacity))
}
.hover\\:bg-\\[\\#0044aa\\]:hover {
    --tw-bg-opacity: 1;
    background-color: rgb(0 68 170 / var(--tw-bg-opacity))
}
.hover\\:bg-\\[\\#075f36\\]:hover {
    --tw-bg-opacity: 1;
    background-color: rgb(7 95 54 / var(--tw-bg-opacity))
}
.hover\\:bg-\\[\\#08c5eb\\]:hover {
    --tw-bg-opacity: 1;
    background-color: rgb(8 197 235 / var(--tw-bg-opacity))
}
.hover\\:bg-\\[\\#ac1221\\]:hover {
    --tw-bg-opacity: 1;
    background-color: rgb(172 18 33 / var(--tw-bg-opacity))
}
.hover\\:bg-\\[\\#f0b609\\]:hover {
    --tw-bg-opacity: 1;
    background-color: rgb(240 182 9 / var(--tw-bg-opacity))
}
.hover\\:bg-\\[\\#fff\\]:hover {
    --tw-bg-opacity: 1;
    background-color: rgb(255 255 255 / var(--tw-bg-opacity))
}
.hover\\:bg-\\[\\#ffffff\\]:hover {
    --tw-bg-opacity: 1;
    background-color: rgb(255 255 255 / var(--tw-bg-opacity))
}
.hover\\:bg-black:hover {
    --tw-bg-opacity: 1;
    background-color: rgb(0 0 0 / var(--tw-bg-opacity))
}
.hover\\:bg-darkgray:hover {
    --tw-bg-opacity: 1;
    background-color: rgb(35 35 35 / var(--tw-bg-opacity))
}
.hover\\:bg-transparent:hover {
    background-color: transparent
}
.hover\\:bg-white:hover {
    --tw-bg-opacity: 1;
    background-color: rgb(255 255 255 / var(--tw-bg-opacity))
}
.hover\\:\\!text-\\[\\#c89965\\]:hover {
    --tw-text-opacity: 1 !important;
    color: rgb(200 153 101 / var(--tw-text-opacity)) !important
}
.hover\\:\\!text-darkgray:hover {
    --tw-text-opacity: 1 !important;
    color: rgb(35 35 35 / var(--tw-text-opacity)) !important
}
.hover\\:text-\\[\\#000\\]:hover {
    --tw-text-opacity: 1;
    color: rgb(0 0 0 / var(--tw-text-opacity))
}
.hover\\:text-\\[\\#0038e3\\]:hover {
    --tw-text-opacity: 1;
    color: rgb(0 56 227 / var(--tw-text-opacity))
}
.hover\\:text-\\[\\#333\\]:hover {
    --tw-text-opacity: 1;
    color: rgb(51 51 51 / var(--tw-text-opacity))
}
.hover\\:text-\\[\\#828282\\]:hover {
    --tw-text-opacity: 1;
    color: rgb(130 130 130 / var(--tw-text-opacity))
}
.hover\\:text-\\[\\#8bb867\\]:hover {
    --tw-text-opacity: 1;
    color: rgb(139 184 103 / var(--tw-text-opacity))
}
.hover\\:text-\\[\\#969896\\]:hover {
    --tw-text-opacity: 1;
    color: rgb(150 152 150 / var(--tw-text-opacity))
}
.hover\\:text-\\[\\#BF8C4C\\]:hover {
    --tw-text-opacity: 1;
    color: rgb(191 140 76 / var(--tw-text-opacity))
}
.hover\\:text-\\[\\#b7b7b7\\]:hover {
    --tw-text-opacity: 1;
    color: rgb(183 183 183 / var(--tw-text-opacity))
}
.hover\\:text-\\[\\#bf8c4c\\]:hover {
    --tw-text-opacity: 1;
    color: rgb(191 140 76 / var(--tw-text-opacity))
}
.hover\\:text-\\[\\#c3964e\\]:hover {
    --tw-text-opacity: 1;
    color: rgb(195 150 78 / var(--tw-text-opacity))
}
.hover\\:text-\\[\\#c89965\\]:hover {
    --tw-text-opacity: 1;
    color: rgb(200 153 101 / var(--tw-text-opacity))
}
.hover\\:text-\\[\\#ca943d\\]:hover {
    --tw-text-opacity: 1;
    color: rgb(202 148 61 / var(--tw-text-opacity))
}
.hover\\:text-\\[\\#ea9d8d\\]:hover {
    --tw-text-opacity: 1;
    color: rgb(234 157 141 / var(--tw-text-opacity))
}
.hover\\:text-\\[\\#fd961e\\]:hover {
    --tw-text-opacity: 1;
    color: rgb(253 150 30 / var(--tw-text-opacity))
}
.hover\\:text-\\[\\#fff\\]:hover {
    --tw-text-opacity: 1;
    color: rgb(255 255 255 / var(--tw-text-opacity))
}
.hover\\:text-\\[\\#ffffff99\\]:hover {
    color: #ffffff99
}
.hover\\:text-black:hover {
    --tw-text-opacity: 1;
    color: rgb(0 0 0 / var(--tw-text-opacity))
}
.hover\\:text-darkgray:hover {
    --tw-text-opacity: 1;
    color: rgb(35 35 35 / var(--tw-text-opacity))
}
.hover\\:text-fastblue:hover {
    --tw-text-opacity: 1;
    color: rgb(0 56 227 / var(--tw-text-opacity))
}
.hover\\:text-neonorange:hover {
    --tw-text-opacity: 1;
    color: rgb(255 122 86 / var(--tw-text-opacity))
}
.hover\\:text-spanishgray:hover {
    --tw-text-opacity: 1;
    color: rgb(147 147 147 / var(--tw-text-opacity))
}
.hover\\:text-white:hover {
    --tw-text-opacity: 1;
    color: rgb(255 255 255 / var(--tw-text-opacity))
}
.hover\\:opacity-100:hover {
    opacity: 1
}
.hover\\:opacity-50:hover {
    opacity: 0.5
}
.hover\\:opacity-70:hover {
    opacity: 0.7
}
.hover\\:shadow-\\[0_0_10px_rgba\\(23\\2c 23\\2c 23\\2c 0\\.10\\)\\]:hover {
    --tw-shadow: 0 0 10px rgba(23,23,23,0.10);
    --tw-shadow-colored: 0 0 10px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)
}
.hover\\:shadow-\\[0_0_15px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.1\\)\\]:hover {
    --tw-shadow: 0 0 15px rgba(0,0,0,0.1);
    --tw-shadow-colored: 0 0 15px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)
}
.hover\\:shadow-\\[0_0_20px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.15\\)\\]:hover {
    --tw-shadow: 0 0 20px rgba(0,0,0,0.15);
    --tw-shadow-colored: 0 0 20px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)
}
.hover\\:shadow-\\[0_0_30px_rgba\\(23\\2c 23\\2c 23\\2c 0\\.40\\)\\]:hover {
    --tw-shadow: 0 0 30px rgba(23,23,23,0.40);
    --tw-shadow-colored: 0 0 30px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)
}
.hover\\:shadow-\\[0_0_35px_rgba\\(40\\2c 42\\2c 54\\2c 0\\.18\\)\\]:hover {
    --tw-shadow: 0 0 35px rgba(40,42,54,0.18);
    --tw-shadow-colored: 0 0 35px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)
}
.hover\\:shadow-xl:hover {
    --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
    --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)
}
@media (max-width: 1600px) {
    .xl\\:-top-\\[90px\\] {
        top: -90px
    }
    .xl\\:bottom-\\[20\\%\\] {
        bottom: 20%
    }
    .xl\\:bottom-\\[30\\%\\] {
        bottom: 30%
    }
    .xl\\:left-\\[-11px\\] {
        left: -11px
    }
    .xl\\:left-\\[10\\%\\] {
        left: 10%
    }
    .xl\\:right-0 {
        right: 0px
    }
    .xl\\:right-\\[-11px\\] {
        right: -11px
    }
    .xl\\:right-\\[370px\\] {
        right: 370px
    }
    .xl\\:z-\\[2\\] {
        z-index: 2
    }
    .xl\\:mx-\\[3\\%\\] {
        margin-left: 3%;
        margin-right: 3%
    }
    .xl\\:mb-0 {
        margin-bottom: 0px
    }
    .xl\\:mb-\\[105px\\] {
        margin-bottom: 105px
    }
    .xl\\:mb-\\[20px\\] {
        margin-bottom: 20px
    }
    .xl\\:mb-\\[25px\\] {
        margin-bottom: 25px
    }
    .xl\\:mb-\\[70px\\] {
        margin-bottom: 70px
    }
    .xl\\:mb-\\[95px\\] {
        margin-bottom: 95px
    }
    .xl\\:block {
        display: block
    }
    .xl\\:hidden {
        display: none
    }
    .xl\\:h-\\[150px\\] {
        height: 150px
    }
    .xl\\:h-\\[500px\\] {
        height: 500px
    }
    .xl\\:h-\\[600px\\] {
        height: 600px
    }
    .xl\\:h-\\[700px\\] {
        height: 700px
    }
    .xl\\:w-\\[100px\\] {
        width: 100px
    }
    .xl\\:w-\\[120\\%\\] {
        width: 120%
    }
    .xl\\:w-\\[40\\%\\] {
        width: 40%
    }
    .xl\\:w-\\[55\\%\\] {
        width: 55%
    }
    .xl\\:w-\\[550px\\] {
        width: 550px
    }
    .xl\\:w-\\[60\\%\\] {
        width: 60%
    }
    .xl\\:w-\\[600px\\] {
        width: 600px
    }
    .xl\\:w-\\[60vw\\] {
        width: 60vw
    }
    .xl\\:w-\\[70\\%\\] {
        width: 70%
    }
    .xl\\:w-\\[700px\\] {
        width: 700px
    }
    .xl\\:w-\\[75\\%\\] {
        width: 75%
    }
    .xl\\:w-\\[80\\%\\] {
        width: 80%
    }
    .xl\\:w-\\[800px\\] {
        width: 800px
    }
    .xl\\:w-\\[85\\%\\] {
        width: 85%
    }
    .xl\\:w-full {
        width: 100%
    }
    .xl\\:scale-50 {
        --tw-scale-x: .5;
        --tw-scale-y: .5;
        transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))
    }
    .xl\\:scale-75 {
        --tw-scale-x: .75;
        --tw-scale-y: .75;
        transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))
    }
    .xl\\:justify-center {
        justify-content: center
    }
    .xl\\:bg-\\[length\\:900px\\] {
        background-size: 900px
    }
    .xl\\:p-12 {
        padding: 3rem
    }
    .xl\\:p-16 {
        padding: 4rem
    }
    .xl\\:p-20 {
        padding: 5rem
    }
    .xl\\:p-32 {
        padding: 8rem
    }
    .xl\\:p-8 {
        padding: 2rem
    }
    .xl\\:p-\\[3rem\\] {
        padding: 3rem
    }
    .xl\\:p-\\[5\\.5rem\\] {
        padding: 5.5rem
    }
    .xl\\:p-\\[50px\\] {
        padding: 50px
    }
    .xl\\:p-\\[6\\%\\] {
        padding: 6%
    }
    .xl\\:p-\\[7\\.5rem\\] {
        padding: 7.5rem
    }
    .xl\\:px-0 {
        padding-left: 0px;
        padding-right: 0px
    }
    .xl\\:px-10 {
        padding-left: 2.5rem;
        padding-right: 2.5rem
    }
    .xl\\:px-12 {
        padding-left: 3rem;
        padding-right: 3rem
    }
    .xl\\:px-14 {
        padding-left: 3.5rem;
        padding-right: 3.5rem
    }
    .xl\\:px-16 {
        padding-left: 4rem;
        padding-right: 4rem
    }
    .xl\\:px-20 {
        padding-left: 5rem;
        padding-right: 5rem
    }
    .xl\\:px-24 {
        padding-left: 6rem;
        padding-right: 6rem
    }
    .xl\\:px-4 {
        padding-left: 1rem;
        padding-right: 1rem
    }
    .xl\\:px-6 {
        padding-left: 1.5rem;
        padding-right: 1.5rem
    }
    .xl\\:px-8 {
        padding-left: 2rem;
        padding-right: 2rem
    }
    .xl\\:px-\\[0px\\] {
        padding-left: 0px;
        padding-right: 0px
    }
    .xl\\:px-\\[1\\%\\] {
        padding-left: 1%;
        padding-right: 1%
    }
    .xl\\:px-\\[10\\%\\] {
        padding-left: 10%;
        padding-right: 10%
    }
    .xl\\:px-\\[15px\\] {
        padding-left: 15px;
        padding-right: 15px
    }
    .xl\\:px-\\[2\\%\\] {
        padding-left: 2%;
        padding-right: 2%
    }
    .xl\\:px-\\[25px\\] {
        padding-left: 25px;
        padding-right: 25px
    }
    .xl\\:px-\\[2rem\\] {
        padding-left: 2rem;
        padding-right: 2rem
    }
    .xl\\:px-\\[3\\%\\] {
        padding-left: 3%;
        padding-right: 3%
    }
    .xl\\:px-\\[3\\.5rem\\] {
        padding-left: 3.5rem;
        padding-right: 3.5rem
    }
    .xl\\:px-\\[30px\\] {
        padding-left: 30px;
        padding-right: 30px
    }
    .xl\\:px-\\[4\\%\\] {
        padding-left: 4%;
        padding-right: 4%
    }
    .xl\\:px-\\[45px\\] {
        padding-left: 45px;
        padding-right: 45px
    }
    .xl\\:px-\\[4rem\\] {
        padding-left: 4rem;
        padding-right: 4rem
    }
    .xl\\:px-\\[5\\%\\] {
        padding-left: 5%;
        padding-right: 5%
    }
    .xl\\:px-\\[50px\\] {
        padding-left: 50px;
        padding-right: 50px
    }
    .xl\\:px-\\[6\\%\\] {
        padding-left: 6%;
        padding-right: 6%
    }
    .xl\\:px-\\[65px\\] {
        padding-left: 65px;
        padding-right: 65px
    }
    .xl\\:py-12 {
        padding-top: 3rem;
        padding-bottom: 3rem
    }
    .xl\\:py-16 {
        padding-top: 4rem;
        padding-bottom: 4rem
    }
    .xl\\:py-20 {
        padding-top: 5rem;
        padding-bottom: 5rem
    }
    .xl\\:py-24 {
        padding-top: 6rem;
        padding-bottom: 6rem
    }
    .xl\\:py-\\[1\\.5rem\\] {
        padding-top: 1.5rem;
        padding-bottom: 1.5rem
    }
    .xl\\:py-\\[120px\\] {
        padding-top: 120px;
        padding-bottom: 120px
    }
    .xl\\:py-\\[20px\\] {
        padding-top: 20px;
        padding-bottom: 20px
    }
    .xl\\:py-\\[25px\\] {
        padding-top: 25px;
        padding-bottom: 25px
    }
    .xl\\:py-\\[30px\\] {
        padding-top: 30px;
        padding-bottom: 30px
    }
    .xl\\:pb-\\[345px\\] {
        padding-bottom: 345px
    }
    .xl\\:pb-\\[450px\\] {
        padding-bottom: 450px
    }
    .xl\\:pb-\\[90px\\] {
        padding-bottom: 90px
    }
    .xl\\:pl-\\[10px\\] {
        padding-left: 10px
    }
    .xl\\:pl-\\[15px\\] {
        padding-left: 15px
    }
    .xl\\:pl-\\[3\\%\\] {
        padding-left: 3%
    }
    .xl\\:pr-0 {
        padding-right: 0px
    }
    .xl\\:text-left {
        text-align: left
    }
    .xl\\:text-start {
        text-align: start
    }
    .xl\\:text-end {
        text-align: end
    }
    .xl\\:text-\\[120px\\] {
        font-size: 120px
    }
    .xl\\:text-\\[200px\\] {
        font-size: 200px
    }
    .xl\\:text-\\[210px\\] {
        font-size: 210px
    }
    .xl\\:text-\\[4rem\\] {
        font-size: 4rem
    }
    .xl\\:text-\\[50px\\] {
        font-size: 50px
    }
    .xl\\:text-xlg {
        font-size: 20px;
        line-height: 28px
    }
    .xl\\:text-xs {
        font-size: 12px;
        line-height: 16px
    }
    .xl\\:leading-\\[200px\\] {
        line-height: 200px
    }
    .xl\\:leading-none {
        line-height: 1
    }
    .xl\\:tracking-\\[-4px\\] {
        letter-spacing: -4px
    }
}
@media (max-width: 1199px) {
    .lg\\:relative {
        position: relative
    }
    .lg\\:\\!left-auto {
        left: auto !important
    }
    .lg\\:\\!right-0 {
        right: 0px !important
    }
    .lg\\:\\!top-0 {
        top: 0px !important
    }
    .lg\\:\\!top-\\[-20px\\] {
        top: -20px !important
    }
    .lg\\:\\!top-\\[130px\\] {
        top: 130px !important
    }
    .lg\\:\\!top-\\[145px\\] {
        top: 145px !important
    }
    .lg\\:\\!top-\\[150px\\] {
        top: 150px !important
    }
    .lg\\:\\!top-\\[20px\\] {
        top: 20px !important
    }
    .lg\\:\\!top-\\[30px\\] {
        top: 30px !important
    }
    .lg\\:-bottom-\\[30px\\] {
        bottom: -30px
    }
    .lg\\:-bottom-\\[65px\\] {
        bottom: -65px
    }
    .lg\\:-top-\\[100px\\] {
        top: -100px
    }
    .lg\\:-top-\\[70px\\] {
        top: -70px
    }
    .lg\\:bottom-0 {
        bottom: 0px
    }
    .lg\\:bottom-\\[-120px\\] {
        bottom: -120px
    }
    .lg\\:bottom-\\[-20px\\] {
        bottom: -20px
    }
    .lg\\:bottom-\\[-25px\\] {
        bottom: -25px
    }
    .lg\\:bottom-\\[-355px\\] {
        bottom: -355px
    }
    .lg\\:bottom-\\[-500px\\] {
        bottom: -500px
    }
    .lg\\:bottom-\\[-80px\\] {
        bottom: -80px
    }
    .lg\\:bottom-\\[0\\] {
        bottom: 0
    }
    .lg\\:bottom-\\[20px\\] {
        bottom: 20px
    }
    .lg\\:bottom-\\[25px\\] {
        bottom: 25px
    }
    .lg\\:bottom-\\[2px\\] {
        bottom: 2px
    }
    .lg\\:left-\\[-12px\\] {
        left: -12px
    }
    .lg\\:left-\\[-99px\\] {
        left: -99px
    }
    .lg\\:left-\\[150px\\] {
        left: 150px
    }
    .lg\\:left-\\[70px\\] {
        left: 70px
    }
    .lg\\:left-auto {
        left: auto
    }
    .lg\\:right-0 {
        right: 0px
    }
    .lg\\:right-\\[-12px\\] {
        right: -12px
    }
    .lg\\:right-\\[100px\\] {
        right: 100px
    }
    .lg\\:right-\\[190px\\] {
        right: 190px
    }
    .lg\\:right-\\[200px\\] {
        right: 200px
    }
    .lg\\:right-\\[300px\\] {
        right: 300px
    }
    .lg\\:right-\\[30px\\] {
        right: 30px
    }
    .lg\\:top-\\[-100px\\] {
        top: -100px
    }
    .lg\\:top-\\[-150px\\] {
        top: -150px
    }
    .lg\\:top-\\[-46px\\] {
        top: -46px
    }
    .lg\\:top-\\[-75px\\] {
        top: -75px
    }
    .lg\\:top-\\[15px\\] {
        top: 15px
    }
    .lg\\:top-\\[80px\\] {
        top: 80px
    }
    .lg\\:m-0 {
        margin: 0px
    }
    .lg\\:mx-0 {
        margin-left: 0px;
        margin-right: 0px
    }
    .lg\\:mx-\\[15px\\] {
        margin-left: 15px;
        margin-right: 15px
    }
    .lg\\:mx-\\[75px\\] {
        margin-left: 75px;
        margin-right: 75px
    }
    .lg\\:mx-auto {
        margin-left: auto;
        margin-right: auto
    }
    .lg\\:\\!ml-\\[10px\\] {
        margin-left: 10px !important
    }
    .lg\\:\\!ml-auto {
        margin-left: auto !important
    }
    .lg\\:mb-0 {
        margin-bottom: 0px
    }
    .lg\\:mb-12 {
        margin-bottom: 3rem
    }
    .lg\\:mb-16 {
        margin-bottom: 4rem
    }
    .lg\\:mb-20 {
        margin-bottom: 5rem
    }
    .lg\\:mb-24 {
        margin-bottom: 6rem
    }
    .lg\\:mb-28 {
        margin-bottom: 7rem
    }
    .lg\\:mb-32 {
        margin-bottom: 8rem
    }
    .lg\\:mb-\\[10px\\] {
        margin-bottom: 10px
    }
    .lg\\:mb-\\[12rem\\] {
        margin-bottom: 12rem
    }
    .lg\\:mb-\\[130px\\] {
        margin-bottom: 130px
    }
    .lg\\:mb-\\[15px\\] {
        margin-bottom: 15px
    }
    .lg\\:mb-\\[245px\\] {
        margin-bottom: 245px
    }
    .lg\\:mb-\\[25px\\] {
        margin-bottom: 25px
    }
    .lg\\:mb-\\[3\\.5rem\\] {
        margin-bottom: 3.5rem
    }
    .lg\\:mb-\\[30px\\] {
        margin-bottom: 30px
    }
    .lg\\:mb-\\[4\\.5rem\\] {
        margin-bottom: 4.5rem
    }
    .lg\\:mb-\\[40px\\] {
        margin-bottom: 40px
    }
    .lg\\:mb-\\[44px\\] {
        margin-bottom: 44px
    }
    .lg\\:mb-\\[45px\\] {
        margin-bottom: 45px
    }
    .lg\\:mb-\\[50px\\] {
        margin-bottom: 50px
    }
    .lg\\:mb-\\[59px\\] {
        margin-bottom: 59px
    }
    .lg\\:mb-\\[60px\\] {
        margin-bottom: 60px
    }
    .lg\\:mb-\\[65px\\] {
        margin-bottom: 65px
    }
    .lg\\:mb-\\[7\\.5rem\\] {
        margin-bottom: 7.5rem
    }
    .lg\\:mb-\\[74px\\] {
        margin-bottom: 74px
    }
    .lg\\:mb-\\[80px\\] {
        margin-bottom: 80px
    }
    .lg\\:mb-\\[84px\\] {
        margin-bottom: 84px
    }
    .lg\\:mb-\\[85px\\] {
        margin-bottom: 85px
    }
    .lg\\:mb-\\[90px\\] {
        margin-bottom: 90px
    }
    .lg\\:mb-\\[95px\\] {
        margin-bottom: 95px
    }
    .lg\\:ml-\\[0px\\] {
        margin-left: 0px
    }
    .lg\\:ml-auto {
        margin-left: auto
    }
    .lg\\:mr-\\[15px\\] {
        margin-right: 15px
    }
    .lg\\:mr-\\[25px\\] {
        margin-right: 25px
    }
    .lg\\:mr-auto {
        margin-right: auto
    }
    .lg\\:mt-0 {
        margin-top: 0px
    }
    .lg\\:mt-16 {
        margin-top: 4rem
    }
    .lg\\:mt-20 {
        margin-top: 5rem
    }
    .lg\\:mt-24 {
        margin-top: 6rem
    }
    .lg\\:mt-36 {
        margin-top: 9rem
    }
    .lg\\:mt-\\[-80px\\] {
        margin-top: -80px
    }
    .lg\\:mt-\\[160px\\] {
        margin-top: 160px
    }
    .lg\\:mt-\\[200px\\] {
        margin-top: 200px
    }
    .lg\\:mt-\\[3\\.5rem\\] {
        margin-top: 3.5rem
    }
    .lg\\:mt-\\[30px\\] {
        margin-top: 30px
    }
    .lg\\:mt-\\[35px\\] {
        margin-top: 35px
    }
    .lg\\:mt-\\[40px\\] {
        margin-top: 40px
    }
    .lg\\:inline-block {
        display: inline-block
    }
    .lg\\:flex {
        display: flex
    }
    .lg\\:hidden {
        display: none
    }
    .lg\\:h-\\[100px\\] {
        height: 100px
    }
    .lg\\:h-\\[198px\\] {
        height: 198px
    }
    .lg\\:h-\\[250px\\] {
        height: 250px
    }
    .lg\\:h-\\[30px\\] {
        height: 30px
    }
    .lg\\:h-\\[400px\\] {
        height: 400px
    }
    .lg\\:h-\\[450px\\] {
        height: 450px
    }
    .lg\\:h-\\[480px\\] {
        height: 480px
    }
    .lg\\:h-\\[490px\\] {
        height: 490px
    }
    .lg\\:h-\\[500px\\] {
        height: 500px
    }
    .lg\\:h-\\[545px\\] {
        height: 545px
    }
    .lg\\:h-\\[550px\\] {
        height: 550px
    }
    .lg\\:h-\\[580px\\] {
        height: 580px
    }
    .lg\\:h-\\[600px\\] {
        height: 600px
    }
    .lg\\:h-\\[635px\\] {
        height: 635px
    }
    .lg\\:h-\\[64vh\\] {
        height: 64vh
    }
    .lg\\:h-\\[650px\\] {
        height: 650px
    }
    .lg\\:h-\\[670px\\] {
        height: 670px
    }
    .lg\\:h-\\[700px\\] {
        height: 700px
    }
    .lg\\:h-\\[70px\\] {
        height: 70px
    }
    .lg\\:h-\\[720px\\] {
        height: 720px
    }
    .lg\\:h-\\[750px\\] {
        height: 750px
    }
    .lg\\:h-\\[80px\\] {
        height: 80px
    }
    .lg\\:h-\\[90px\\] {
        height: 90px
    }
    .lg\\:h-\\[90vh\\] {
        height: 90vh
    }
    .lg\\:h-\\[92vh\\] {
        height: 92vh
    }
    .lg\\:w-1\\/2 {
        width: 50%
    }
    .lg\\:w-2\\/5 {
        width: 40%
    }
    .lg\\:w-3\\/5 {
        width: 60%
    }
    .lg\\:w-\\[100px\\] {
        width: 100px
    }
    .lg\\:w-\\[120px\\] {
        width: 120px
    }
    .lg\\:w-\\[130\\%\\] {
        width: 130%
    }
    .lg\\:w-\\[130px\\] {
        width: 130px
    }
    .lg\\:w-\\[170px\\] {
        width: 170px
    }
    .lg\\:w-\\[20\\%\\] {
        width: 20%
    }
    .lg\\:w-\\[250px\\] {
        width: 250px
    }
    .lg\\:w-\\[260px\\] {
        width: 260px
    }
    .lg\\:w-\\[35\\%\\] {
        width: 35%
    }
    .lg\\:w-\\[350px\\] {
        width: 350px
    }
    .lg\\:w-\\[365px\\] {
        width: 365px
    }
    .lg\\:w-\\[40\\%\\] {
        width: 40%
    }
    .lg\\:w-\\[45\\%\\] {
        width: 45%
    }
    .lg\\:w-\\[50\\%\\] {
        width: 50%
    }
    .lg\\:w-\\[500px\\] {
        width: 500px
    }
    .lg\\:w-\\[55\\%\\] {
        width: 55%
    }
    .lg\\:w-\\[60\\%\\] {
        width: 60%
    }
    .lg\\:w-\\[600px\\] {
        width: 600px
    }
    .lg\\:w-\\[620px\\] {
        width: 620px
    }
    .lg\\:w-\\[65\\%\\] {
        width: 65%
    }
    .lg\\:w-\\[650px\\] {
        width: 650px
    }
    .lg\\:w-\\[65px\\] {
        width: 65px
    }
    .lg\\:w-\\[70\\%\\] {
        width: 70%
    }
    .lg\\:w-\\[70px\\] {
        width: 70px
    }
    .lg\\:w-\\[70vw\\] {
        width: 70vw
    }
    .lg\\:w-\\[75\\%\\] {
        width: 75%
    }
    .lg\\:w-\\[75px\\] {
        width: 75px
    }
    .lg\\:w-\\[80\\%\\] {
        width: 80%
    }
    .lg\\:w-\\[85\\%\\] {
        width: 85%
    }
    .lg\\:w-\\[90\\%\\] {
        width: 90%
    }
    .lg\\:w-\\[90px\\] {
        width: 90px
    }
    .lg\\:w-\\[95\\%\\] {
        width: 95%
    }
    .lg\\:w-full {
        width: 100%
    }
    .lg\\:\\!translate-y-0 {
        --tw-translate-y: 0px !important;
        transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important
    }
    .lg\\:justify-start {
        justify-content: flex-start
    }
    .lg\\:justify-end {
        justify-content: flex-end
    }
    .lg\\:justify-center {
        justify-content: center
    }
    .lg\\:gap-y-10 {
        row-gap: 2.5rem
    }
    .lg\\:gap-y-\\[30px\\] {
        row-gap: 30px
    }
    .lg\\:divide-y > :not([hidden]) ~ :not([hidden]) {
        --tw-divide-y-reverse: 0;
        border-top-width: calc(1px * calc(1 - var(--tw-divide-y-reverse)));
        border-bottom-width: calc(1px * var(--tw-divide-y-reverse))
    }
    .lg\\:bg-inherit {
        background-color: inherit
    }
    .lg\\:bg-\\[length\\:700px\\] {
        background-size: 700px
    }
    .lg\\:bg-cover {
        background-size: cover
    }
    .lg\\:bg-local {
        background-attachment: local
    }
    .lg\\:bg-\\[right_-230px_center\\] {
        background-position: right -230px center
    }
    .lg\\:bg-\\[right_-80px_top\\] {
        background-position: right -80px top
    }
    .lg\\:bg-center {
        background-position: center
    }
    .lg\\:bg-right {
        background-position: right
    }
    .lg\\:p-0 {
        padding: 0px
    }
    .lg\\:p-10 {
        padding: 2.5rem
    }
    .lg\\:p-12 {
        padding: 3rem
    }
    .lg\\:p-16 {
        padding: 4rem
    }
    .lg\\:p-20 {
        padding: 5rem
    }
    .lg\\:p-24 {
        padding: 6rem
    }
    .lg\\:p-8 {
        padding: 2rem
    }
    .lg\\:p-\\[104px\\] {
        padding: 104px
    }
    .lg\\:p-\\[15px\\] {
        padding: 15px
    }
    .lg\\:p-\\[2\\.5rem\\] {
        padding: 2.5rem
    }
    .lg\\:p-\\[25px\\] {
        padding: 25px
    }
    .lg\\:p-\\[30px\\] {
        padding: 30px
    }
    .lg\\:p-\\[35px\\] {
        padding: 35px
    }
    .lg\\:p-\\[4\\.5rem\\] {
        padding: 4.5rem
    }
    .lg\\:p-\\[45px\\] {
        padding: 45px
    }
    .lg\\:p-\\[5\\.5rem\\] {
        padding: 5.5rem
    }
    .lg\\:p-\\[52px\\] {
        padding: 52px
    }
    .lg\\:p-\\[58px\\] {
        padding: 58px
    }
    .lg\\:p-\\[6\\%\\] {
        padding: 6%
    }
    .lg\\:p-\\[74px\\] {
        padding: 74px
    }
    .lg\\:p-\\[90px\\] {
        padding: 90px
    }
    .lg\\:px-0 {
        padding-left: 0px;
        padding-right: 0px
    }
    .lg\\:px-12 {
        padding-left: 3rem;
        padding-right: 3rem
    }
    .lg\\:px-16 {
        padding-left: 4rem;
        padding-right: 4rem
    }
    .lg\\:px-2 {
        padding-left: 0.5rem;
        padding-right: 0.5rem
    }
    .lg\\:px-20 {
        padding-left: 5rem;
        padding-right: 5rem
    }
    .lg\\:px-28 {
        padding-left: 7rem;
        padding-right: 7rem
    }
    .lg\\:px-32 {
        padding-left: 8rem;
        padding-right: 8rem
    }
    .lg\\:px-8 {
        padding-left: 2rem;
        padding-right: 2rem
    }
    .lg\\:px-\\[0px\\] {
        padding-left: 0px;
        padding-right: 0px
    }
    .lg\\:px-\\[1\\.5rem\\] {
        padding-left: 1.5rem;
        padding-right: 1.5rem
    }
    .lg\\:px-\\[10px\\] {
        padding-left: 10px;
        padding-right: 10px
    }
    .lg\\:px-\\[15px\\] {
        padding-left: 15px;
        padding-right: 15px
    }
    .lg\\:px-\\[2\\%\\] {
        padding-left: 2%;
        padding-right: 2%
    }
    .lg\\:px-\\[2\\.5rem\\] {
        padding-left: 2.5rem;
        padding-right: 2.5rem
    }
    .lg\\:px-\\[20px\\] {
        padding-left: 20px;
        padding-right: 20px
    }
    .lg\\:px-\\[23px\\] {
        padding-left: 23px;
        padding-right: 23px
    }
    .lg\\:px-\\[25px\\] {
        padding-left: 25px;
        padding-right: 25px
    }
    .lg\\:px-\\[2rem\\] {
        padding-left: 2rem;
        padding-right: 2rem
    }
    .lg\\:px-\\[3\\%\\] {
        padding-left: 3%;
        padding-right: 3%
    }
    .lg\\:px-\\[30px\\] {
        padding-left: 30px;
        padding-right: 30px
    }
    .lg\\:px-\\[35px\\] {
        padding-left: 35px;
        padding-right: 35px
    }
    .lg\\:px-\\[39px\\] {
        padding-left: 39px;
        padding-right: 39px
    }
    .lg\\:px-\\[3rem\\] {
        padding-left: 3rem;
        padding-right: 3rem
    }
    .lg\\:px-\\[4\\%\\] {
        padding-left: 4%;
        padding-right: 4%
    }
    .lg\\:px-\\[4\\.5rem\\] {
        padding-left: 4.5rem;
        padding-right: 4.5rem
    }
    .lg\\:px-\\[40px\\] {
        padding-left: 40px;
        padding-right: 40px
    }
    .lg\\:px-\\[5\\.5rem\\] {
        padding-left: 5.5rem;
        padding-right: 5.5rem
    }
    .lg\\:px-\\[6\\%\\] {
        padding-left: 6%;
        padding-right: 6%
    }
    .lg\\:px-\\[6\\.5rem\\] {
        padding-left: 6.5rem;
        padding-right: 6.5rem
    }
    .lg\\:px-\\[7\\%\\] {
        padding-left: 7%;
        padding-right: 7%
    }
    .lg\\:py-12 {
        padding-top: 3rem;
        padding-bottom: 3rem
    }
    .lg\\:py-20 {
        padding-top: 5rem;
        padding-bottom: 5rem
    }
    .lg\\:py-24 {
        padding-top: 6rem;
        padding-bottom: 6rem
    }
    .lg\\:py-28 {
        padding-top: 7rem;
        padding-bottom: 7rem
    }
    .lg\\:py-\\[120px\\] {
        padding-top: 120px;
        padding-bottom: 120px
    }
    .lg\\:py-\\[130px\\] {
        padding-top: 130px;
        padding-bottom: 130px
    }
    .lg\\:py-\\[140px\\] {
        padding-top: 140px;
        padding-bottom: 140px
    }
    .lg\\:py-\\[160px\\] {
        padding-top: 160px;
        padding-bottom: 160px
    }
    .lg\\:py-\\[180px\\] {
        padding-top: 180px;
        padding-bottom: 180px
    }
    .lg\\:py-\\[20px\\] {
        padding-top: 20px;
        padding-bottom: 20px
    }
    .lg\\:py-\\[3\\.5rem\\] {
        padding-top: 3.5rem;
        padding-bottom: 3.5rem
    }
    .lg\\:py-\\[30px\\] {
        padding-top: 30px;
        padding-bottom: 30px
    }
    .lg\\:py-\\[52px\\] {
        padding-top: 52px;
        padding-bottom: 52px
    }
    .lg\\:py-\\[55px\\] {
        padding-top: 55px;
        padding-bottom: 55px
    }
    .lg\\:py-\\[60px\\] {
        padding-top: 60px;
        padding-bottom: 60px
    }
    .lg\\:py-\\[7\\%\\] {
        padding-top: 7%;
        padding-bottom: 7%
    }
    .lg\\:py-\\[75px\\] {
        padding-top: 75px;
        padding-bottom: 75px
    }
    .lg\\:py-\\[7rem\\] {
        padding-top: 7rem;
        padding-bottom: 7rem
    }
    .lg\\:py-\\[8\\%\\] {
        padding-top: 8%;
        padding-bottom: 8%
    }
    .lg\\:py-\\[90px\\] {
        padding-top: 90px;
        padding-bottom: 90px
    }
    .lg\\:py-\\[95px\\] {
        padding-top: 95px;
        padding-bottom: 95px
    }
    .lg\\:\\!pl-\\[15px\\] {
        padding-left: 15px !important
    }
    .lg\\:\\!pl-\\[50px\\] {
        padding-left: 50px !important
    }
    .lg\\:\\!pr-0 {
        padding-right: 0px !important
    }
    .lg\\:pb-0 {
        padding-bottom: 0px
    }
    .lg\\:pb-28 {
        padding-bottom: 7rem
    }
    .lg\\:pb-32 {
        padding-bottom: 8rem
    }
    .lg\\:pb-\\[120px\\] {
        padding-bottom: 120px
    }
    .lg\\:pb-\\[160px\\] {
        padding-bottom: 160px
    }
    .lg\\:pb-\\[195px\\] {
        padding-bottom: 195px
    }
    .lg\\:pb-\\[200px\\] {
        padding-bottom: 200px
    }
    .lg\\:pb-\\[210px\\] {
        padding-bottom: 210px
    }
    .lg\\:pb-\\[22px\\] {
        padding-bottom: 22px
    }
    .lg\\:pb-\\[265px\\] {
        padding-bottom: 265px
    }
    .lg\\:pb-\\[275px\\] {
        padding-bottom: 275px
    }
    .lg\\:pb-\\[320px\\] {
        padding-bottom: 320px
    }
    .lg\\:pb-\\[50px\\] {
        padding-bottom: 50px
    }
    .lg\\:pb-\\[600px\\] {
        padding-bottom: 600px
    }
    .lg\\:pb-\\[70px\\] {
        padding-bottom: 70px
    }
    .lg\\:pb-\\[75px\\] {
        padding-bottom: 75px
    }
    .lg\\:pb-\\[80px\\] {
        padding-bottom: 80px
    }
    .lg\\:pb-\\[90px\\] {
        padding-bottom: 90px
    }
    .lg\\:pb-\\[95px\\] {
        padding-bottom: 95px
    }
    .lg\\:pl-12 {
        padding-left: 3rem
    }
    .lg\\:pl-20 {
        padding-left: 5rem
    }
    .lg\\:pl-24 {
        padding-left: 6rem
    }
    .lg\\:pl-5 {
        padding-left: 1.25rem
    }
    .lg\\:pl-8 {
        padding-left: 2rem
    }
    .lg\\:pl-\\[120px\\] {
        padding-left: 120px
    }
    .lg\\:pl-\\[15px\\] {
        padding-left: 15px
    }
    .lg\\:pl-\\[40px\\] {
        padding-left: 40px
    }
    .lg\\:pr-0 {
        padding-right: 0px
    }
    .lg\\:pr-\\[15px\\] {
        padding-right: 15px
    }
    .lg\\:pr-\\[30px\\] {
        padding-right: 30px
    }
    .lg\\:pr-\\[35px\\] {
        padding-right: 35px
    }
    .lg\\:pr-\\[40px\\] {
        padding-right: 40px
    }
    .lg\\:pr-\\[50px\\] {
        padding-right: 50px
    }
    .lg\\:pr-\\[65px\\] {
        padding-right: 65px
    }
    .lg\\:pt-0 {
        padding-top: 0px
    }
    .lg\\:pt-40 {
        padding-top: 10rem
    }
    .lg\\:pt-6 {
        padding-top: 1.5rem
    }
    .lg\\:pt-\\[100px\\] {
        padding-top: 100px
    }
    .lg\\:pt-\\[120px\\] {
        padding-top: 120px
    }
    .lg\\:pt-\\[160px\\] {
        padding-top: 160px
    }
    .lg\\:pt-\\[20px\\] {
        padding-top: 20px
    }
    .lg\\:pt-\\[221px\\] {
        padding-top: 221px
    }
    .lg\\:pt-\\[300px\\] {
        padding-top: 300px
    }
    .lg\\:pt-\\[75px\\] {
        padding-top: 75px
    }
    .lg\\:pt-\\[8\\%\\] {
        padding-top: 8%
    }
    .lg\\:pt-\\[90px\\] {
        padding-top: 90px
    }
    .lg\\:pt-\\[95px\\] {
        padding-top: 95px
    }
    .lg\\:text-center {
        text-align: center
    }
    .lg\\:text-start {
        text-align: start
    }
    .lg\\:font-sans {
        font-family: Roboto, sans-serif
    }
    .lg\\:text-\\[110px\\] {
        font-size: 110px
    }
    .lg\\:text-\\[143px\\] {
        font-size: 143px
    }
    .lg\\:text-\\[14px\\] {
        font-size: 14px
    }
    .lg\\:text-\\[150px\\] {
        font-size: 150px
    }
    .lg\\:text-\\[15px\\] {
        font-size: 15px
    }
    .lg\\:text-\\[160px\\] {
        font-size: 160px
    }
    .lg\\:text-\\[170px\\] {
        font-size: 170px
    }
    .lg\\:text-\\[18px\\] {
        font-size: 18px
    }
    .lg\\:text-\\[200px\\] {
        font-size: 200px
    }
    .lg\\:text-\\[25px\\] {
        font-size: 25px
    }
    .lg\\:text-\\[300px\\] {
        font-size: 300px
    }
    .lg\\:text-\\[33px\\] {
        font-size: 33px
    }
    .lg\\:text-\\[37px\\] {
        font-size: 37px
    }
    .lg\\:text-\\[50px\\] {
        font-size: 50px
    }
    .lg\\:text-\\[55px\\] {
        font-size: 55px
    }
    .lg\\:text-\\[60px\\] {
        font-size: 60px
    }
    .lg\\:text-\\[75px\\] {
        font-size: 75px
    }
    .lg\\:text-\\[80px\\] {
        font-size: 80px
    }
    .lg\\:text-\\[90px\\] {
        font-size: 90px
    }
    .lg\\:text-lg {
        font-size: 18px;
        line-height: 22px
    }
    .lg\\:text-md {
        font-size: 14px;
        line-height: 20px
    }
    .lg\\:text-sm {
        font-size: 13px;
        line-height: 22px
    }
    .lg\\:text-xmd {
        font-size: 16px;
        line-height: 28px
    }
    .lg\\:leading-\\[100px\\] {
        line-height: 100px
    }
    .lg\\:leading-\\[140px\\] {
        line-height: 140px
    }
    .lg\\:leading-\\[150px\\] {
        line-height: 150px
    }
    .lg\\:leading-\\[160px\\] {
        line-height: 160px
    }
    .lg\\:leading-\\[170px\\] {
        line-height: 170px
    }
    .lg\\:leading-\\[24px\\] {
        line-height: 24px
    }
    .lg\\:leading-\\[26px\\] {
        line-height: 26px
    }
    .lg\\:leading-\\[33px\\] {
        line-height: 33px
    }
    .lg\\:leading-\\[55px\\] {
        line-height: 55px
    }
    .lg\\:leading-\\[60px\\] {
        line-height: 60px
    }
    .lg\\:leading-\\[80px\\] {
        line-height: 80px
    }
    .lg\\:leading-\\[90px\\] {
        line-height: 90px
    }
    .lg\\:leading-none {
        line-height: 1
    }
    .lg\\:leading-normal {
        line-height: 1.5
    }
    .lg\\:-tracking-\\[1\\.5px\\] {
        letter-spacing: -1.5px
    }
    .lg\\:tracking-normal {
        letter-spacing: 0em
    }
}
@media (max-width: 991px) {
    .md\\:\\!relative {
        position: relative !important
    }
    .md\\:relative {
        position: relative
    }
    .md\\:-bottom-\\[30\\%\\] {
        bottom: -30%
    }
    .md\\:-left-\\[15px\\] {
        left: -15px
    }
    .md\\:-right-\\[15px\\] {
        right: -15px
    }
    .md\\:-right-\\[50px\\] {
        right: -50px
    }
    .md\\:-top-\\[30px\\] {
        top: -30px
    }
    .md\\:-top-\\[50px\\] {
        top: -50px
    }
    .md\\:bottom-0 {
        bottom: 0px
    }
    .md\\:bottom-\\[-10px\\] {
        bottom: -10px
    }
    .md\\:bottom-\\[-20px\\] {
        bottom: -20px
    }
    .md\\:bottom-\\[-50px\\] {
        bottom: -50px
    }
    .md\\:bottom-\\[-70px\\] {
        bottom: -70px
    }
    .md\\:bottom-\\[-80px\\] {
        bottom: -80px
    }
    .md\\:bottom-\\[10\\%\\] {
        bottom: 10%
    }
    .md\\:bottom-\\[10px\\] {
        bottom: 10px
    }
    .md\\:bottom-\\[15\\%\\] {
        bottom: 15%
    }
    .md\\:bottom-\\[30px\\] {
        bottom: 30px
    }
    .md\\:bottom-\\[50px\\] {
        bottom: 50px
    }
    .md\\:left-0 {
        left: 0px
    }
    .md\\:left-1\\/2 {
        left: 50%
    }
    .md\\:left-\\[-15px\\] {
        left: -15px
    }
    .md\\:left-\\[-180px\\] {
        left: -180px
    }
    .md\\:left-auto {
        left: auto
    }
    .md\\:right-0 {
        right: 0px
    }
    .md\\:right-\\[-100px\\] {
        right: -100px
    }
    .md\\:right-\\[-120px\\] {
        right: -120px
    }
    .md\\:right-\\[-90px\\] {
        right: -90px
    }
    .md\\:right-\\[320px\\] {
        right: 320px
    }
    .md\\:right-\\[50px\\] {
        right: 50px
    }
    .md\\:right-\\[60px\\] {
        right: 60px
    }
    .md\\:right-\\[80px\\] {
        right: 80px
    }
    .md\\:right-auto {
        right: auto
    }
    .md\\:top-0 {
        top: 0px
    }
    .md\\:top-\\[-10px\\] {
        top: -10px
    }
    .md\\:top-\\[-30px\\] {
        top: -30px
    }
    .md\\:top-\\[-35px\\] {
        top: -35px
    }
    .md\\:top-\\[-40px\\] {
        top: -40px
    }
    .md\\:top-\\[-60px\\] {
        top: -60px
    }
    .md\\:top-\\[-66px\\] {
        top: -66px
    }
    .md\\:top-\\[23px\\] {
        top: 23px
    }
    .md\\:top-\\[50px\\] {
        top: 50px
    }
    .md\\:top-\\[70px\\] {
        top: 70px
    }
    .md\\:top-auto {
        top: auto
    }
    .md\\:order-1 {
        order: 1
    }
    .md\\:order-2 {
        order: 2
    }
    .md\\:m-0 {
        margin: 0px
    }
    .md\\:mx-0 {
        margin-left: 0px;
        margin-right: 0px
    }
    .md\\:mx-\\[15px\\] {
        margin-left: 15px;
        margin-right: 15px
    }
    .md\\:mx-\\[17px\\] {
        margin-left: 17px;
        margin-right: 17px
    }
    .md\\:mx-\\[2\\.5rem\\] {
        margin-left: 2.5rem;
        margin-right: 2.5rem
    }
    .md\\:mx-\\[20px\\] {
        margin-left: 20px;
        margin-right: 20px
    }
    .md\\:mx-\\[75px\\] {
        margin-left: 75px;
        margin-right: 75px
    }
    .md\\:mx-auto {
        margin-left: auto;
        margin-right: auto
    }
    .md\\:my-0 {
        margin-top: 0px;
        margin-bottom: 0px
    }
    .md\\:my-6 {
        margin-top: 1.5rem;
        margin-bottom: 1.5rem
    }
    .md\\:my-\\[15px\\] {
        margin-top: 15px;
        margin-bottom: 15px
    }
    .md\\:my-\\[18px\\] {
        margin-top: 18px;
        margin-bottom: 18px
    }
    .md\\:my-\\[7\\.5rem\\] {
        margin-top: 7.5rem;
        margin-bottom: 7.5rem
    }
    .md\\:mb-0 {
        margin-bottom: 0px
    }
    .md\\:mb-10 {
        margin-bottom: 2.5rem
    }
    .md\\:mb-12 {
        margin-bottom: 3rem
    }
    .md\\:mb-16 {
        margin-bottom: 4rem
    }
    .md\\:mb-20 {
        margin-bottom: 5rem
    }
    .md\\:mb-24 {
        margin-bottom: 6rem
    }
    .md\\:mb-28 {
        margin-bottom: 7rem
    }
    .md\\:mb-32 {
        margin-bottom: 8rem
    }
    .md\\:mb-36 {
        margin-bottom: 9rem
    }
    .md\\:mb-4 {
        margin-bottom: 1rem
    }
    .md\\:mb-5 {
        margin-bottom: 1.25rem
    }
    .md\\:mb-8 {
        margin-bottom: 2rem
    }
    .md\\:mb-\\[0\\.75rem\\] {
        margin-bottom: 0.75rem
    }
    .md\\:mb-\\[10px\\] {
        margin-bottom: 10px
    }
    .md\\:mb-\\[15px\\] {
        margin-bottom: 15px
    }
    .md\\:mb-\\[20px\\] {
        margin-bottom: 20px
    }
    .md\\:mb-\\[25px\\] {
        margin-bottom: 25px
    }
    .md\\:mb-\\[30px\\] {
        margin-bottom: 30px
    }
    .md\\:mb-\\[35px\\] {
        margin-bottom: 35px
    }
    .md\\:mb-\\[4\\.5rem\\] {
        margin-bottom: 4.5rem
    }
    .md\\:mb-\\[40px\\] {
        margin-bottom: 40px
    }
    .md\\:mb-\\[43\\%\\] {
        margin-bottom: 43%
    }
    .md\\:mb-\\[44px\\] {
        margin-bottom: 44px
    }
    .md\\:mb-\\[45px\\] {
        margin-bottom: 45px
    }
    .md\\:mb-\\[48px\\] {
        margin-bottom: 48px
    }
    .md\\:mb-\\[5\\.5rem\\] {
        margin-bottom: 5.5rem
    }
    .md\\:mb-\\[50px\\] {
        margin-bottom: 50px
    }
    .md\\:mb-\\[58px\\] {
        margin-bottom: 58px
    }
    .md\\:mb-\\[5px\\] {
        margin-bottom: 5px
    }
    .md\\:mb-\\[60px\\] {
        margin-bottom: 60px
    }
    .md\\:mb-\\[65px\\] {
        margin-bottom: 65px
    }
    .md\\:mb-\\[70px\\] {
        margin-bottom: 70px
    }
    .md\\:mb-\\[72px\\] {
        margin-bottom: 72px
    }
    .md\\:mb-\\[75px\\] {
        margin-bottom: 75px
    }
    .md\\:mb-\\[78px\\] {
        margin-bottom: 78px
    }
    .md\\:mb-\\[7px\\] {
        margin-bottom: 7px
    }
    .md\\:mb-\\[80px\\] {
        margin-bottom: 80px
    }
    .md\\:mb-\\[90px\\] {
        margin-bottom: 90px
    }
    .md\\:ml-0 {
        margin-left: 0px
    }
    .md\\:ml-24 {
        margin-left: 6rem
    }
    .md\\:ml-\\[10px\\] {
        margin-left: 10px
    }
    .md\\:ml-\\[12px\\] {
        margin-left: 12px
    }
    .md\\:ml-\\[17px\\] {
        margin-left: 17px
    }
    .md\\:ml-\\[25px\\] {
        margin-left: 25px
    }
    .md\\:ml-\\[8px\\] {
        margin-left: 8px
    }
    .md\\:mr-0 {
        margin-right: 0px
    }
    .md\\:mr-\\[-15px\\] {
        margin-right: -15px
    }
    .md\\:mr-\\[0px\\] {
        margin-right: 0px
    }
    .md\\:mr-\\[10px\\] {
        margin-right: 10px
    }
    .md\\:mr-\\[15px\\] {
        margin-right: 15px
    }
    .md\\:mr-\\[17px\\] {
        margin-right: 17px
    }
    .md\\:mr-\\[20px\\] {
        margin-right: 20px
    }
    .md\\:mt-0 {
        margin-top: 0px
    }
    .md\\:mt-12 {
        margin-top: 3rem
    }
    .md\\:mt-14 {
        margin-top: 3.5rem
    }
    .md\\:mt-16 {
        margin-top: 4rem
    }
    .md\\:mt-20 {
        margin-top: 5rem
    }
    .md\\:mt-24 {
        margin-top: 6rem
    }
    .md\\:mt-28 {
        margin-top: 7rem
    }
    .md\\:mt-\\[-50px\\] {
        margin-top: -50px
    }
    .md\\:mt-\\[-60px\\] {
        margin-top: -60px
    }
    .md\\:mt-\\[0px\\] {
        margin-top: 0px
    }
    .md\\:mt-\\[100px\\] {
        margin-top: 100px
    }
    .md\\:mt-\\[10px\\] {
        margin-top: 10px
    }
    .md\\:mt-\\[15\\%\\] {
        margin-top: 15%
    }
    .md\\:mt-\\[15px\\] {
        margin-top: 15px
    }
    .md\\:mt-\\[25px\\] {
        margin-top: 25px
    }
    .md\\:mt-\\[30px\\] {
        margin-top: 30px
    }
    .md\\:mt-\\[35px\\] {
        margin-top: 35px
    }
    .md\\:mt-\\[4\\.5rem\\] {
        margin-top: 4.5rem
    }
    .md\\:mt-\\[40px\\] {
        margin-top: 40px
    }
    .md\\:mt-\\[5\\%\\] {
        margin-top: 5%
    }
    .md\\:mt-\\[5\\.5rem\\] {
        margin-top: 5.5rem
    }
    .md\\:mt-\\[50px\\] {
        margin-top: 50px
    }
    .md\\:mt-\\[70px\\] {
        margin-top: 70px
    }
    .md\\:mt-\\[75px\\] {
        margin-top: 75px
    }
    .md\\:block {
        display: block
    }
    .md\\:inline-block {
        display: inline-block
    }
    .md\\:flex {
        display: flex
    }
    .md\\:inline-flex {
        display: inline-flex
    }
    .md\\:contents {
        display: contents
    }
    .md\\:\\!hidden {
        display: none !important
    }
    .md\\:hidden {
        display: none
    }
    .md\\:h-\\[100px\\] {
        height: 100px
    }
    .md\\:h-\\[110px\\] {
        height: 110px
    }
    .md\\:h-\\[255px\\] {
        height: 255px
    }
    .md\\:h-\\[300px\\] {
        height: 300px
    }
    .md\\:h-\\[320px\\] {
        height: 320px
    }
    .md\\:h-\\[350px\\] {
        height: 350px
    }
    .md\\:h-\\[375px\\] {
        height: 375px
    }
    .md\\:h-\\[400px\\] {
        height: 400px
    }
    .md\\:h-\\[450px\\] {
        height: 450px
    }
    .md\\:h-\\[465px\\] {
        height: 465px
    }
    .md\\:h-\\[484px\\] {
        height: 484px
    }
    .md\\:h-\\[500px\\] {
        height: 500px
    }
    .md\\:h-\\[50vh\\] {
        height: 50vh
    }
    .md\\:h-\\[520px\\] {
        height: 520px
    }
    .md\\:h-\\[530px\\] {
        height: 530px
    }
    .md\\:h-\\[550px\\] {
        height: 550px
    }
    .md\\:h-\\[570px\\] {
        height: 570px
    }
    .md\\:h-\\[571px\\] {
        height: 571px
    }
    .md\\:h-\\[600px\\] {
        height: 600px
    }
    .md\\:h-\\[60vh\\] {
        height: 60vh
    }
    .md\\:h-\\[650px\\] {
        height: 650px
    }
    .md\\:h-\\[700px\\] {
        height: 700px
    }
    .md\\:h-\\[70px\\] {
        height: 70px
    }
    .md\\:h-\\[70vh\\] {
        height: 70vh
    }
    .md\\:h-\\[750px\\] {
        height: 750px
    }
    .md\\:h-\\[800px\\] {
        height: 800px
    }
    .md\\:h-\\[80px\\] {
        height: 80px
    }
    .md\\:h-\\[85vh\\] {
        height: 85vh
    }
    .md\\:h-\\[90vh\\] {
        height: 90vh
    }
    .md\\:h-\\[910px\\] {
        height: 910px
    }
    .md\\:h-auto {
        height: auto
    }
    .md\\:h-full {
        height: 100%
    }
    .md\\:w-1\\/2 {
        width: 50%
    }
    .md\\:w-2\\/5 {
        width: 40%
    }
    .md\\:w-3\\/4 {
        width: 75%
    }
    .md\\:w-4\\/5 {
        width: 80%
    }
    .md\\:w-9\\/12 {
        width: 75%
    }
    .md\\:w-\\[100px\\] {
        width: 100px
    }
    .md\\:w-\\[105px\\] {
        width: 105px
    }
    .md\\:w-\\[135px\\] {
        width: 135px
    }
    .md\\:w-\\[150px\\] {
        width: 150px
    }
    .md\\:w-\\[160px\\] {
        width: 160px
    }
    .md\\:w-\\[165px\\] {
        width: 165px
    }
    .md\\:w-\\[20\\%\\] {
        width: 20%
    }
    .md\\:w-\\[250px\\] {
        width: 250px
    }
    .md\\:w-\\[350px\\] {
        width: 350px
    }
    .md\\:w-\\[40\\%\\] {
        width: 40%
    }
    .md\\:w-\\[400px\\] {
        width: 400px
    }
    .md\\:w-\\[450px\\] {
        width: 450px
    }
    .md\\:w-\\[50\\%\\] {
        width: 50%
    }
    .md\\:w-\\[500px\\] {
        width: 500px
    }
    .md\\:w-\\[50vw\\] {
        width: 50vw
    }
    .md\\:w-\\[55\\%\\] {
        width: 55%
    }
    .md\\:w-\\[550px\\] {
        width: 550px
    }
    .md\\:w-\\[570px\\] {
        width: 570px
    }
    .md\\:w-\\[60\\%\\] {
        width: 60%
    }
    .md\\:w-\\[65\\%\\] {
        width: 65%
    }
    .md\\:w-\\[68\\%\\] {
        width: 68%
    }
    .md\\:w-\\[70\\%\\] {
        width: 70%
    }
    .md\\:w-\\[70px\\] {
        width: 70px
    }
    .md\\:w-\\[75\\%\\] {
        width: 75%
    }
    .md\\:w-\\[80\\%\\] {
        width: 80%
    }
    .md\\:w-\\[90\\%\\] {
        width: 90%
    }
    .md\\:w-\\[95\\%\\] {
        width: 95%
    }
    .md\\:w-full {
        width: 100%
    }
    .md\\:min-w-0 {
        min-width: 0px
    }
    .md\\:min-w-full {
        min-width: 100%
    }
    .md\\:flex-initial {
        flex: 0 1 auto
    }
    .md\\:-translate-x-1\\/2 {
        --tw-translate-x: -50%;
        transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))
    }
    .md\\:scale-50 {
        --tw-scale-x: .5;
        --tw-scale-y: .5;
        transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))
    }
    .md\\:flex-row {
        flex-direction: row
    }
    .md\\:flex-col {
        flex-direction: column
    }
    .md\\:flex-nowrap {
        flex-wrap: nowrap
    }
    .md\\:items-start {
        align-items: flex-start
    }
    .md\\:items-end {
        align-items: flex-end
    }
    .md\\:items-center {
        align-items: center
    }
    .md\\:justify-start {
        justify-content: flex-start
    }
    .md\\:justify-end {
        justify-content: flex-end
    }
    .md\\:justify-center {
        justify-content: center
    }
    .md\\:justify-between {
        justify-content: space-between
    }
    .md\\:gap-10 {
        gap: 2.5rem
    }
    .md\\:gap-x-\\[15px\\] {
        column-gap: 15px
    }
    .md\\:gap-x-\\[20px\\] {
        column-gap: 20px
    }
    .md\\:gap-y-0 {
        row-gap: 0px
    }
    .md\\:gap-y-10 {
        row-gap: 2.5rem
    }
    .md\\:gap-y-\\[15px\\] {
        row-gap: 15px
    }
    .md\\:gap-y-\\[30px\\] {
        row-gap: 30px
    }
    .md\\:gap-y-\\[45px\\] {
        row-gap: 45px
    }
    .md\\:gap-y-\\[4rem\\] {
        row-gap: 4rem
    }
    .md\\:gap-y-\\[50px\\] {
        row-gap: 50px
    }
    .md\\:gap-y-\\[5rem\\] {
        row-gap: 5rem
    }
    .md\\:self-center {
        align-self: center
    }
    .md\\:overflow-hidden {
        overflow: hidden
    }
    .md\\:border-0 {
        border-width: 0px
    }
    .md\\:border-white {
        --tw-border-opacity: 1;
        border-color: rgb(255 255 255 / var(--tw-border-opacity))
    }
    .md\\:bg-white {
        --tw-bg-opacity: 1;
        background-color: rgb(255 255 255 / var(--tw-bg-opacity))
    }
    .md\\:bg-contain {
        background-size: contain
    }
    .md\\:bg-scroll {
        background-attachment: scroll
    }
    .md\\:bg-\\[right_-50px_top\\] {
        background-position: right -50px top
    }
    .md\\:bg-right {
        background-position: right
    }
    .md\\:bg-right-bottom {
        background-position: right bottom
    }
    .md\\:bg-top {
        background-position: top
    }
    .md\\:p-0 {
        padding: 0px
    }
    .md\\:p-10 {
        padding: 2.5rem
    }
    .md\\:p-12 {
        padding: 3rem
    }
    .md\\:p-14 {
        padding: 3.5rem
    }
    .md\\:p-16 {
        padding: 4rem
    }
    .md\\:p-20 {
        padding: 5rem
    }
    .md\\:p-24 {
        padding: 6rem
    }
    .md\\:p-28 {
        padding: 7rem
    }
    .md\\:p-8 {
        padding: 2rem
    }
    .md\\:p-\\[0px\\] {
        padding: 0px
    }
    .md\\:p-\\[10\\%\\] {
        padding: 10%
    }
    .md\\:p-\\[10px\\] {
        padding: 10px
    }
    .md\\:p-\\[15px\\] {
        padding: 15px
    }
    .md\\:p-\\[2\\.5rem\\] {
        padding: 2.5rem
    }
    .md\\:p-\\[24px\\] {
        padding: 24px
    }
    .md\\:p-\\[30px\\] {
        padding: 30px
    }
    .md\\:p-\\[3rem\\] {
        padding: 3rem
    }
    .md\\:p-\\[4\\.5rem\\] {
        padding: 4.5rem
    }
    .md\\:p-\\[40px\\] {
        padding: 40px
    }
    .md\\:p-\\[42px\\] {
        padding: 42px
    }
    .md\\:p-\\[5\\.5rem\\] {
        padding: 5.5rem
    }
    .md\\:p-\\[60px\\] {
        padding: 60px
    }
    .md\\:p-\\[66px\\] {
        padding: 66px
    }
    .md\\:\\!px-0 {
        padding-left: 0px !important;
        padding-right: 0px !important
    }
    .md\\:\\!px-\\[15px\\] {
        padding-left: 15px !important;
        padding-right: 15px !important
    }
    .md\\:\\!py-0 {
        padding-top: 0px !important;
        padding-bottom: 0px !important
    }
    .md\\:px-0 {
        padding-left: 0px;
        padding-right: 0px
    }
    .md\\:px-10 {
        padding-left: 2.5rem;
        padding-right: 2.5rem
    }
    .md\\:px-12 {
        padding-left: 3rem;
        padding-right: 3rem
    }
    .md\\:px-14 {
        padding-left: 3.5rem;
        padding-right: 3.5rem
    }
    .md\\:px-16 {
        padding-left: 4rem;
        padding-right: 4rem
    }
    .md\\:px-20 {
        padding-left: 5rem;
        padding-right: 5rem
    }
    .md\\:px-8 {
        padding-left: 2rem;
        padding-right: 2rem
    }
    .md\\:px-\\[150px\\] {
        padding-left: 150px;
        padding-right: 150px
    }
    .md\\:px-\\[15px\\] {
        padding-left: 15px;
        padding-right: 15px
    }
    .md\\:px-\\[2\\.5rem\\] {
        padding-left: 2.5rem;
        padding-right: 2.5rem
    }
    .md\\:px-\\[20px\\] {
        padding-left: 20px;
        padding-right: 20px
    }
    .md\\:px-\\[25px\\] {
        padding-left: 25px;
        padding-right: 25px
    }
    .md\\:px-\\[2rem\\] {
        padding-left: 2rem;
        padding-right: 2rem
    }
    .md\\:px-\\[3\\%\\] {
        padding-left: 3%;
        padding-right: 3%
    }
    .md\\:px-\\[3\\.5rem\\] {
        padding-left: 3.5rem;
        padding-right: 3.5rem
    }
    .md\\:px-\\[30px\\] {
        padding-left: 30px;
        padding-right: 30px
    }
    .md\\:px-\\[3rem\\] {
        padding-left: 3rem;
        padding-right: 3rem
    }
    .md\\:px-\\[40px\\] {
        padding-left: 40px;
        padding-right: 40px
    }
    .md\\:px-\\[8\\%\\] {
        padding-left: 8%;
        padding-right: 8%
    }
    .md\\:px-\\[8px\\] {
        padding-left: 8px;
        padding-right: 8px
    }
    .md\\:py-0 {
        padding-top: 0px;
        padding-bottom: 0px
    }
    .md\\:py-12 {
        padding-top: 3rem;
        padding-bottom: 3rem
    }
    .md\\:py-20 {
        padding-top: 5rem;
        padding-bottom: 5rem
    }
    .md\\:py-24 {
        padding-top: 6rem;
        padding-bottom: 6rem
    }
    .md\\:py-28 {
        padding-top: 7rem;
        padding-bottom: 7rem
    }
    .md\\:py-5 {
        padding-top: 1.25rem;
        padding-bottom: 1.25rem
    }
    .md\\:py-8 {
        padding-top: 2rem;
        padding-bottom: 2rem
    }
    .md\\:py-\\[110px\\] {
        padding-top: 110px;
        padding-bottom: 110px
    }
    .md\\:py-\\[15px\\] {
        padding-top: 15px;
        padding-bottom: 15px
    }
    .md\\:py-\\[17px\\] {
        padding-top: 17px;
        padding-bottom: 17px
    }
    .md\\:py-\\[18px\\] {
        padding-top: 18px;
        padding-bottom: 18px
    }
    .md\\:py-\\[20px\\] {
        padding-top: 20px;
        padding-bottom: 20px
    }
    .md\\:py-\\[30px\\] {
        padding-top: 30px;
        padding-bottom: 30px
    }
    .md\\:py-\\[40px\\] {
        padding-top: 40px;
        padding-bottom: 40px
    }
    .md\\:py-\\[50px\\] {
        padding-top: 50px;
        padding-bottom: 50px
    }
    .md\\:py-\\[60px\\] {
        padding-top: 60px;
        padding-bottom: 60px
    }
    .md\\:py-\\[70px\\] {
        padding-top: 70px;
        padding-bottom: 70px
    }
    .md\\:py-\\[75px\\] {
        padding-top: 75px;
        padding-bottom: 75px
    }
    .md\\:py-\\[7rem\\] {
        padding-top: 7rem;
        padding-bottom: 7rem
    }
    .md\\:py-\\[8\\.5rem\\] {
        padding-top: 8.5rem;
        padding-bottom: 8.5rem
    }
    .md\\:py-\\[80px\\] {
        padding-top: 80px;
        padding-bottom: 80px
    }
    .md\\:py-\\[85px\\] {
        padding-top: 85px;
        padding-bottom: 85px
    }
    .md\\:py-\\[90px\\] {
        padding-top: 90px;
        padding-bottom: 90px
    }
    .md\\:py-\\[95px\\] {
        padding-top: 95px;
        padding-bottom: 95px
    }
    .md\\:py-\\[9px\\] {
        padding-top: 9px;
        padding-bottom: 9px
    }
    .md\\:\\!pl-0 {
        padding-left: 0px !important
    }
    .md\\:\\!pl-\\[30px\\] {
        padding-left: 30px !important
    }
    .md\\:\\!pr-\\[15px\\] {
        padding-right: 15px !important
    }
    .md\\:pb-0 {
        padding-bottom: 0px
    }
    .md\\:pb-24 {
        padding-bottom: 6rem
    }
    .md\\:pb-40 {
        padding-bottom: 10rem
    }
    .md\\:pb-\\[100px\\] {
        padding-bottom: 100px
    }
    .md\\:pb-\\[120px\\] {
        padding-bottom: 120px
    }
    .md\\:pb-\\[150px\\] {
        padding-bottom: 150px
    }
    .md\\:pb-\\[160px\\] {
        padding-bottom: 160px
    }
    .md\\:pb-\\[185px\\] {
        padding-bottom: 185px
    }
    .md\\:pb-\\[200px\\] {
        padding-bottom: 200px
    }
    .md\\:pb-\\[220px\\] {
        padding-bottom: 220px
    }
    .md\\:pb-\\[22px\\] {
        padding-bottom: 22px
    }
    .md\\:pb-\\[270px\\] {
        padding-bottom: 270px
    }
    .md\\:pb-\\[30px\\] {
        padding-bottom: 30px
    }
    .md\\:pb-\\[310px\\] {
        padding-bottom: 310px
    }
    .md\\:pb-\\[400px\\] {
        padding-bottom: 400px
    }
    .md\\:pb-\\[40px\\] {
        padding-bottom: 40px
    }
    .md\\:pb-\\[60px\\] {
        padding-bottom: 60px
    }
    .md\\:pb-\\[70px\\] {
        padding-bottom: 70px
    }
    .md\\:pb-\\[75px\\] {
        padding-bottom: 75px
    }
    .md\\:pb-\\[80px\\] {
        padding-bottom: 80px
    }
    .md\\:pb-\\[95px\\] {
        padding-bottom: 95px
    }
    .md\\:pl-0 {
        padding-left: 0px
    }
    .md\\:pl-\\[15px\\] {
        padding-left: 15px
    }
    .md\\:pl-\\[25px\\] {
        padding-left: 25px
    }
    .md\\:pl-\\[30px\\] {
        padding-left: 30px
    }
    .md\\:pl-\\[35px\\] {
        padding-left: 35px
    }
    .md\\:pl-\\[5px\\] {
        padding-left: 5px
    }
    .md\\:pl-\\[9\\%\\] {
        padding-left: 9%
    }
    .md\\:pr-0 {
        padding-right: 0px
    }
    .md\\:pr-\\[15px\\] {
        padding-right: 15px
    }
    .md\\:pr-\\[30px\\] {
        padding-right: 30px
    }
    .md\\:pr-\\[35px\\] {
        padding-right: 35px
    }
    .md\\:pr-\\[50px\\] {
        padding-right: 50px
    }
    .md\\:pt-0 {
        padding-top: 0px
    }
    .md\\:pt-24 {
        padding-top: 6rem
    }
    .md\\:pt-40 {
        padding-top: 10rem
    }
    .md\\:pt-\\[110px\\] {
        padding-top: 110px
    }
    .md\\:pt-\\[200px\\] {
        padding-top: 200px
    }
    .md\\:pt-\\[220px\\] {
        padding-top: 220px
    }
    .md\\:pt-\\[4\\.5rem\\] {
        padding-top: 4.5rem
    }
    .md\\:pt-\\[40px\\] {
        padding-top: 40px
    }
    .md\\:pt-\\[50px\\] {
        padding-top: 50px
    }
    .md\\:pt-\\[60\\%\\] {
        padding-top: 60%
    }
    .md\\:pt-\\[66px\\] {
        padding-top: 66px
    }
    .md\\:pt-\\[70px\\] {
        padding-top: 70px
    }
    .md\\:pt-\\[72px\\] {
        padding-top: 72px
    }
    .md\\:pt-\\[75px\\] {
        padding-top: 75px
    }
    .md\\:pt-\\[80px\\] {
        padding-top: 80px
    }
    .md\\:pt-\\[90px\\] {
        padding-top: 90px
    }
    .md\\:pt-\\[95px\\] {
        padding-top: 95px
    }
    .md\\:text-left {
        text-align: left
    }
    .md\\:text-center {
        text-align: center
    }
    .md\\:text-right {
        text-align: right
    }
    .md\\:text-start {
        text-align: start
    }
    .md\\:text-end {
        text-align: end
    }
    .md\\:text-\\[108px\\] {
        font-size: 108px
    }
    .md\\:text-\\[120px\\] {
        font-size: 120px
    }
    .md\\:text-\\[130px\\] {
        font-size: 130px
    }
    .md\\:text-\\[145px\\] {
        font-size: 145px
    }
    .md\\:text-\\[150px\\] {
        font-size: 150px
    }
    .md\\:text-\\[17px\\] {
        font-size: 17px
    }
    .md\\:text-\\[18px\\] {
        font-size: 18px
    }
    .md\\:text-\\[22px\\] {
        font-size: 22px
    }
    .md\\:text-\\[27px\\] {
        font-size: 27px
    }
    .md\\:text-\\[28px\\] {
        font-size: 28px
    }
    .md\\:text-\\[34px\\] {
        font-size: 34px
    }
    .md\\:text-\\[45px\\] {
        font-size: 45px
    }
    .md\\:text-\\[46px\\] {
        font-size: 46px
    }
    .md\\:text-\\[54px\\] {
        font-size: 54px
    }
    .md\\:text-\\[55px\\] {
        font-size: 55px
    }
    .md\\:text-\\[60px\\] {
        font-size: 60px
    }
    .md\\:text-\\[70px\\] {
        font-size: 70px
    }
    .md\\:text-\\[80px\\] {
        font-size: 80px
    }
    .md\\:text-\\[87px\\] {
        font-size: 87px
    }
    .md\\:text-\\[90px\\] {
        font-size: 90px
    }
    .md\\:text-\\[9rem\\] {
        font-size: 9rem
    }
    .md\\:text-lg {
        font-size: 18px;
        line-height: 22px
    }
    .md\\:text-md {
        font-size: 14px;
        line-height: 20px
    }
    .md\\:text-sm {
        font-size: 13px;
        line-height: 22px
    }
    .md\\:text-xmd {
        font-size: 16px;
        line-height: 28px
    }
    .md\\:leading-\\[110px\\] {
        line-height: 110px
    }
    .md\\:leading-\\[120px\\] {
        line-height: 120px
    }
    .md\\:leading-\\[130px\\] {
        line-height: 130px
    }
    .md\\:leading-\\[145px\\] {
        line-height: 145px
    }
    .md\\:leading-\\[18px\\] {
        line-height: 18px
    }
    .md\\:leading-\\[22px\\] {
        line-height: 22px
    }
    .md\\:leading-\\[26px\\] {
        line-height: 26px
    }
    .md\\:leading-\\[30px\\] {
        line-height: 30px
    }
    .md\\:leading-\\[32px\\] {
        line-height: 32px
    }
    .md\\:leading-\\[34px\\] {
        line-height: 34px
    }
    .md\\:leading-\\[36px\\] {
        line-height: 36px
    }
    .md\\:leading-\\[38px\\] {
        line-height: 38px
    }
    .md\\:leading-\\[64px\\] {
        line-height: 64px
    }
    .md\\:leading-\\[65px\\] {
        line-height: 65px
    }
    .md\\:leading-\\[85px\\] {
        line-height: 85px
    }
    .md\\:leading-\\[90px\\] {
        line-height: 90px
    }
    .md\\:leading-normal {
        line-height: 1.5
    }
    .md\\:-tracking-\\[4px\\] {
        letter-spacing: -4px
    }
    .md\\:tracking-\\[-2px\\] {
        letter-spacing: -2px
    }
    .md\\:tracking-\\[-5px\\] {
        letter-spacing: -5px
    }
    .md\\:text-\\[\\#000\\] {
        --tw-text-opacity: 1;
        color: rgb(0 0 0 / var(--tw-text-opacity))
    }
    .md\\:text-black {
        --tw-text-opacity: 1;
        color: rgb(0 0 0 / var(--tw-text-opacity))
    }
    .md\\:after\\:hidden::after {
        content: var(--tw-content);
        display: none
    }
    .md\\:hover\\:bg-\\[\\#000\\]:hover {
        --tw-bg-opacity: 1;
        background-color: rgb(0 0 0 / var(--tw-bg-opacity))
    }
}
@media (max-width: 767px) {
    .sm\\:relative {
        position: relative
    }
    .sm\\:\\!top-\\[100px\\] {
        top: 100px !important
    }
    .sm\\:-bottom-\\[15px\\] {
        bottom: -15px
    }
    .sm\\:-top-\\[40px\\] {
        top: -40px
    }
    .sm\\:-top-\\[60px\\] {
        top: -60px
    }
    .sm\\:-top-\\[70px\\] {
        top: -70px
    }
    .sm\\:bottom-0 {
        bottom: 0px
    }
    .sm\\:bottom-7 {
        bottom: 1.75rem
    }
    .sm\\:bottom-\\[30px\\] {
        bottom: 30px
    }
    .sm\\:bottom-\\[50px\\] {
        bottom: 50px
    }
    .sm\\:left-\\[-50\\%\\] {
        left: -50%
    }
    .sm\\:left-\\[10px\\] {
        left: 10px
    }
    .sm\\:right-0 {
        right: 0px
    }
    .sm\\:right-1\\/2 {
        right: 50%
    }
    .sm\\:right-\\[-30px\\] {
        right: -30px
    }
    .sm\\:right-\\[120px\\] {
        right: 120px
    }
    .sm\\:right-\\[170px\\] {
        right: 170px
    }
    .sm\\:right-\\[380px\\] {
        right: 380px
    }
    .sm\\:right-\\[40px\\] {
        right: 40px
    }
    .sm\\:right-\\[45px\\] {
        right: 45px
    }
    .sm\\:top-0 {
        top: 0px
    }
    .sm\\:top-1\\/2 {
        top: 50%
    }
    .sm\\:top-\\[-44px\\] {
        top: -44px
    }
    .sm\\:top-\\[-60px\\] {
        top: -60px
    }
    .sm\\:top-\\[25px\\] {
        top: 25px
    }
    .sm\\:top-\\[65\\%\\] {
        top: 65%
    }
    .sm\\:m-0 {
        margin: 0px
    }
    .sm\\:m-12 {
        margin: 3rem
    }
    .sm\\:m-\\[10px\\] {
        margin: 10px
    }
    .sm\\:\\!mx-0 {
        margin-left: 0px !important;
        margin-right: 0px !important
    }
    .sm\\:mx-0 {
        margin-left: 0px;
        margin-right: 0px
    }
    .sm\\:mx-\\[15px\\] {
        margin-left: 15px;
        margin-right: 15px
    }
    .sm\\:mx-\\[20px\\] {
        margin-left: 20px;
        margin-right: 20px
    }
    .sm\\:mx-\\[40px\\] {
        margin-left: 40px;
        margin-right: 40px
    }
    .sm\\:mx-auto {
        margin-left: auto;
        margin-right: auto
    }
    .sm\\:my-0 {
        margin-top: 0px;
        margin-bottom: 0px
    }
    .sm\\:my-20 {
        margin-top: 5rem;
        margin-bottom: 5rem
    }
    .sm\\:my-6 {
        margin-top: 1.5rem;
        margin-bottom: 1.5rem
    }
    .sm\\:my-\\[25px\\] {
        margin-top: 25px;
        margin-bottom: 25px
    }
    .sm\\:my-\\[5rem\\] {
        margin-top: 5rem;
        margin-bottom: 5rem
    }
    .sm\\:mb-0 {
        margin-bottom: 0px
    }
    .sm\\:mb-10 {
        margin-bottom: 2.5rem
    }
    .sm\\:mb-12 {
        margin-bottom: 3rem
    }
    .sm\\:mb-14 {
        margin-bottom: 3.5rem
    }
    .sm\\:mb-16 {
        margin-bottom: 4rem
    }
    .sm\\:mb-20 {
        margin-bottom: 5rem
    }
    .sm\\:mb-28 {
        margin-bottom: 7rem
    }
    .sm\\:mb-36 {
        margin-bottom: 9rem
    }
    .sm\\:mb-4 {
        margin-bottom: 1rem
    }
    .sm\\:mb-40 {
        margin-bottom: 10rem
    }
    .sm\\:mb-6 {
        margin-bottom: 1.5rem
    }
    .sm\\:mb-8 {
        margin-bottom: 2rem
    }
    .sm\\:mb-\\[10px\\] {
        margin-bottom: 10px
    }
    .sm\\:mb-\\[15px\\] {
        margin-bottom: 15px
    }
    .sm\\:mb-\\[20px\\] {
        margin-bottom: 20px
    }
    .sm\\:mb-\\[25px\\] {
        margin-bottom: 25px
    }
    .sm\\:mb-\\[3\\.5rem\\] {
        margin-bottom: 3.5rem
    }
    .sm\\:mb-\\[30px\\] {
        margin-bottom: 30px
    }
    .sm\\:mb-\\[33px\\] {
        margin-bottom: 33px
    }
    .sm\\:mb-\\[35px\\] {
        margin-bottom: 35px
    }
    .sm\\:mb-\\[40px\\] {
        margin-bottom: 40px
    }
    .sm\\:mb-\\[44px\\] {
        margin-bottom: 44px
    }
    .sm\\:mb-\\[47px\\] {
        margin-bottom: 47px
    }
    .sm\\:mb-\\[50px\\] {
        margin-bottom: 50px
    }
    .sm\\:mb-\\[53px\\] {
        margin-bottom: 53px
    }
    .sm\\:mb-\\[55px\\] {
        margin-bottom: 55px
    }
    .sm\\:mb-\\[5px\\] {
        margin-bottom: 5px
    }
    .sm\\:mb-\\[6\\.5rem\\] {
        margin-bottom: 6.5rem
    }
    .sm\\:mb-\\[60px\\] {
        margin-bottom: 60px
    }
    .sm\\:mb-\\[65px\\] {
        margin-bottom: 65px
    }
    .sm\\:mb-\\[66px\\] {
        margin-bottom: 66px
    }
    .sm\\:mb-\\[7\\.5rem\\] {
        margin-bottom: 7.5rem
    }
    .sm\\:mb-\\[8\\.5rem\\] {
        margin-bottom: 8.5rem
    }
    .sm\\:mb-\\[9px\\] {
        margin-bottom: 9px
    }
    .sm\\:ml-0 {
        margin-left: 0px
    }
    .sm\\:ml-\\[10px\\] {
        margin-left: 10px
    }
    .sm\\:ml-\\[15px\\] {
        margin-left: 15px
    }
    .sm\\:ml-\\[17px\\] {
        margin-left: 17px
    }
    .sm\\:mr-0 {
        margin-right: 0px
    }
    .sm\\:mr-8 {
        margin-right: 2rem
    }
    .sm\\:mr-\\[15px\\] {
        margin-right: 15px
    }
    .sm\\:mr-\\[20px\\] {
        margin-right: 20px
    }
    .sm\\:mt-0 {
        margin-top: 0px
    }
    .sm\\:mt-16 {
        margin-top: 4rem
    }
    .sm\\:mt-20 {
        margin-top: 5rem
    }
    .sm\\:mt-24 {
        margin-top: 6rem
    }
    .sm\\:mt-8 {
        margin-top: 2rem
    }
    .sm\\:mt-\\[10px\\] {
        margin-top: 10px
    }
    .sm\\:mt-\\[16px\\] {
        margin-top: 16px
    }
    .sm\\:mt-\\[20px\\] {
        margin-top: 20px
    }
    .sm\\:mt-\\[225px\\] {
        margin-top: 225px
    }
    .sm\\:mt-\\[30px\\] {
        margin-top: 30px
    }
    .sm\\:mt-\\[50px\\] {
        margin-top: 50px
    }
    .sm\\:mt-\\[5px\\] {
        margin-top: 5px
    }
    .sm\\:mt-\\[60px\\] {
        margin-top: 60px
    }
    .sm\\:mt-\\[70px\\] {
        margin-top: 70px
    }
    .sm\\:block {
        display: block
    }
    .sm\\:inline-block {
        display: inline-block
    }
    .sm\\:inline {
        display: inline
    }
    .sm\\:flex {
        display: flex
    }
    .sm\\:contents {
        display: contents
    }
    .sm\\:hidden {
        display: none
    }
    .sm\\:\\!h-\\[80px\\] {
        height: 80px !important
    }
    .sm\\:h-\\[100vh\\] {
        height: 100vh
    }
    .sm\\:h-\\[150px\\] {
        height: 150px
    }
    .sm\\:h-\\[200px\\] {
        height: 200px
    }
    .sm\\:h-\\[250px\\] {
        height: 250px
    }
    .sm\\:h-\\[300px\\] {
        height: 300px
    }
    .sm\\:h-\\[350px\\] {
        height: 350px
    }
    .sm\\:h-\\[35px\\] {
        height: 35px
    }
    .sm\\:h-\\[365px\\] {
        height: 365px
    }
    .sm\\:h-\\[400px\\] {
        height: 400px
    }
    .sm\\:h-\\[40px\\] {
        height: 40px
    }
    .sm\\:h-\\[450px\\] {
        height: 450px
    }
    .sm\\:h-\\[49vh\\] {
        height: 49vh
    }
    .sm\\:h-\\[500px\\] {
        height: 500px
    }
    .sm\\:h-\\[50px\\] {
        height: 50px
    }
    .sm\\:h-\\[50vh\\] {
        height: 50vh
    }
    .sm\\:h-\\[550px\\] {
        height: 550px
    }
    .sm\\:h-\\[56vh\\] {
        height: 56vh
    }
    .sm\\:h-\\[600px\\] {
        height: 600px
    }
    .sm\\:h-\\[690px\\] {
        height: 690px
    }
    .sm\\:h-\\[700px\\] {
        height: 700px
    }
    .sm\\:h-\\[70px\\] {
        height: 70px
    }
    .sm\\:h-\\[70vh\\] {
        height: 70vh
    }
    .sm\\:h-\\[760px\\] {
        height: 760px
    }
    .sm\\:h-\\[80px\\] {
        height: 80px
    }
    .sm\\:h-auto {
        height: auto
    }
    .sm\\:h-full {
        height: 100%
    }
    .sm\\:\\!w-\\[80px\\] {
        width: 80px !important
    }
    .sm\\:w-10 {
        width: 2.5rem
    }
    .sm\\:w-\\[100px\\] {
        width: 100px
    }
    .sm\\:w-\\[100vw\\] {
        width: 100vw
    }
    .sm\\:w-\\[150px\\] {
        width: 150px
    }
    .sm\\:w-\\[180px\\] {
        width: 180px
    }
    .sm\\:w-\\[20\\%\\] {
        width: 20%
    }
    .sm\\:w-\\[230px\\] {
        width: 230px
    }
    .sm\\:w-\\[250px\\] {
        width: 250px
    }
    .sm\\:w-\\[30\\%\\] {
        width: 30%
    }
    .sm\\:w-\\[35\\%\\] {
        width: 35%
    }
    .sm\\:w-\\[35px\\] {
        width: 35px
    }
    .sm\\:w-\\[40px\\] {
        width: 40px
    }
    .sm\\:w-\\[500px\\] {
        width: 500px
    }
    .sm\\:w-\\[50px\\] {
        width: 50px
    }
    .sm\\:w-\\[55\\%\\] {
        width: 55%
    }
    .sm\\:w-\\[60\\%\\] {
        width: 60%
    }
    .sm\\:w-\\[65\\%\\] {
        width: 65%
    }
    .sm\\:w-\\[70\\%\\] {
        width: 70%
    }
    .sm\\:w-\\[70px\\] {
        width: 70px
    }
    .sm\\:w-\\[75\\%\\] {
        width: 75%
    }
    .sm\\:w-\\[80\\%\\] {
        width: 80%
    }
    .sm\\:w-\\[80px\\] {
        width: 80px
    }
    .sm\\:w-\\[85\\%\\] {
        width: 85%
    }
    .sm\\:w-\\[90\\%\\] {
        width: 90%
    }
    .sm\\:w-full {
        width: 100%
    }
    .sm\\:flex-none {
        flex: none
    }
    .sm\\:scale-75 {
        --tw-scale-x: .75;
        --tw-scale-y: .75;
        transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))
    }
    .sm\\:flex-row {
        flex-direction: row
    }
    .sm\\:flex-col {
        flex-direction: column
    }
    .sm\\:flex-wrap {
        flex-wrap: wrap
    }
    .sm\\:items-start {
        align-items: flex-start
    }
    .sm\\:items-center {
        align-items: center
    }
    .sm\\:justify-start {
        justify-content: flex-start
    }
    .sm\\:justify-end {
        justify-content: flex-end
    }
    .sm\\:\\!justify-center {
        justify-content: center !important
    }
    .sm\\:justify-center {
        justify-content: center
    }
    .sm\\:justify-between {
        justify-content: space-between
    }
    .sm\\:gap-3 {
        gap: 0.75rem
    }
    .sm\\:gap-y-10 {
        row-gap: 2.5rem
    }
    .sm\\:gap-y-\\[15px\\] {
        row-gap: 15px
    }
    .sm\\:gap-y-\\[30px\\] {
        row-gap: 30px
    }
    .sm\\:gap-y-\\[40px\\] {
        row-gap: 40px
    }
    .sm\\:border-0 {
        border-width: 0px
    }
    .sm\\:border-b {
        border-bottom-width: 1px
    }
    .sm\\:border-b-0 {
        border-bottom-width: 0px
    }
    .sm\\:border-t {
        border-top-width: 1px
    }
    .sm\\:border-none {
        border-style: none
    }
    .sm\\:border-mediumgray {
        --tw-border-opacity: 1;
        border-color: rgb(228 228 228 / var(--tw-border-opacity))
    }
    .sm\\:bg-inherit {
        background-color: inherit
    }
    .sm\\:bg-lightgray {
        --tw-bg-opacity: 1;
        background-color: rgb(247 247 247 / var(--tw-bg-opacity))
    }
    .sm\\:bg-white {
        --tw-bg-opacity: 1;
        background-color: rgb(255 255 255 / var(--tw-bg-opacity))
    }
    .sm\\:\\!bg-none {
        background-image: none !important
    }
    .sm\\:bg-\\[right_-350px_center\\] {
        background-position: right -350px center
    }
    .sm\\:p-0 {
        padding: 0px
    }
    .sm\\:p-16 {
        padding: 4rem
    }
    .sm\\:p-20 {
        padding: 5rem
    }
    .sm\\:p-\\[20px\\] {
        padding: 20px
    }
    .sm\\:p-\\[30px\\] {
        padding: 30px
    }
    .sm\\:p-\\[38px\\] {
        padding: 38px
    }
    .sm\\:p-\\[55px\\] {
        padding: 55px
    }
    .sm\\:\\!px-0 {
        padding-left: 0px !important;
        padding-right: 0px !important
    }
    .sm\\:\\!px-\\[15px\\] {
        padding-left: 15px !important;
        padding-right: 15px !important
    }
    .sm\\:\\!py-\\[10px\\] {
        padding-top: 10px !important;
        padding-bottom: 10px !important
    }
    .sm\\:px-0 {
        padding-left: 0px;
        padding-right: 0px
    }
    .sm\\:px-10 {
        padding-left: 2.5rem;
        padding-right: 2.5rem
    }
    .sm\\:px-12 {
        padding-left: 3rem;
        padding-right: 3rem
    }
    .sm\\:px-24 {
        padding-left: 6rem;
        padding-right: 6rem
    }
    .sm\\:px-28 {
        padding-left: 7rem;
        padding-right: 7rem
    }
    .sm\\:px-4 {
        padding-left: 1rem;
        padding-right: 1rem
    }
    .sm\\:px-8 {
        padding-left: 2rem;
        padding-right: 2rem
    }
    .sm\\:px-\\[10\\%\\] {
        padding-left: 10%;
        padding-right: 10%
    }
    .sm\\:px-\\[100px\\] {
        padding-left: 100px;
        padding-right: 100px
    }
    .sm\\:px-\\[10px\\] {
        padding-left: 10px;
        padding-right: 10px
    }
    .sm\\:px-\\[15px\\] {
        padding-left: 15px;
        padding-right: 15px
    }
    .sm\\:px-\\[2\\.5rem\\] {
        padding-left: 2.5rem;
        padding-right: 2.5rem
    }
    .sm\\:px-\\[20px\\] {
        padding-left: 20px;
        padding-right: 20px
    }
    .sm\\:px-\\[25px\\] {
        padding-left: 25px;
        padding-right: 25px
    }
    .sm\\:px-\\[2rem\\] {
        padding-left: 2rem;
        padding-right: 2rem
    }
    .sm\\:px-\\[30px\\] {
        padding-left: 30px;
        padding-right: 30px
    }
    .sm\\:px-\\[33px\\] {
        padding-left: 33px;
        padding-right: 33px
    }
    .sm\\:px-\\[35px\\] {
        padding-left: 35px;
        padding-right: 35px
    }
    .sm\\:px-\\[4\\.5rem\\] {
        padding-left: 4.5rem;
        padding-right: 4.5rem
    }
    .sm\\:px-\\[5px\\] {
        padding-left: 5px;
        padding-right: 5px
    }
    .sm\\:px-\\[80px\\] {
        padding-left: 80px;
        padding-right: 80px
    }
    .sm\\:px-\\[8px\\] {
        padding-left: 8px;
        padding-right: 8px
    }
    .sm\\:py-0 {
        padding-top: 0px;
        padding-bottom: 0px
    }
    .sm\\:py-12 {
        padding-top: 3rem;
        padding-bottom: 3rem
    }
    .sm\\:py-16 {
        padding-top: 4rem;
        padding-bottom: 4rem
    }
    .sm\\:py-\\[15\\%\\] {
        padding-top: 15%;
        padding-bottom: 15%
    }
    .sm\\:py-\\[15px\\] {
        padding-top: 15px;
        padding-bottom: 15px
    }
    .sm\\:py-\\[20px\\] {
        padding-top: 20px;
        padding-bottom: 20px
    }
    .sm\\:py-\\[25px\\] {
        padding-top: 25px;
        padding-bottom: 25px
    }
    .sm\\:py-\\[30px\\] {
        padding-top: 30px;
        padding-bottom: 30px
    }
    .sm\\:py-\\[33px\\] {
        padding-top: 33px;
        padding-bottom: 33px
    }
    .sm\\:py-\\[40px\\] {
        padding-top: 40px;
        padding-bottom: 40px
    }
    .sm\\:py-\\[50px\\] {
        padding-top: 50px;
        padding-bottom: 50px
    }
    .sm\\:py-\\[60px\\] {
        padding-top: 60px;
        padding-bottom: 60px
    }
    .sm\\:py-\\[70px\\] {
        padding-top: 70px;
        padding-bottom: 70px
    }
    .sm\\:py-\\[75px\\] {
        padding-top: 75px;
        padding-bottom: 75px
    }
    .sm\\:py-\\[80px\\] {
        padding-top: 80px;
        padding-bottom: 80px
    }
    .sm\\:\\!pl-0 {
        padding-left: 0px !important
    }
    .sm\\:\\!pt-\\[50px\\] {
        padding-top: 50px !important
    }
    .sm\\:pb-0 {
        padding-bottom: 0px
    }
    .sm\\:pb-20 {
        padding-bottom: 5rem
    }
    .sm\\:pb-24 {
        padding-bottom: 6rem
    }
    .sm\\:pb-32 {
        padding-bottom: 8rem
    }
    .sm\\:pb-\\[15px\\] {
        padding-bottom: 15px
    }
    .sm\\:pb-\\[50px\\] {
        padding-bottom: 50px
    }
    .sm\\:pb-\\[7\\%\\] {
        padding-bottom: 7%
    }
    .sm\\:pb-\\[70px\\] {
        padding-bottom: 70px
    }
    .sm\\:pb-\\[75px\\] {
        padding-bottom: 75px
    }
    .sm\\:pb-\\[7px\\] {
        padding-bottom: 7px
    }
    .sm\\:pb-\\[80px\\] {
        padding-bottom: 80px
    }
    .sm\\:pl-0 {
        padding-left: 0px
    }
    .sm\\:pl-\\[15px\\] {
        padding-left: 15px
    }
    .sm\\:pl-\\[55px\\] {
        padding-left: 55px
    }
    .sm\\:pl-\\[8px\\] {
        padding-left: 8px
    }
    .sm\\:pr-0 {
        padding-right: 0px
    }
    .sm\\:pr-\\[15px\\] {
        padding-right: 15px
    }
    .sm\\:pr-\\[50px\\] {
        padding-right: 50px
    }
    .sm\\:pr-\\[8px\\] {
        padding-right: 8px
    }
    .sm\\:pt-0 {
        padding-top: 0px
    }
    .sm\\:pt-16 {
        padding-top: 4rem
    }
    .sm\\:pt-24 {
        padding-top: 6rem
    }
    .sm\\:pt-\\[0px\\] {
        padding-top: 0px
    }
    .sm\\:pt-\\[100px\\] {
        padding-top: 100px
    }
    .sm\\:pt-\\[10px\\] {
        padding-top: 10px
    }
    .sm\\:pt-\\[20px\\] {
        padding-top: 20px
    }
    .sm\\:pt-\\[40px\\] {
        padding-top: 40px
    }
    .sm\\:pt-\\[50px\\] {
        padding-top: 50px
    }
    .sm\\:pt-\\[80px\\] {
        padding-top: 80px
    }
    .sm\\:text-left {
        text-align: left
    }
    .sm\\:\\!text-center {
        text-align: center !important
    }
    .sm\\:text-center {
        text-align: center
    }
    .sm\\:text-start {
        text-align: start
    }
    .sm\\:text-end {
        text-align: end
    }
    .sm\\:text-\\[100px\\] {
        font-size: 100px
    }
    .sm\\:text-\\[108px\\] {
        font-size: 108px
    }
    .sm\\:text-\\[110px\\] {
        font-size: 110px
    }
    .sm\\:text-\\[16px\\] {
        font-size: 16px
    }
    .sm\\:text-\\[20px\\] {
        font-size: 20px
    }
    .sm\\:text-\\[25px\\] {
        font-size: 25px
    }
    .sm\\:text-\\[27px\\] {
        font-size: 27px
    }
    .sm\\:text-\\[28px\\] {
        font-size: 28px
    }
    .sm\\:text-\\[30px\\] {
        font-size: 30px
    }
    .sm\\:text-\\[31px\\] {
        font-size: 31px
    }
    .sm\\:text-\\[33px\\] {
        font-size: 33px
    }
    .sm\\:text-\\[35px\\] {
        font-size: 35px
    }
    .sm\\:text-\\[44px\\] {
        font-size: 44px
    }
    .sm\\:text-\\[45px\\] {
        font-size: 45px
    }
    .sm\\:text-\\[50px\\] {
        font-size: 50px
    }
    .sm\\:text-\\[65px\\] {
        font-size: 65px
    }
    .sm\\:text-\\[66px\\] {
        font-size: 66px
    }
    .sm\\:text-\\[70px\\] {
        font-size: 70px
    }
    .sm\\:text-\\[75px\\] {
        font-size: 75px
    }
    .sm\\:text-\\[8rem\\] {
        font-size: 8rem
    }
    .sm\\:text-\\[90px\\] {
        font-size: 90px
    }
    .sm\\:text-\\[99px\\] {
        font-size: 99px
    }
    .sm\\:text-lg {
        font-size: 18px;
        line-height: 22px
    }
    .sm\\:text-sm {
        font-size: 13px;
        line-height: 22px
    }
    .sm\\:text-xmd {
        font-size: 16px;
        line-height: 28px
    }
    .sm\\:text-xs {
        font-size: 12px;
        line-height: 16px
    }
    .sm\\:leading-10 {
        line-height: 2.5rem
    }
    .sm\\:leading-\\[100px\\] {
        line-height: 100px
    }
    .sm\\:leading-\\[108px\\] {
        line-height: 108px
    }
    .sm\\:leading-\\[22px\\] {
        line-height: 22px
    }
    .sm\\:leading-\\[26px\\] {
        line-height: 26px
    }
    .sm\\:leading-\\[30px\\] {
        line-height: 30px
    }
    .sm\\:leading-\\[32px\\] {
        line-height: 32px
    }
    .sm\\:leading-\\[34px\\] {
        line-height: 34px
    }
    .sm\\:leading-\\[36px\\] {
        line-height: 36px
    }
    .sm\\:leading-\\[40px\\] {
        line-height: 40px
    }
    .sm\\:leading-\\[41px\\] {
        line-height: 41px
    }
    .sm\\:leading-\\[43px\\] {
        line-height: 43px
    }
    .sm\\:leading-\\[45px\\] {
        line-height: 45px
    }
    .sm\\:leading-\\[50px\\] {
        line-height: 50px
    }
    .sm\\:leading-\\[65px\\] {
        line-height: 65px
    }
    .sm\\:leading-\\[70px\\] {
        line-height: 70px
    }
    .sm\\:leading-\\[80px\\] {
        line-height: 80px
    }
    .sm\\:leading-\\[90px\\] {
        line-height: 90px
    }
    .sm\\:leading-none {
        line-height: 1
    }
    .sm\\:-tracking-\\[\\.5px\\] {
        letter-spacing: -.5px
    }
    .sm\\:-tracking-\\[0\\.5px\\] {
        letter-spacing: -0.5px
    }
    .sm\\:-tracking-\\[1\\.5px\\] {
        letter-spacing: -1.5px
    }
    .sm\\:-tracking-\\[1px\\] {
        letter-spacing: -1px
    }
    .sm\\:-tracking-\\[3px\\] {
        letter-spacing: -3px
    }
    .sm\\:-tracking-\\[5px\\] {
        letter-spacing: -5px
    }
    .sm\\:tracking-\\[-\\.5px\\] {
        letter-spacing: -.5px
    }
    .sm\\:tracking-\\[-0\\.5px\\] {
        letter-spacing: -0.5px
    }
    .sm\\:tracking-\\[-1px\\] {
        letter-spacing: -1px
    }
    .sm\\:shadow-none {
        --tw-shadow: 0 0 #0000;
        --tw-shadow-colored: 0 0 #0000;
        box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)
    }
    .sm\\:before\\:hidden::before {
        content: var(--tw-content);
        display: none
    }
    .sm\\:before\\:border-0::before {
        content: var(--tw-content);
        border-width: 0px
    }
}
@media (max-width: 575px) {
    .xs\\:absolute {
        position: absolute
    }
    .xs\\:-bottom-\\[15px\\] {
        bottom: -15px
    }
    .xs\\:-bottom-\\[160px\\] {
        bottom: -160px
    }
    .xs\\:-bottom-\\[30px\\] {
        bottom: -30px
    }
    .xs\\:-left-\\[15px\\] {
        left: -15px
    }
    .xs\\:-right-\\[15px\\] {
        right: -15px
    }
    .xs\\:-top-\\[70px\\] {
        top: -70px
    }
    .xs\\:bottom-0 {
        bottom: 0px
    }
    .xs\\:bottom-\\[-15px\\] {
        bottom: -15px
    }
    .xs\\:bottom-\\[-50px\\] {
        bottom: -50px
    }
    .xs\\:bottom-\\[19px\\] {
        bottom: 19px
    }
    .xs\\:bottom-\\[25px\\] {
        bottom: 25px
    }
    .xs\\:bottom-\\[4\\.5rem\\] {
        bottom: 4.5rem
    }
    .xs\\:bottom-\\[50px\\] {
        bottom: 50px
    }
    .xs\\:bottom-\\[80px\\] {
        bottom: 80px
    }
    .xs\\:left-0 {
        left: 0px
    }
    .xs\\:left-1\\/2 {
        left: 50%
    }
    .xs\\:left-\\[-25px\\] {
        left: -25px
    }
    .xs\\:left-\\[10px\\] {
        left: 10px
    }
    .xs\\:left-\\[15px\\] {
        left: 15px
    }
    .xs\\:left-\\[20px\\] {
        left: 20px
    }
    .xs\\:left-\\[25px\\] {
        left: 25px
    }
    .xs\\:left-\\[calc\\(50\\%\\+100px\\)\\] {
        left: calc(50% + 100px)
    }
    .xs\\:left-\\[calc\\(50\\%\\+115px\\)\\] {
        left: calc(50% + 115px)
    }
    .xs\\:left-\\[calc\\(50\\%-25px\\)\\] {
        left: calc(50% - 25px)
    }
    .xs\\:left-\\[calc\\(50\\%-50px\\)\\] {
        left: calc(50% - 50px)
    }
    .xs\\:left-auto {
        left: auto
    }
    .xs\\:right-0 {
        right: 0px
    }
    .xs\\:right-\\[-50px\\] {
        right: -50px
    }
    .xs\\:right-\\[10px\\] {
        right: 10px
    }
    .xs\\:right-\\[15px\\] {
        right: 15px
    }
    .xs\\:right-\\[20px\\] {
        right: 20px
    }
    .xs\\:right-\\[25px\\] {
        right: 25px
    }
    .xs\\:right-\\[320px\\] {
        right: 320px
    }
    .xs\\:right-auto {
        right: auto
    }
    .xs\\:top-0 {
        top: 0px
    }
    .xs\\:top-\\[-50px\\] {
        top: -50px
    }
    .xs\\:top-\\[-80px\\] {
        top: -80px
    }
    .xs\\:top-\\[26px\\] {
        top: 26px
    }
    .xs\\:m-0 {
        margin: 0px
    }
    .xs\\:m-\\[0_auto\\] {
        margin: 0 auto
    }
    .xs\\:m-\\[13px\\] {
        margin: 13px
    }
    .xs\\:\\!mx-auto {
        margin-left: auto !important;
        margin-right: auto !important
    }
    .xs\\:\\!my-\\[30px\\] {
        margin-top: 30px !important;
        margin-bottom: 30px !important
    }
    .xs\\:mx-0 {
        margin-left: 0px;
        margin-right: 0px
    }
    .xs\\:mx-\\[15px\\] {
        margin-left: 15px;
        margin-right: 15px
    }
    .xs\\:mx-\\[40px\\] {
        margin-left: 40px;
        margin-right: 40px
    }
    .xs\\:mx-auto {
        margin-left: auto;
        margin-right: auto
    }
    .xs\\:my-0 {
        margin-top: 0px;
        margin-bottom: 0px
    }
    .xs\\:my-\\[15px\\] {
        margin-top: 15px;
        margin-bottom: 15px
    }
    .xs\\:my-\\[30px\\] {
        margin-top: 30px;
        margin-bottom: 30px
    }
    .xs\\:my-\\[40px\\] {
        margin-top: 40px;
        margin-bottom: 40px
    }
    .xs\\:\\!mb-0 {
        margin-bottom: 0px !important
    }
    .xs\\:\\!mb-\\[10px\\] {
        margin-bottom: 10px !important
    }
    .xs\\:\\!mb-\\[15px\\] {
        margin-bottom: 15px !important
    }
    .xs\\:\\!mr-0 {
        margin-right: 0px !important
    }
    .xs\\:\\!mt-\\[65px\\] {
        margin-top: 65px !important
    }
    .xs\\:\\!mt-\\[70px\\] {
        margin-top: 70px !important
    }
    .xs\\:mb-0 {
        margin-bottom: 0px
    }
    .xs\\:mb-10 {
        margin-bottom: 2.5rem
    }
    .xs\\:mb-12 {
        margin-bottom: 3rem
    }
    .xs\\:mb-14 {
        margin-bottom: 3.5rem
    }
    .xs\\:mb-16 {
        margin-bottom: 4rem
    }
    .xs\\:mb-20 {
        margin-bottom: 5rem
    }
    .xs\\:mb-28 {
        margin-bottom: 7rem
    }
    .xs\\:mb-5 {
        margin-bottom: 1.25rem
    }
    .xs\\:mb-8 {
        margin-bottom: 2rem
    }
    .xs\\:mb-\\[0px\\] {
        margin-bottom: 0px
    }
    .xs\\:mb-\\[10\\%\\] {
        margin-bottom: 10%
    }
    .xs\\:mb-\\[10px\\] {
        margin-bottom: 10px
    }
    .xs\\:mb-\\[110px\\] {
        margin-bottom: 110px
    }
    .xs\\:mb-\\[13px\\] {
        margin-bottom: 13px
    }
    .xs\\:mb-\\[15px\\] {
        margin-bottom: 15px
    }
    .xs\\:mb-\\[20px\\] {
        margin-bottom: 20px
    }
    .xs\\:mb-\\[25px\\] {
        margin-bottom: 25px
    }
    .xs\\:mb-\\[2px\\] {
        margin-bottom: 2px
    }
    .xs\\:mb-\\[30px\\] {
        margin-bottom: 30px
    }
    .xs\\:mb-\\[35px\\] {
        margin-bottom: 35px
    }
    .xs\\:mb-\\[4\\.5rem\\] {
        margin-bottom: 4.5rem
    }
    .xs\\:mb-\\[40px\\] {
        margin-bottom: 40px
    }
    .xs\\:mb-\\[46px\\] {
        margin-bottom: 46px
    }
    .xs\\:mb-\\[49px\\] {
        margin-bottom: 49px
    }
    .xs\\:mb-\\[50px\\] {
        margin-bottom: 50px
    }
    .xs\\:mb-\\[5px\\] {
        margin-bottom: 5px
    }
    .xs\\:mb-\\[60px\\] {
        margin-bottom: 60px
    }
    .xs\\:mb-\\[70px\\] {
        margin-bottom: 70px
    }
    .xs\\:mb-\\[7px\\] {
        margin-bottom: 7px
    }
    .xs\\:ml-0 {
        margin-left: 0px
    }
    .xs\\:mr-0 {
        margin-right: 0px
    }
    .xs\\:mr-8 {
        margin-right: 2rem
    }
    .xs\\:mr-\\[10px\\] {
        margin-right: 10px
    }
    .xs\\:mr-\\[15px\\] {
        margin-right: 15px
    }
    .xs\\:mr-\\[17px\\] {
        margin-right: 17px
    }
    .xs\\:mr-\\[20px\\] {
        margin-right: 20px
    }
    .xs\\:mr-\\[8px\\] {
        margin-right: 8px
    }
    .xs\\:mt-0 {
        margin-top: 0px
    }
    .xs\\:mt-12 {
        margin-top: 3rem
    }
    .xs\\:mt-16 {
        margin-top: 4rem
    }
    .xs\\:mt-20 {
        margin-top: 5rem
    }
    .xs\\:mt-24 {
        margin-top: 6rem
    }
    .xs\\:mt-32 {
        margin-top: 8rem
    }
    .xs\\:mt-8 {
        margin-top: 2rem
    }
    .xs\\:mt-\\[10px\\] {
        margin-top: 10px
    }
    .xs\\:mt-\\[15px\\] {
        margin-top: 15px
    }
    .xs\\:mt-\\[18\\%\\] {
        margin-top: 18%
    }
    .xs\\:mt-\\[185px\\] {
        margin-top: 185px
    }
    .xs\\:mt-\\[20px\\] {
        margin-top: 20px
    }
    .xs\\:mt-\\[30px\\] {
        margin-top: 30px
    }
    .xs\\:mt-\\[35px\\] {
        margin-top: 35px
    }
    .xs\\:mt-\\[5\\.5rem\\] {
        margin-top: 5.5rem
    }
    .xs\\:mt-\\[60px\\] {
        margin-top: 60px
    }
    .xs\\:mt-\\[65px\\] {
        margin-top: 65px
    }
    .xs\\:\\!block {
        display: block !important
    }
    .xs\\:block {
        display: block
    }
    .xs\\:flex {
        display: flex
    }
    .xs\\:grid {
        display: grid
    }
    .xs\\:\\!hidden {
        display: none !important
    }
    .xs\\:hidden {
        display: none
    }
    .xs\\:h-1\\/2 {
        height: 50%
    }
    .xs\\:h-\\[115px\\] {
        height: 115px
    }
    .xs\\:h-\\[150px\\] {
        height: 150px
    }
    .xs\\:h-\\[200px\\] {
        height: 200px
    }
    .xs\\:h-\\[250px\\] {
        height: 250px
    }
    .xs\\:h-\\[280px\\] {
        height: 280px
    }
    .xs\\:h-\\[300px\\] {
        height: 300px
    }
    .xs\\:h-\\[320px\\] {
        height: 320px
    }
    .xs\\:h-\\[350px\\] {
        height: 350px
    }
    .xs\\:h-\\[357px\\] {
        height: 357px
    }
    .xs\\:h-\\[380px\\] {
        height: 380px
    }
    .xs\\:h-\\[400px\\] {
        height: 400px
    }
    .xs\\:h-\\[40vh\\] {
        height: 40vh
    }
    .xs\\:h-\\[420px\\] {
        height: 420px
    }
    .xs\\:h-\\[450px\\] {
        height: 450px
    }
    .xs\\:h-\\[45vh\\] {
        height: 45vh
    }
    .xs\\:h-\\[480px\\] {
        height: 480px
    }
    .xs\\:h-\\[50vh\\] {
        height: 50vh
    }
    .xs\\:h-\\[528px\\;\\] {
        height: 528px;
    }
    .xs\\:h-\\[564px\\] {
        height: 564px
    }
    .xs\\:h-\\[600px\\] {
        height: 600px
    }
    .xs\\:h-\\[60px\\] {
        height: 60px
    }
    .xs\\:h-\\[650px\\] {
        height: 650px
    }
    .xs\\:h-\\[664px\\] {
        height: 664px
    }
    .xs\\:h-\\[70\\%\\] {
        height: 70%
    }
    .xs\\:h-\\[750px\\] {
        height: 750px
    }
    .xs\\:h-\\[80px\\] {
        height: 80px
    }
    .xs\\:h-\\[calc\\(100vh-60px\\)\\] {
        height: calc(100vh - 60px)
    }
    .xs\\:h-auto {
        height: auto
    }
    .xs\\:max-h-\\[calc\\(100vh-60px\\)\\] {
        max-height: calc(100vh - 60px)
    }
    .xs\\:max-h-\\[calc\\(65vh-60px\\)\\] {
        max-height: calc(65vh - 60px)
    }
    .xs\\:w-1\\/2 {
        width: 50%
    }
    .xs\\:w-11\\/12 {
        width: 91.666667%
    }
    .xs\\:w-4\\/5 {
        width: 80%
    }
    .xs\\:w-\\[100px\\] {
        width: 100px
    }
    .xs\\:w-\\[200\\%\\] {
        width: 200%
    }
    .xs\\:w-\\[300px\\] {
        width: 300px
    }
    .xs\\:w-\\[315px\\] {
        width: 315px
    }
    .xs\\:w-\\[320px\\] {
        width: 320px
    }
    .xs\\:w-\\[370px\\] {
        width: 370px
    }
    .xs\\:w-\\[40\\%\\] {
        width: 40%
    }
    .xs\\:w-\\[400px\\] {
        width: 400px
    }
    .xs\\:w-\\[40px\\] {
        width: 40px
    }
    .xs\\:w-\\[420px\\] {
        width: 420px
    }
    .xs\\:w-\\[450px\\] {
        width: 450px
    }
    .xs\\:w-\\[50px\\] {
        width: 50px
    }
    .xs\\:w-\\[60\\%\\] {
        width: 60%
    }
    .xs\\:w-\\[60px\\] {
        width: 60px
    }
    .xs\\:w-\\[65\\%\\] {
        width: 65%
    }
    .xs\\:w-\\[70\\%\\] {
        width: 70%
    }
    .xs\\:w-\\[75\\%\\] {
        width: 75%
    }
    .xs\\:w-\\[80\\%\\] {
        width: 80%
    }
    .xs\\:w-\\[80px\\] {
        width: 80px
    }
    .xs\\:w-\\[85\\%\\] {
        width: 85%
    }
    .xs\\:w-\\[90\\%\\] {
        width: 90%
    }
    .xs\\:w-\\[95\\%\\] {
        width: 95%
    }
    .xs\\:w-\\[98\\%\\] {
        width: 98%
    }
    .xs\\:w-\\[99\\%\\] {
        width: 99%
    }
    .xs\\:w-fit {
        width: -moz-fit-content;
        width: fit-content
    }
    .xs\\:w-full {
        width: 100%
    }
    .xs\\:max-w-fit {
        max-width: -moz-fit-content;
        max-width: fit-content
    }
    .xs\\:-translate-x-1\\/2 {
        --tw-translate-x: -50%;
        transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))
    }
    .xs\\:flex-row {
        flex-direction: row
    }
    .xs\\:flex-col {
        flex-direction: column
    }
    .xs\\:flex-col-reverse {
        flex-direction: column-reverse
    }
    .xs\\:flex-nowrap {
        flex-wrap: nowrap
    }
    .xs\\:items-start {
        align-items: flex-start
    }
    .xs\\:items-center {
        align-items: center
    }
    .xs\\:justify-start {
        justify-content: flex-start
    }
    .xs\\:justify-end {
        justify-content: flex-end
    }
    .xs\\:justify-center {
        justify-content: center
    }
    .xs\\:gap-y-\\[10px\\] {
        row-gap: 10px
    }
    .xs\\:gap-y-\\[15px\\] {
        row-gap: 15px
    }
    .xs\\:gap-y-\\[30px\\] {
        row-gap: 30px
    }
    .xs\\:gap-y-\\[40px\\] {
        row-gap: 40px
    }
    .xs\\:gap-y-\\[50px\\] {
        row-gap: 50px
    }
    .xs\\:gap-y-\\[6rem\\] {
        row-gap: 6rem
    }
    .xs\\:overflow-hidden {
        overflow: hidden
    }
    .xs\\:rounded-none {
        border-radius: 0px
    }
    .xs\\:border-0 {
        border-width: 0px
    }
    .xs\\:border-y {
        border-top-width: 1px;
        border-bottom-width: 1px
    }
    .xs\\:border-b {
        border-bottom-width: 1px
    }
    .xs\\:border-r-0 {
        border-right-width: 0px
    }
    .xs\\:border-t-0 {
        border-top-width: 0px
    }
    .xs\\:border-none {
        border-style: none
    }
    .xs\\:bg-\\[length\\:53\\%\\] {
        background-size: 53%
    }
    .xs\\:bg-\\[center_center\\] {
        background-position: center center
    }
    .xs\\:bg-\\[left_center\\] {
        background-position: left center
    }
    .xs\\:bg-center {
        background-position: center
    }
    .xs\\:\\!p-0 {
        padding: 0px !important
    }
    .xs\\:p-0 {
        padding: 0px
    }
    .xs\\:p-10 {
        padding: 2.5rem
    }
    .xs\\:p-12 {
        padding: 3rem
    }
    .xs\\:p-14 {
        padding: 3.5rem
    }
    .xs\\:p-16 {
        padding: 4rem
    }
    .xs\\:p-20 {
        padding: 5rem
    }
    .xs\\:p-28 {
        padding: 7rem
    }
    .xs\\:p-8 {
        padding: 2rem
    }
    .xs\\:p-\\[10px\\] {
        padding: 10px
    }
    .xs\\:p-\\[15px\\] {
        padding: 15px
    }
    .xs\\:p-\\[22px\\] {
        padding: 22px
    }
    .xs\\:p-\\[25px\\] {
        padding: 25px
    }
    .xs\\:p-\\[30px\\] {
        padding: 30px
    }
    .xs\\:p-\\[3rem\\] {
        padding: 3rem
    }
    .xs\\:p-\\[6\\%\\] {
        padding: 6%
    }
    .xs\\:\\!px-0 {
        padding-left: 0px !important;
        padding-right: 0px !important
    }
    .xs\\:\\!px-\\[15px\\] {
        padding-left: 15px !important;
        padding-right: 15px !important
    }
    .xs\\:\\!px-\\[32px\\] {
        padding-left: 32px !important;
        padding-right: 32px !important
    }
    .xs\\:\\!py-\\[10px\\] {
        padding-top: 10px !important;
        padding-bottom: 10px !important
    }
    .xs\\:\\!py-\\[12px\\] {
        padding-top: 12px !important;
        padding-bottom: 12px !important
    }
    .xs\\:px-0 {
        padding-left: 0px;
        padding-right: 0px
    }
    .xs\\:px-10 {
        padding-left: 2.5rem;
        padding-right: 2.5rem
    }
    .xs\\:px-12 {
        padding-left: 3rem;
        padding-right: 3rem
    }
    .xs\\:px-20 {
        padding-left: 5rem;
        padding-right: 5rem
    }
    .xs\\:px-24 {
        padding-left: 6rem;
        padding-right: 6rem
    }
    .xs\\:px-5 {
        padding-left: 1.25rem;
        padding-right: 1.25rem
    }
    .xs\\:px-7 {
        padding-left: 1.75rem;
        padding-right: 1.75rem
    }
    .xs\\:px-8 {
        padding-left: 2rem;
        padding-right: 2rem
    }
    .xs\\:px-\\[0\\] {
        padding-left: 0;
        padding-right: 0
    }
    .xs\\:px-\\[15px\\] {
        padding-left: 15px;
        padding-right: 15px
    }
    .xs\\:px-\\[2\\%\\] {
        padding-left: 2%;
        padding-right: 2%
    }
    .xs\\:px-\\[20px\\] {
        padding-left: 20px;
        padding-right: 20px
    }
    .xs\\:px-\\[22px\\] {
        padding-left: 22px;
        padding-right: 22px
    }
    .xs\\:px-\\[25px\\] {
        padding-left: 25px;
        padding-right: 25px
    }
    .xs\\:px-\\[3\\.5rem\\] {
        padding-left: 3.5rem;
        padding-right: 3.5rem
    }
    .xs\\:px-\\[30px\\] {
        padding-left: 30px;
        padding-right: 30px
    }
    .xs\\:px-\\[40px\\] {
        padding-left: 40px;
        padding-right: 40px
    }
    .xs\\:px-\\[4rem\\] {
        padding-left: 4rem;
        padding-right: 4rem
    }
    .xs\\:py-0 {
        padding-top: 0px;
        padding-bottom: 0px
    }
    .xs\\:py-24 {
        padding-top: 6rem;
        padding-bottom: 6rem
    }
    .xs\\:py-\\[13\\%\\] {
        padding-top: 13%;
        padding-bottom: 13%
    }
    .xs\\:py-\\[13px\\] {
        padding-top: 13px;
        padding-bottom: 13px
    }
    .xs\\:py-\\[15px\\] {
        padding-top: 15px;
        padding-bottom: 15px
    }
    .xs\\:py-\\[2rem\\] {
        padding-top: 2rem;
        padding-bottom: 2rem
    }
    .xs\\:py-\\[30px\\] {
        padding-top: 30px;
        padding-bottom: 30px
    }
    .xs\\:py-\\[35px\\] {
        padding-top: 35px;
        padding-bottom: 35px
    }
    .xs\\:py-\\[40px\\] {
        padding-top: 40px;
        padding-bottom: 40px
    }
    .xs\\:py-\\[44px\\] {
        padding-top: 44px;
        padding-bottom: 44px
    }
    .xs\\:py-\\[50px\\] {
        padding-top: 50px;
        padding-bottom: 50px
    }
    .xs\\:py-\\[6\\.5rem\\] {
        padding-top: 6.5rem;
        padding-bottom: 6.5rem
    }
    .xs\\:py-\\[6rem\\] {
        padding-top: 6rem;
        padding-bottom: 6rem
    }
    .xs\\:py-\\[8\\%\\] {
        padding-top: 8%;
        padding-bottom: 8%
    }
    .xs\\:py-\\[80px\\] {
        padding-top: 80px;
        padding-bottom: 80px
    }
    .xs\\:\\!pr-0 {
        padding-right: 0px !important
    }
    .xs\\:\\!pr-\\[32px\\] {
        padding-right: 32px !important
    }
    .xs\\:pb-0 {
        padding-bottom: 0px
    }
    .xs\\:pb-24 {
        padding-bottom: 6rem
    }
    .xs\\:pb-28 {
        padding-bottom: 7rem
    }
    .xs\\:pb-8 {
        padding-bottom: 2rem
    }
    .xs\\:pb-\\[25px\\] {
        padding-bottom: 25px
    }
    .xs\\:pb-\\[50px\\] {
        padding-bottom: 50px
    }
    .xs\\:pl-0 {
        padding-left: 0px
    }
    .xs\\:pl-8 {
        padding-left: 2rem
    }
    .xs\\:pl-\\[15px\\] {
        padding-left: 15px
    }
    .xs\\:pl-\\[20px\\] {
        padding-left: 20px
    }
    .xs\\:pl-\\[30px\\] {
        padding-left: 30px
    }
    .xs\\:pr-0 {
        padding-right: 0px
    }
    .xs\\:pr-\\[15px\\] {
        padding-right: 15px
    }
    .xs\\:pr-\\[50px\\] {
        padding-right: 50px
    }
    .xs\\:pt-0 {
        padding-top: 0px
    }
    .xs\\:pt-16 {
        padding-top: 4rem
    }
    .xs\\:pt-32 {
        padding-top: 8rem
    }
    .xs\\:pt-6 {
        padding-top: 1.5rem
    }
    .xs\\:pt-\\[10px\\] {
        padding-top: 10px
    }
    .xs\\:pt-\\[15px\\] {
        padding-top: 15px
    }
    .xs\\:pt-\\[50px\\] {
        padding-top: 50px
    }
    .xs\\:pt-\\[9\\%\\] {
        padding-top: 9%
    }
    .xs\\:text-left {
        text-align: left
    }
    .xs\\:\\!text-center {
        text-align: center !important
    }
    .xs\\:text-center {
        text-align: center
    }
    .xs\\:\\!text-start {
        text-align: start !important
    }
    .xs\\:text-start {
        text-align: start
    }
    .xs\\:text-\\[10px\\] {
        font-size: 10px
    }
    .xs\\:text-\\[11px\\] {
        font-size: 11px
    }
    .xs\\:text-\\[160px\\] {
        font-size: 160px
    }
    .xs\\:text-\\[16px\\] {
        font-size: 16px
    }
    .xs\\:text-\\[19\\.8px\\] {
        font-size: 19.8px
    }
    .xs\\:text-\\[20px\\] {
        font-size: 20px
    }
    .xs\\:text-\\[22px\\] {
        font-size: 22px
    }
    .xs\\:text-\\[25px\\] {
        font-size: 25px
    }
    .xs\\:text-\\[28px\\] {
        font-size: 28px
    }
    .xs\\:text-\\[30px\\] {
        font-size: 30px
    }
    .xs\\:text-\\[35px\\] {
        font-size: 35px
    }
    .xs\\:text-\\[38px\\] {
        font-size: 38px
    }
    .xs\\:text-\\[40px\\] {
        font-size: 40px
    }
    .xs\\:text-\\[45px\\] {
        font-size: 45px
    }
    .xs\\:text-\\[50px\\] {
        font-size: 50px
    }
    .xs\\:text-\\[55px\\] {
        font-size: 55px
    }
    .xs\\:text-\\[5rem\\] {
        font-size: 5rem
    }
    .xs\\:text-\\[60px\\] {
        font-size: 60px
    }
    .xs\\:text-\\[76px\\] {
        font-size: 76px
    }
    .xs\\:text-\\[80px\\] {
        font-size: 80px
    }
    .xs\\:text-\\[84px\\] {
        font-size: 84px
    }
    .xs\\:text-base {
        font-size: 15px;
        line-height: 30px
    }
    .xs\\:text-lg {
        font-size: 18px;
        line-height: 22px
    }
    .xs\\:text-md {
        font-size: 14px;
        line-height: 20px
    }
    .xs\\:text-sm {
        font-size: 13px;
        line-height: 22px
    }
    .xs\\:text-xlg {
        font-size: 20px;
        line-height: 28px
    }
    .xs\\:text-xmd {
        font-size: 16px;
        line-height: 28px
    }
    .xs\\:text-xs {
        font-size: 12px;
        line-height: 16px
    }
    .xs\\:text-xxs {
        font-size: 11px;
        line-height: 14px
    }
    .xs\\:leading-\\[150px\\] {
        line-height: 150px
    }
    .xs\\:leading-\\[16px\\] {
        line-height: 16px
    }
    .xs\\:leading-\\[1\\] {
        line-height: 1
    }
    .xs\\:leading-\\[20px\\] {
        line-height: 20px
    }
    .xs\\:leading-\\[21px\\] {
        line-height: 21px
    }
    .xs\\:leading-\\[22px\\] {
        line-height: 22px
    }
    .xs\\:leading-\\[30px\\] {
        line-height: 30px
    }
    .xs\\:leading-\\[38px\\] {
        line-height: 38px
    }
    .xs\\:leading-\\[3rem\\] {
        line-height: 3rem
    }
    .xs\\:leading-\\[40px\\] {
        line-height: 40px
    }
    .xs\\:leading-\\[42px\\] {
        line-height: 42px
    }
    .xs\\:leading-\\[45px\\] {
        line-height: 45px
    }
    .xs\\:leading-\\[50px\\] {
        line-height: 50px
    }
    .xs\\:leading-\\[55px\\] {
        line-height: 55px
    }
    .xs\\:leading-\\[60px\\] {
        line-height: 60px
    }
    .xs\\:leading-\\[65px\\] {
        line-height: 65px
    }
    .xs\\:leading-\\[70px\\] {
        line-height: 70px
    }
    .xs\\:leading-\\[74px\\] {
        line-height: 74px
    }
    .xs\\:leading-\\[76px\\] {
        line-height: 76px
    }
    .xs\\:leading-none {
        line-height: 1
    }
    .xs\\:-tracking-\\[\\.5px\\] {
        letter-spacing: -.5px
    }
    .xs\\:-tracking-\\[1px\\] {
        letter-spacing: -1px
    }
    .xs\\:-tracking-\\[2px\\] {
        letter-spacing: -2px
    }
    .xs\\:-tracking-\\[3px\\] {
        letter-spacing: -3px
    }
    .xs\\:tracking-\\[-0\\.5px\\] {
        letter-spacing: -0.5px
    }
    .xs\\:tracking-\\[-1px\\] {
        letter-spacing: -1px
    }
    .xs\\:tracking-\\[10px\\] {
        letter-spacing: 10px
    }
    .xs\\:underline-offset-\\[5px\\] {
        text-underline-offset: 5px
    }
    .xs\\:opacity-0 {
        opacity: 0
    }
    .xs\\:shadow-\\[0_0_20px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.08\\)\\] {
        --tw-shadow: 0 0 20px rgba(0,0,0,0.08);
        --tw-shadow-colored: 0 0 20px var(--tw-shadow-color);
        box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)
    }
    .xs\\:last\\:mb-0:last-child {
        margin-bottom: 0px
    }
}
@media (max-width: 480px) {
    .xxs\\:-top-\\[80px\\] {
        top: -80px
    }
    .xxs\\:mx-0 {
        margin-left: 0px;
        margin-right: 0px
    }
    .xxs\\:mb-0 {
        margin-bottom: 0px
    }
    .xxs\\:mb-\\[40px\\] {
        margin-bottom: 40px
    }
    .xxs\\:mb-\\[43px\\] {
        margin-bottom: 43px
    }
    .xxs\\:mb-\\[45px\\] {
        margin-bottom: 45px
    }
    .xxs\\:flex {
        display: flex
    }
    .xxs\\:h-\\[300px\\] {
        height: 300px
    }
    .xxs\\:h-\\[50vh\\] {
        height: 50vh
    }
    .xxs\\:h-\\[53vh\\] {
        height: 53vh
    }
    .xxs\\:w-\\[70\\%\\] {
        width: 70%
    }
    .xxs\\:w-full {
        width: 100%
    }
    .xxs\\:flex-col {
        flex-direction: column
    }
    .xxs\\:items-center {
        align-items: center
    }
    .xxs\\:justify-center {
        justify-content: center
    }
    .xxs\\:px-0 {
        padding-left: 0px;
        padding-right: 0px
    }
    .xxs\\:px-\\[30px\\] {
        padding-left: 30px;
        padding-right: 30px
    }
    .xxs\\:py-\\[50px\\] {
        padding-top: 50px;
        padding-bottom: 50px
    }
    .xxs\\:\\!pl-\\[20px\\] {
        padding-left: 20px !important
    }
    .xxs\\:pt-\\[20px\\] {
        padding-top: 20px
    }
    .xxs\\:text-center {
        text-align: center
    }
    .xxs\\:text-\\[58px\\] {
        font-size: 58px
    }
    .xxs\\:leading-\\[43px\\] {
        line-height: 43px
    }
}
@media (min-width: 1921px) {
    .mxl\\:top-0 {
        top: 0px
    }
    .mxl\\:mb-\\[30\\%\\] {
        margin-bottom: 30%
    }
    .mxl\\:block {
        display: block
    }
    .mxl\\:h-\\[350px\\] {
        height: 350px
    }
    .mxl\\:h-\\[740px\\] {
        height: 740px
    }
    .mxl\\:justify-center {
        justify-content: center
    }
    .mxl\\:bg-cover {
        background-size: cover
    }
}
@media (orientation: portrait) {
    .portrait\\:h-\\[450px\\] {
        height: 450px
    }
    .portrait\\:justify-center {
        justify-content: center
    }
    .portrait\\:text-center {
        text-align: center
    }
    @media (max-width: 991px) {
        .portrait\\:md\\:justify-start {
            justify-content: flex-start
        }
        .portrait\\:md\\:text-start {
            text-align: start
        }
    }
}
@media (max-width: 575px) {
    @media (orientation: portrait) {
        .xs\\:portrait\\:h-\\[330px\\] {
            height: 330px
        }
    }
}
@media (orientation: landscape) {
    .landscape\\:right-\\[20px\\] {
        right: 20px
    }
    .landscape\\:top-\\[20px\\] {
        top: 20px
    }
    .landscape\\:h-full {
        height: 100%
    }
    .landscape\\:justify-start {
        justify-content: flex-start
    }
    .landscape\\:justify-center {
        justify-content: center
    }
    .landscape\\:bg-right {
        background-position: right
    }
    .landscape\\:px-\\[15px\\] {
        padding-left: 15px;
        padding-right: 15px
    }
    .landscape\\:text-start {
        text-align: start
    }
    @media (max-width: 1600px) {
        .landscape\\:xl\\:px-\\[20px\\] {
            padding-left: 20px;
            padding-right: 20px
        }
    }
    @media (max-width: 1199px) {
        .landscape\\:lg\\:mb-\\[15px\\] {
            margin-bottom: 15px
        }
        .landscape\\:lg\\:justify-center {
            justify-content: center
        }
        .landscape\\:lg\\:\\!px-10 {
            padding-left: 2.5rem !important;
            padding-right: 2.5rem !important
        }
        .landscape\\:lg\\:text-lg {
            font-size: 18px;
            line-height: 22px
        }
    }
    @media (max-width: 991px) {
        .landscape\\:md\\:\\!-bottom-\\[25px\\] {
            bottom: -25px !important
        }
        .landscape\\:md\\:bottom-0 {
            bottom: 0px
        }
        .landscape\\:md\\:bottom-auto {
            bottom: auto
        }
        .landscape\\:md\\:left-\\[-7px\\] {
            left: -7px
        }
        .landscape\\:md\\:right-\\[-7px\\] {
            right: -7px
        }
        .landscape\\:md\\:top-0 {
            top: 0px
        }
        .landscape\\:md\\:top-\\[-20px\\] {
            top: -20px
        }
        .landscape\\:md\\:mb-\\[15px\\] {
            margin-bottom: 15px
        }
        .landscape\\:md\\:mb-\\[30px\\] {
            margin-bottom: 30px
        }
        .landscape\\:md\\:mb-\\[50px\\] {
            margin-bottom: 50px
        }
        .landscape\\:md\\:mb-\\[60px\\] {
            margin-bottom: 60px
        }
        .landscape\\:md\\:mt-0 {
            margin-top: 0px
        }
        .landscape\\:md\\:mt-12 {
            margin-top: 3rem
        }
        .landscape\\:md\\:mt-\\[100px\\] {
            margin-top: 100px
        }
        .landscape\\:md\\:mt-\\[15px\\] {
            margin-top: 15px
        }
        .landscape\\:md\\:mt-\\[40px\\] {
            margin-top: 40px
        }
        .landscape\\:md\\:hidden {
            display: none
        }
        .landscape\\:md\\:h-\\[100vh\\] {
            height: 100vh
        }
        .landscape\\:md\\:h-\\[300px\\] {
            height: 300px
        }
        .landscape\\:md\\:h-\\[320px\\] {
            height: 320px
        }
        .landscape\\:md\\:h-\\[400px\\] {
            height: 400px
        }
        .landscape\\:md\\:h-\\[450px\\] {
            height: 450px
        }
        .landscape\\:md\\:h-\\[500px\\] {
            height: 500px
        }
        .landscape\\:md\\:h-\\[600px\\] {
            height: 600px
        }
        .landscape\\:md\\:h-\\[650px\\] {
            height: 650px
        }
        .landscape\\:md\\:h-\\[auto\\] {
            height: auto
        }
        .landscape\\:md\\:h-auto {
            height: auto
        }
    }
}
@media (max-width: 991px) {
    @media (orientation: landscape) {
        .md\\:landscape\\:h-\\[500px\\] {
            height: 500px
        }
        .md\\:landscape\\:h-auto {
            height: auto
        }
    }
}
@media (orientation: landscape) {
    @media (max-width: 991px) {
        .landscape\\:md\\:flex-row {
            flex-direction: row
        }
        .landscape\\:md\\:items-start {
            align-items: flex-start
        }
        .landscape\\:md\\:gap-y-0 {
            row-gap: 0px
        }
        .landscape\\:md\\:overflow-auto {
            overflow: auto
        }
        .landscape\\:md\\:\\!px-0 {
            padding-left: 0px !important;
            padding-right: 0px !important
        }
        .landscape\\:md\\:py-\\[2\\.5rem\\] {
            padding-top: 2.5rem;
            padding-bottom: 2.5rem
        }
    }
}
@media (max-width: 991px) {
    @media (orientation: landscape) {
        .md\\:landscape\\:py-\\[50px\\] {
            padding-top: 50px;
            padding-bottom: 50px
        }
    }
}
@media (orientation: landscape) {
    @media (max-width: 991px) {
        .landscape\\:md\\:pb-8 {
            padding-bottom: 2rem
        }
        .landscape\\:md\\:text-center {
            text-align: center
        }
        .landscape\\:md\\:text-\\[57px\\] {
            font-size: 57px
        }
        .landscape\\:md\\:text-\\[7px\\] {
            font-size: 7px
        }
        .landscape\\:md\\:\\!leading-\\[18px\\] {
            line-height: 18px !important
        }
        .landscape\\:md\\:leading-\\[57px\\] {
            line-height: 57px
        }
        .landscape\\:md\\:leading-\\[8px\\] {
            line-height: 8px
        }
        .landscape\\:md\\:tracking-\\[7px\\] {
            letter-spacing: 7px
        }
    }
    @media (max-width: 767px) {
        .landscape\\:sm\\:h-\\[450px\\] {
            height: 450px
        }
    }
}`, "",{"version":3,"sources":["webpack://./src/index.scss"],"names":[],"mappings":"AAAA;IAAA;AAAA;AACA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA,6BAAA;IAAA;AAAA;AAAA;IAAA,6BAAA;IAAA;AAAA;AAAA;IAAA,gBAAA;IAAA;AAAA;AAAA;IAAA,oBAAA;IAAA;AAAA;AAAA;IAAA,iBAAA;IAAA;AAAA;AAAA;IAAA,iBAAA;IAAA;AAAA;AAAA;IAAA,iBAAA;IAAA;AAAA;AAAA;IAAA,iBAAA;IAAA;AAAA;AAAA;IAAA,gBAAA;IAAA;AAAA;AAAA;IAAA,eAAA;IAAA;AAAA;AAAA;IAAA,iBAAA;IAAA;AAAA;AAAA;IAAA,gBAAA;IAAA;AAAA;AAAA;IAAA,eAAA;IAAA;AAAA;AAAA;IAAA,iBAAA;IAAA;AAAA;AAAA;IAAA,iBAAA;IAAA;AAAA;AAAA;IAAA,eAAA;IAAA;AAAA;AAAA;IAAA,kBAAA;IAAA;AAAA;AAAA;IAAA,gBAAA;IAAA;AAAA;AAAA;IAAA,kBAAA;IAAA;AAAA;AAAA;IAAA,gBAAA;IAAA;AAAA;AAAA;IAAA,gBAAA;IAAA;AAAA;AAAA;IAAA,mBAAA;IAAA;AAAA;AAAA;IAAA,gBAAA;IAAA;AAAA;AAAA;IAAA,gBAAA;IAAA;AAAA;AAAA;IAAA,gBAAA;IAAA;AAAA;AAAA;IAAA,gBAAA;IAAA;AAAA;AAAA;IAAA,kBAAA;IAAA;AAAA;AAAA;IAAA,gBAAA;IAAA;AAAA;AAAA;IAAA,gBAAA;IAAA;AAAA;AAAA;IAAA,kBAAA;IAAA;AAAA;AAAA;IAAA,kBAAA;IAAA;AAAA;AAAA;IAAA,gBAAA;IAAA;AAAA;AAAA;IAAA,gBAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA,sBAAA;IAAA;AAAA;AAAA;IAAA,sBAAA;IAAA;AAAA;AAAA;IAAA,qBAAA;IAAA;AAAA;AAAA;IAAA,mBAAA;IAAA;AAAA;AAAA;IAAA,kBAAA;IAAA;AAAA;AAAA;IAAA,iBAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA,wBAAA;IAAA,0DAAA;IAAA;AAAA;AAAA;IAAA,wBAAA;IAAA,kEAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA,qBAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA,gCAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA,qBAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA,sBAAA;IAAA;AAAA;AAAA;IAAA,sBAAA;IAAA;AAAA;AAAA;IAAA,sBAAA;IAAA;AAAA;AAAA;IAAA,sBAAA;IAAA;AAAA;AAAA;IAAA,sBAAA;IAAA;AAAA;AAAA;IAAA,sBAAA;IAAA;AAAA;AAAA;IAAA,sBAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA,sBAAA;IAAA;AAAA;AAAA;IAAA,sBAAA;IAAA;AAAA;AAAA;IAAA,sBAAA;IAAA;AAAA;AAAA;IAAA,sBAAA;IAAA;AAAA;AAAA;IAAA,sBAAA;IAAA;AAAA;AAAA;IAAA,sBAAA;IAAA;AAAA;AAAA;IAAA,sBAAA;IAAA;AAAA;AAAA;IAAA,sBAAA;IAAA;AAAA;AAAA;IAAA,sBAAA;IAAA;AAAA;AAAA;IAAA,sBAAA;IAAA;AAAA;AAAA;IAAA,sBAAA;IAAA;AAAA;AAAA;IAAA,sBAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA,sBAAA;IAAA;AAAA;AAAA;IAAA,sBAAA;IAAA;AAAA;AAAA;IAAA,sBAAA;IAAA;AAAA;AAAA;IAAA,sBAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA,sBAAA;IAAA;AAAA;AAAA;IAAA,sBAAA;IAAA;AAAA;AAAA;IAAA,sBAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA,sBAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA,kBAAA;IAAA;AAAA;AAAA;IAAA,kBAAA;IAAA;AAAA;AAAA;IAAA,kBAAA;IAAA;AAAA;AAAA;IAAA,kBAAA;IAAA;AAAA;AAAA;IAAA,kBAAA;IAAA;AAAA;AAAA;IAAA,kBAAA;IAAA;AAAA;AAAA;IAAA,kBAAA;IAAA;AAAA;AAAA;IAAA,kBAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA,kBAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA,kBAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA,kBAAA;IAAA;AAAA;AAAA;IAAA,kBAAA;IAAA;AAAA;AAAA;IAAA,kBAAA;IAAA;AAAA;AAAA;IAAA,kBAAA;IAAA;AAAA;AAAA;IAAA,kBAAA;IAAA;AAAA;AAAA;IAAA,kBAAA;IAAA;AAAA;AAAA;IAAA,kBAAA;IAAA;AAAA;AAAA;IAAA,kBAAA;IAAA;AAAA;AAAA;IAAA,kBAAA;IAAA;AAAA;AAAA;IAAA,kBAAA;IAAA;AAAA;AAAA;IAAA,kBAAA;IAAA;AAAA;AAAA;IAAA,kBAAA;IAAA;AAAA;AAAA;IAAA,kBAAA;IAAA;AAAA;AAAA;IAAA,kBAAA;IAAA;AAAA;AAAA;IAAA,kBAAA;IAAA;AAAA;AAAA;IAAA,kBAAA;IAAA;AAAA;AAAA;IAAA,kBAAA;IAAA;AAAA;AAAA;IAAA,kBAAA;IAAA;AAAA;AAAA;IAAA,kBAAA;IAAA;AAAA;AAAA;IAAA,kBAAA;IAAA;AAAA;AAAA;IAAA,kBAAA;IAAA;AAAA;AAAA;IAAA,kBAAA;IAAA;AAAA;AAAA;IAAA,kBAAA;IAAA;AAAA;AAAA;IAAA,kBAAA;IAAA;AAAA;AAAA;IAAA,kBAAA;IAAA;AAAA;AAAA;IAAA,kBAAA;IAAA;AAAA;AAAA;IAAA,kBAAA;IAAA;AAAA;AAAA;IAAA,kBAAA;IAAA;AAAA;AAAA;IAAA,kBAAA;IAAA;AAAA;AAAA;IAAA,kBAAA;IAAA;AAAA;AAAA;IAAA,kBAAA;IAAA;AAAA;AAAA;IAAA,kBAAA;IAAA;AAAA;AAAA;IAAA,kBAAA;IAAA;AAAA;AAAA;IAAA,kBAAA;IAAA;AAAA;AAAA;IAAA,kBAAA;IAAA;AAAA;AAAA;IAAA,kBAAA;IAAA;AAAA;AAAA;IAAA,kBAAA;IAAA;AAAA;AAAA;IAAA,kBAAA;IAAA;AAAA;AAAA;IAAA,kBAAA;IAAA;AAAA;AAAA;IAAA,kBAAA;IAAA;AAAA;AAAA;IAAA,kBAAA;IAAA;AAAA;AAAA;IAAA,kBAAA;IAAA;AAAA;AAAA;IAAA,kBAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA,kBAAA;IAAA;AAAA;AAAA;IAAA,kBAAA;IAAA;AAAA;AAAA;IAAA,kBAAA;IAAA;AAAA;AAAA;IAAA,kBAAA;IAAA;AAAA;AAAA;IAAA,kBAAA;IAAA;AAAA;AAAA;IAAA,kBAAA;IAAA;AAAA;AAAA;IAAA,kBAAA;IAAA;AAAA;AAAA;IAAA,kBAAA;IAAA;AAAA;AAAA;IAAA,kBAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA,kBAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA,4DAAA;IAAA,kEAAA;IAAA;AAAA;AAAA;IAAA,4DAAA;IAAA,+DAAA;IAAA;AAAA;AAAA;IAAA,4DAAA;IAAA,oEAAA;IAAA;AAAA;AAAA;IAAA,4DAAA;IAAA,kEAAA;IAAA;AAAA;AAAA;IAAA,4DAAA;IAAA,iEAAA;IAAA;AAAA;AAAA;IAAA,4DAAA;IAAA,kEAAA;IAAA;AAAA;AAAA;IAAA,4DAAA;IAAA,oEAAA;IAAA;AAAA;AAAA;IAAA,4DAAA;IAAA,oEAAA;IAAA;AAAA;AAAA;IAAA,4DAAA;IAAA,oEAAA;IAAA;AAAA;AAAA;IAAA,4DAAA;IAAA,oEAAA;IAAA;AAAA;AAAA;IAAA,4DAAA;IAAA,oEAAA;IAAA;AAAA;AAAA;IAAA,4DAAA;IAAA,qEAAA;IAAA;AAAA;AAAA;IAAA,4DAAA;IAAA,oEAAA;IAAA;AAAA;AAAA;IAAA,4DAAA;IAAA,oEAAA;IAAA;AAAA;AAAA;IAAA,4DAAA;IAAA,oEAAA;IAAA;AAAA;AAAA;IAAA,4DAAA;IAAA,oEAAA;IAAA;AAAA;AAAA;IAAA,4DAAA;IAAA,qEAAA;IAAA;AAAA;AAAA;IAAA,4DAAA;IAAA,qEAAA;IAAA;AAAA;AAAA;IAAA,4DAAA;IAAA,qEAAA;IAAA;AAAA;AAAA;IAAA,4DAAA;IAAA,qEAAA;IAAA;AAAA;AAAA;IAAA,4DAAA;IAAA,qEAAA;IAAA;AAAA;AAAA;IAAA,4DAAA;IAAA,mEAAA;IAAA;AAAA;AAAA;IAAA,4DAAA;IAAA,oEAAA;IAAA;AAAA;AAAA;IAAA,4DAAA;IAAA,qEAAA;IAAA;AAAA;AAAA;IAAA,4DAAA;IAAA,qEAAA;IAAA;AAAA;AAAA;IAAA,4DAAA;IAAA,qEAAA;IAAA;AAAA;AAAA;IAAA,yDAAA;IAAA,qEAAA;IAAA;AAAA;AAAA;IAAA,gEAAA;IAAA,+DAAA;IAAA;AAAA;AAAA;IAAA,4DAAA;IAAA,kEAAA;IAAA;AAAA;AAAA;IAAA,4DAAA;IAAA,oEAAA;IAAA;AAAA;AAAA;IAAA,gEAAA;IAAA,+DAAA;IAAA;AAAA;AAAA;IAAA,mEAAA;IAAA;AAAA;AAAA;IAAA,qEAAA;IAAA;AAAA;AAAA;IAAA,mEAAA;IAAA;AAAA;AAAA;IAAA,oEAAA;IAAA;AAAA;AAAA;IAAA,qEAAA;IAAA;AAAA;AAAA;IAAA,qEAAA;IAAA;AAAA;AAAA;IAAA,qEAAA;IAAA;AAAA;AAAA;IAAA,qEAAA;IAAA;AAAA;AAAA;IAAA,qEAAA;IAAA;AAAA;AAAA;IAAA,sEAAA;IAAA;AAAA;AAAA;IAAA,qEAAA;IAAA;AAAA;AAAA;IAAA,qEAAA;IAAA;AAAA;AAAA;IAAA,qEAAA;IAAA;AAAA;AAAA;IAAA,oEAAA;IAAA;AAAA;AAAA;IAAA,qEAAA;IAAA;AAAA;AAAA;IAAA,sEAAA;IAAA;AAAA;AAAA;IAAA,sEAAA;IAAA;AAAA;AAAA;IAAA,sEAAA;IAAA;AAAA;AAAA;IAAA,sEAAA;IAAA;AAAA;AAAA;IAAA,qEAAA;IAAA;AAAA;AAAA;IAAA,qEAAA;IAAA;AAAA;AAAA;IAAA,qEAAA;IAAA;AAAA;AAAA;IAAA,sEAAA;IAAA;AAAA;AAAA;IAAA,sEAAA;IAAA;AAAA;AAAA;IAAA,sEAAA;IAAA;AAAA;AAAA;IAAA,sEAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA,6BAAA;YAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA,4BAAA;IAAA;AAAA;AAAA;IAAA,6BAAA;IAAA;AAAA;AAAA;IAAA,4BAAA;IAAA;AAAA;AAAA;IAAA,4BAAA;IAAA;AAAA;AAAA;IAAA,2BAAA;IAAA;AAAA;AAAA;IAAA,2BAAA;IAAA;AAAA;AAAA;IAAA,iBAAA;IAAA;AAAA;AAAA;IAAA,oBAAA;IAAA;AAAA;AAAA;IAAA,kBAAA;IAAA;AAAA;AAAA;IAAA,oBAAA;IAAA;AAAA;AAAA;IAAA,kBAAA;IAAA;AAAA;AAAA;IAAA,oBAAA;IAAA;AAAA;AAAA;IAAA,kBAAA;IAAA;AAAA;AAAA;IAAA,kBAAA;IAAA;AAAA;AAAA;IAAA,kBAAA;IAAA;AAAA;AAAA;IAAA,kBAAA;IAAA;AAAA;AAAA;IAAA,kBAAA;IAAA;AAAA;AAAA;IAAA,mBAAA;IAAA;AAAA;AAAA;IAAA,kBAAA;IAAA;AAAA;AAAA;IAAA,qBAAA;IAAA;AAAA;AAAA;IAAA,iBAAA;IAAA;AAAA;AAAA;IAAA,iBAAA;IAAA;AAAA;AAAA;IAAA,qBAAA;IAAA;AAAA;AAAA;IAAA,mBAAA;IAAA;AAAA;AAAA;IAAA,mBAAA;IAAA;AAAA;AAAA;IAAA,kBAAA;IAAA;AAAA;AAAA;IAAA,mBAAA;IAAA;AAAA;AAAA;IAAA,iBAAA;IAAA;AAAA;AAAA;IAAA,iBAAA;IAAA;AAAA;AAAA;IAAA,mBAAA;IAAA;AAAA;AAAA;IAAA,kBAAA;IAAA;AAAA;AAAA;IAAA,mBAAA;IAAA;AAAA;AAAA;IAAA,kBAAA;IAAA;AAAA;AAAA;IAAA,iBAAA;IAAA;AAAA;AAAA;IAAA,kBAAA;IAAA;AAAA;AAAA;IAAA,mBAAA;IAAA;AAAA;AAAA;IAAA,kBAAA;IAAA;AAAA;AAAA;IAAA,iBAAA;IAAA;AAAA;AAAA;IAAA,kBAAA;IAAA;AAAA;AAAA;IAAA,kBAAA;IAAA;AAAA;AAAA;IAAA,kBAAA;IAAA;AAAA;AAAA;IAAA,kBAAA;IAAA;AAAA;AAAA;IAAA,kBAAA;IAAA;AAAA;AAAA;IAAA,kBAAA;IAAA;AAAA;AAAA;IAAA,oBAAA;IAAA;AAAA;AAAA;IAAA,kBAAA;IAAA;AAAA;AAAA;IAAA,kBAAA;IAAA;AAAA;AAAA;IAAA,kBAAA;IAAA;AAAA;AAAA;IAAA,kBAAA;IAAA;AAAA;AAAA;IAAA,kBAAA;IAAA;AAAA;AAAA;IAAA,gBAAA;IAAA;AAAA;AAAA;IAAA,oBAAA;IAAA;AAAA;AAAA;IAAA,kBAAA;IAAA;AAAA;AAAA;IAAA,kBAAA;IAAA;AAAA;AAAA;IAAA,kBAAA;IAAA;AAAA;AAAA;IAAA,gBAAA;IAAA;AAAA;AAAA;IAAA,oBAAA;IAAA;AAAA;AAAA;IAAA,kBAAA;IAAA;AAAA;AAAA;IAAA,kBAAA;IAAA;AAAA;AAAA;IAAA,iBAAA;IAAA;AAAA;AAAA;IAAA,kBAAA;IAAA;AAAA;AAAA;IAAA,gBAAA;IAAA;AAAA;AAAA;IAAA,oBAAA;IAAA;AAAA;AAAA;IAAA,kBAAA;IAAA;AAAA;AAAA;IAAA,kBAAA;IAAA;AAAA;AAAA;IAAA,kBAAA;IAAA;AAAA;AAAA;IAAA,gBAAA;IAAA;AAAA;AAAA;IAAA,oBAAA;IAAA;AAAA;AAAA;IAAA,kBAAA;IAAA;AAAA;AAAA;IAAA,kBAAA;IAAA;AAAA;AAAA;IAAA,kBAAA;IAAA;AAAA;AAAA;IAAA,kBAAA;IAAA;AAAA;AAAA;IAAA,gBAAA;IAAA;AAAA;AAAA;IAAA,oBAAA;IAAA;AAAA;AAAA;IAAA,kBAAA;IAAA;AAAA;AAAA;IAAA,iBAAA;IAAA;AAAA;AAAA;IAAA,gBAAA;IAAA;AAAA;AAAA;IAAA,oBAAA;IAAA;AAAA;AAAA;IAAA,kBAAA;IAAA;AAAA;AAAA;IAAA,iBAAA;IAAA;AAAA;AAAA;IAAA,gBAAA;IAAA;AAAA;AAAA;IAAA,mBAAA;IAAA;AAAA;AAAA;IAAA,iBAAA;IAAA;AAAA;AAAA;IAAA,mBAAA;IAAA;AAAA;AAAA;IAAA,iBAAA;IAAA;AAAA;AAAA;IAAA,mBAAA;IAAA;AAAA;AAAA;IAAA,iBAAA;IAAA;AAAA;AAAA;IAAA,iBAAA;IAAA;AAAA;AAAA;IAAA,iBAAA;IAAA;AAAA;AAAA;IAAA,iBAAA;IAAA;AAAA;AAAA;IAAA,iBAAA;IAAA;AAAA;AAAA;IAAA,kBAAA;IAAA;AAAA;AAAA;IAAA,kBAAA;IAAA;AAAA;AAAA;IAAA,oBAAA;IAAA;AAAA;AAAA;IAAA,iBAAA;IAAA;AAAA;AAAA;IAAA,gBAAA;IAAA;AAAA;AAAA;IAAA,oBAAA;IAAA;AAAA;AAAA;IAAA,kBAAA;IAAA;AAAA;AAAA;IAAA,iBAAA;IAAA;AAAA;AAAA;IAAA,kBAAA;IAAA;AAAA;AAAA;IAAA,gBAAA;IAAA;AAAA;AAAA;IAAA,kBAAA;IAAA;AAAA;AAAA;IAAA,gBAAA;IAAA;AAAA;AAAA;IAAA,kBAAA;IAAA;AAAA;AAAA;IAAA,iBAAA;IAAA;AAAA;AAAA;IAAA,kBAAA;IAAA;AAAA;AAAA;IAAA,iBAAA;IAAA;AAAA;AAAA;IAAA,kBAAA;IAAA;AAAA;AAAA;IAAA,iBAAA;IAAA;AAAA;AAAA;IAAA,iBAAA;IAAA;AAAA;AAAA;IAAA,kBAAA;IAAA;AAAA;AAAA;IAAA,iBAAA;IAAA;AAAA;AAAA;IAAA,kBAAA;IAAA;AAAA;AAAA;IAAA,iBAAA;IAAA;AAAA;AAAA;IAAA,iBAAA;IAAA;AAAA;AAAA;IAAA,mBAAA;IAAA;AAAA;AAAA;IAAA,kBAAA;IAAA;AAAA;AAAA;IAAA,iBAAA;IAAA;AAAA;AAAA;IAAA,kBAAA;IAAA;AAAA;AAAA;IAAA,iBAAA;IAAA;AAAA;AAAA;IAAA,iBAAA;IAAA;AAAA;AAAA;IAAA,gBAAA;IAAA;AAAA;AAAA;IAAA,eAAA;IAAA;AAAA;AAAA;IAAA,mBAAA;IAAA;AAAA;AAAA;IAAA,iBAAA;IAAA;AAAA;AAAA;IAAA,iBAAA;IAAA;AAAA;AAAA;IAAA,gBAAA;IAAA;AAAA;AAAA;IAAA,iBAAA;IAAA;AAAA;AAAA;IAAA,eAAA;IAAA;AAAA;AAAA;IAAA,mBAAA;IAAA;AAAA;AAAA;IAAA,iBAAA;IAAA;AAAA;AAAA;IAAA,iBAAA;IAAA;AAAA;AAAA;IAAA,iBAAA;IAAA;AAAA;AAAA;IAAA,gBAAA;IAAA;AAAA;AAAA;IAAA,eAAA;IAAA;AAAA;AAAA;IAAA,mBAAA;IAAA;AAAA;AAAA;IAAA,iBAAA;IAAA;AAAA;AAAA;IAAA,iBAAA;IAAA;AAAA;AAAA;IAAA,gBAAA;IAAA;AAAA;AAAA;IAAA,iBAAA;IAAA;AAAA;AAAA;IAAA,eAAA;IAAA;AAAA;AAAA;IAAA,iBAAA;IAAA;AAAA;AAAA;IAAA,iBAAA;IAAA;AAAA;AAAA;IAAA,gBAAA;IAAA;AAAA;AAAA;IAAA,iBAAA;IAAA;AAAA;AAAA;IAAA,eAAA;IAAA;AAAA;AAAA;IAAA,mBAAA;IAAA;AAAA;AAAA;IAAA,iBAAA;IAAA;AAAA;AAAA;IAAA,gBAAA;IAAA;AAAA;AAAA;IAAA,iBAAA;IAAA;AAAA;AAAA;IAAA,eAAA;IAAA;AAAA;AAAA;IAAA,iBAAA;IAAA;AAAA;AAAA;IAAA,gBAAA;IAAA;AAAA;AAAA;IAAA,iBAAA;IAAA;AAAA;AAAA;IAAA,eAAA;IAAA;AAAA;AAAA;IAAA,mBAAA;IAAA;AAAA;AAAA;IAAA,iBAAA;IAAA;AAAA;AAAA;IAAA,iBAAA;IAAA;AAAA;AAAA;IAAA,gBAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA,0BAAA;IAAA;AAAA;AAAA;IAAA,0BAAA;IAAA;AAAA;AAAA;IAAA,0BAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA,eAAA;IAAA;AAAA;AAAA;IAAA,eAAA;IAAA;AAAA;AAAA;IAAA,eAAA;IAAA;AAAA;AAAA;IAAA,eAAA;IAAA;AAAA;AAAA;IAAA,eAAA;IAAA;AAAA;AAAA;IAAA,eAAA;IAAA;AAAA;AAAA;IAAA,eAAA;IAAA;AAAA;AAAA;IAAA,eAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA,+BAAA;IAAA;AAAA;AAAA;IAAA,oBAAA;IAAA;AAAA;AAAA;IAAA,oBAAA;IAAA;AAAA;AAAA;IAAA,oBAAA;IAAA;AAAA;AAAA;IAAA,oBAAA;IAAA;AAAA;AAAA;IAAA,oBAAA;IAAA;AAAA;AAAA;IAAA,oBAAA;IAAA;AAAA;AAAA;IAAA,oBAAA;IAAA;AAAA;AAAA;IAAA,oBAAA;IAAA;AAAA;AAAA;IAAA,oBAAA;IAAA;AAAA;AAAA;IAAA,oBAAA;IAAA;AAAA;AAAA;IAAA,oBAAA;IAAA;AAAA;AAAA;IAAA,oBAAA;IAAA;AAAA;AAAA;IAAA,oBAAA;IAAA;AAAA;AAAA;IAAA,oBAAA;IAAA;AAAA;AAAA;IAAA,oBAAA;IAAA;AAAA;AAAA;IAAA,oBAAA;IAAA;AAAA;AAAA;IAAA,oBAAA;IAAA;AAAA;AAAA;IAAA,oBAAA;IAAA;AAAA;AAAA;IAAA,oBAAA;IAAA;AAAA;AAAA;IAAA,oBAAA;IAAA;AAAA;AAAA;IAAA,oBAAA;IAAA;AAAA;AAAA;IAAA,oBAAA;IAAA;AAAA;AAAA;IAAA,oBAAA;IAAA;AAAA;AAAA;IAAA,oBAAA;IAAA;AAAA;AAAA;IAAA,oBAAA;IAAA;AAAA;AAAA;IAAA,oBAAA;IAAA;AAAA;AAAA;IAAA,oBAAA;IAAA;AAAA;AAAA;IAAA,oBAAA;IAAA;AAAA;AAAA;IAAA,oBAAA;IAAA;AAAA;AAAA;IAAA,oBAAA;IAAA;AAAA;AAAA;IAAA,oBAAA;IAAA;AAAA;AAAA;IAAA,oBAAA;IAAA;AAAA;AAAA;IAAA,oBAAA;IAAA;AAAA;AAAA;IAAA,oBAAA;IAAA;AAAA;AAAA;IAAA,oBAAA;IAAA;AAAA;AAAA;IAAA,oBAAA;IAAA;AAAA;AAAA;IAAA,oBAAA;IAAA;AAAA;AAAA;IAAA,oBAAA;IAAA;AAAA;AAAA;IAAA,oBAAA;IAAA;AAAA;AAAA;IAAA,oBAAA;IAAA;AAAA;AAAA;IAAA,oBAAA;IAAA;AAAA;AAAA;IAAA,oBAAA;IAAA;AAAA;AAAA;IAAA,oBAAA;IAAA;AAAA;AAAA;IAAA,oBAAA;IAAA;AAAA;AAAA;IAAA,oBAAA;IAAA;AAAA;AAAA;IAAA,oBAAA;IAAA;AAAA;AAAA;IAAA,oBAAA;IAAA;AAAA;AAAA;IAAA,oBAAA;IAAA;AAAA;AAAA;IAAA,oBAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA,oBAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA,oBAAA;IAAA;AAAA;AAAA;IAAA,oBAAA;IAAA;AAAA;AAAA;IAAA,oBAAA;IAAA;AAAA;AAAA;IAAA,oBAAA;IAAA;AAAA;AAAA;IAAA,oBAAA;IAAA;AAAA;AAAA;IAAA,oBAAA;IAAA;AAAA;AAAA;IAAA,oBAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA,oBAAA;IAAA;AAAA;AAAA;IAAA,oBAAA;IAAA;AAAA;AAAA;IAAA,oBAAA;IAAA;AAAA;AAAA;IAAA,oBAAA;IAAA;AAAA;AAAA;IAAA,oBAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA,oBAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA,2BAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA,0EAAA;IAAA,8FAAA;IAAA;AAAA;AAAA;IAAA,sCAAA;IAAA,oDAAA;IAAA;AAAA;AAAA;IAAA,sCAAA;IAAA,oDAAA;IAAA;AAAA;AAAA;IAAA,qCAAA;IAAA,oDAAA;IAAA;AAAA;AAAA;IAAA,sCAAA;IAAA,oDAAA;IAAA;AAAA;AAAA;IAAA,sCAAA;IAAA,oDAAA;IAAA;AAAA;AAAA;IAAA,sCAAA;IAAA,oDAAA;IAAA;AAAA;AAAA;IAAA,qCAAA;IAAA,oDAAA;IAAA;AAAA;AAAA;IAAA,qCAAA;IAAA,oDAAA;IAAA;AAAA;AAAA;IAAA,yCAAA;IAAA,oDAAA;IAAA;AAAA;AAAA;IAAA,sCAAA;IAAA,oDAAA;IAAA;AAAA;AAAA;IAAA,qCAAA;IAAA,oDAAA;IAAA;AAAA;AAAA;IAAA,sCAAA;IAAA,oDAAA;IAAA;AAAA;AAAA;IAAA,qCAAA;IAAA,oDAAA;IAAA;AAAA;AAAA;IAAA,yCAAA;IAAA,oDAAA;IAAA;AAAA;AAAA;IAAA,sCAAA;IAAA,oDAAA;IAAA;AAAA;AAAA;IAAA,qCAAA;IAAA,oDAAA;IAAA;AAAA;AAAA;IAAA,qCAAA;IAAA,mDAAA;IAAA;AAAA;AAAA;IAAA,+EAAA;IAAA,mGAAA;IAAA;AAAA;AAAA;IAAA,6EAAA;IAAA,iGAAA;IAAA;AAAA;AAAA;IAAA,sBAAA;IAAA,8BAAA;IAAA;AAAA;AAAA;IAAA,gFAAA;IAAA,oGAAA;IAAA;AAAA;AAAA;IAAA,uBAAA;IAAA;AAAA;AAAA;IAAA,0BAAA;IAAA;AAAA;AAAA;IAAA,oBAAA;IAAA;AAAA;AAAA;IAAA,qBAAA;IAAA;AAAA;AAAA;IAAA,kGAAA;IAAA;AAAA;AAAA;IAAA,4DAAA;IAAA;AAAA;AAAA;IAAA,uDAAA;IAAA;AAAA;AAAA;IAAA,uDAAA;IAAA;AAAA;AAAA;IAAA,mGAAA;IAAA;AAAA;AAAA;IAAA,mGAAA;IAAA;AAAA;AAAA;IAAA,+BAAA;IAAA;AAAA;AAAA;IAAA,yBAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA,gKAAA;IAAA,wJAAA;IAAA,iLAAA;IAAA,wDAAA;IAAA;AAAA;AAAA;IAAA,wBAAA;IAAA,wDAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AAAA;IAAA;AAAA;AADA;IAAA,0BACA;IADA;AACA;AADA;IAAA,0BACA;IADA;AACA;AADA;IAAA,0BACA;IADA;AACA;AADA;IAAA,0BACA;IADA;AACA;AADA;IAAA,0BACA;IADA;AACA;AADA;IAAA,0BACA;IADA;AACA;AADA;IAAA,0BACA;IADA;AACA;AADA;IAAA,0BACA;IADA;AACA;AADA;IAAA,0BACA;IADA;AACA;AADA;IAAA,0BACA;IADA;AACA;AADA;IAAA,0BACA;IADA,sBACA;IADA;AACA;AADA;IAAA,0BACA;IADA,kBACA;IADA;AACA;AADA;IAAA,0BACA;IADA,kBACA;IADA;AACA;AADA;IAAA,gBACA;IADA;AACA;AADA;IAAA,0BACA;IADA;AACA;AADA;IAAA,0BACA;IADA;AACA;AADA;IAAA,0BACA;IADA;AACA;AADA;IAAA,0BACA;IADA;AACA;AADA;IAAA,0BACA;IADA;AACA;AADA;IAAA,0BACA;IADA;AACA;AADA;IAAA,0BACA;IADA;AACA;AADA;IAAA,0BACA;IADA;AACA;AADA;IAAA,0BACA;IADA;AACA;AADA;IAAA,0BACA;IADA;AACA;AADA;IAAA,0BACA;IADA,sBACA;IADA;AACA;AADA;IAAA,0BACA;IADA,kBACA;IADA;AACA;AADA;IAAA,0BACA;IADA,kBACA;IADA;AACA;AADA;IAAA,0BACA;IADA,kBACA;IADA;AACA;AADA;IAAA,0BACA;IADA,kBACA;IADA;AACA;AADA;IAAA,0BACA;IADA;AACA;AADA;IAAA,0BACA;IADA,kBACA;IADA;AACA;AADA;IAAA,0BACA;IADA,kBACA;IADA;AACA;AADA;IAAA,0BACA;IADA,kBACA;IADA;AACA;AADA;IAAA,0BACA;IADA,kBACA;IADA;AACA;AADA;IAAA,0BACA;IADA,kBACA;IADA;AACA;AADA;IAAA,0BACA;IADA,kBACA;IADA;AACA;AADA;IAAA,0BACA;IADA,kBACA;IADA;AACA;AADA;IAAA,0BACA;IADA;AACA;AADA;IAAA,0BACA;IADA,kBACA;IADA;AACA;AADA;IAAA,0BACA;IADA;AACA;AADA;IAAA,0BACA;IADA,4DACA;IADA,qEACA;IADA;AACA;AADA;IAAA,0BACA;IADA;AACA;AADA;IAAA,0BACA;IADA;AACA;AADA;IAAA,0BACA;IADA,oBACA;IADA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA,oBACA;IADA;AACA;AADA;IAAA,sBACA;IADA;AACA;AADA;IAAA,sBACA;IADA;AACA;AADA;IAAA,sBACA;IADA;AACA;AADA;IAAA,sBACA;IADA;AACA;AADA;IAAA,sBACA;IADA;AACA;AADA;IAAA,sBACA;IADA;AACA;AADA;IAAA,sBACA;IADA;AACA;AADA;IAAA,sBACA;IADA;AACA;AADA;IAAA,sBACA;IADA;AACA;AADA;IAAA;AACA;AADA;IAAA,sBACA;IADA;AACA;AADA;IAAA,kBACA;IADA;AACA;AADA;IAAA,kBACA;IADA;AACA;AADA;IAAA,kBACA;IADA;AACA;AADA;IAAA,kBACA;IADA;AACA;AADA;IAAA,kBACA;IADA;AACA;AADA;IAAA,kBACA;IADA;AACA;AADA;IAAA,kBACA;IADA;AACA;AADA;IAAA,kBACA;IADA;AACA;AADA;IAAA,kBACA;IADA;AACA;AADA;IAAA,kBACA;IADA;AACA;AADA;IAAA;AACA;AADA;IAAA,kBACA;IADA;AACA;AADA;IAAA,+BACA;IADA;AACA;AADA;IAAA,+BACA;IADA;AACA;AADA;IAAA,oBACA;IADA;AACA;AADA;IAAA,oBACA;IADA;AACA;AADA;IAAA,oBACA;IADA;AACA;AADA;IAAA,oBACA;IADA;AACA;AADA;IAAA,oBACA;IADA;AACA;AADA;IAAA,oBACA;IADA;AACA;AADA;IAAA,oBACA;IADA;AACA;AADA;IAAA,oBACA;IADA;AACA;AADA;IAAA,oBACA;IADA;AACA;AADA;IAAA,oBACA;IADA;AACA;AADA;IAAA,oBACA;IADA;AACA;AADA;IAAA,oBACA;IADA;AACA;AADA;IAAA,oBACA;IADA;AACA;AADA;IAAA,oBACA;IADA;AACA;AADA;IAAA,oBACA;IADA;AACA;AADA;IAAA;AACA;AADA;IAAA,oBACA;IADA;AACA;AADA;IAAA,oBACA;IADA;AACA;AADA;IAAA,oBACA;IADA;AACA;AADA;IAAA,oBACA;IADA;AACA;AADA;IAAA,oBACA;IADA;AACA;AADA;IAAA,oBACA;IADA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA,yCACA;IADA,oDACA;IADA;AACA;AADA;IAAA,qCACA;IADA,oDACA;IADA;AACA;AADA;IAAA,sCACA;IADA,oDACA;IADA;AACA;AADA;IAAA,yCACA;IADA,oDACA;IADA;AACA;AADA;IAAA,yCACA;IADA,oDACA;IADA;AACA;AADA;IAAA,gFACA;IADA,oGACA;IADA;AACA;AADA;IAAA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA,eACA;QADA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA,gBACA;QADA,gBACA;QADA;IACA;IADA;QAAA,iBACA;QADA,iBACA;QADA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA,iBACA;QADA;IACA;IADA;QAAA,oBACA;QADA;IACA;IADA;QAAA,kBACA;QADA;IACA;IADA;QAAA,oBACA;QADA;IACA;IADA;QAAA,kBACA;QADA;IACA;IADA;QAAA,kBACA;QADA;IACA;IADA;QAAA,kBACA;QADA;IACA;IADA;QAAA,kBACA;QADA;IACA;IADA;QAAA,oBACA;QADA;IACA;IADA;QAAA,kBACA;QADA;IACA;IADA;QAAA,iBACA;QADA;IACA;IADA;QAAA,gBACA;QADA;IACA;IADA;QAAA,iBACA;QADA;IACA;IADA;QAAA,kBACA;QADA;IACA;IADA;QAAA,gBACA;QADA;IACA;IADA;QAAA,kBACA;QADA;IACA;IADA;QAAA,kBACA;QADA;IACA;IADA;QAAA,gBACA;QADA;IACA;IADA;QAAA,oBACA;QADA;IACA;IADA;QAAA,kBACA;QADA;IACA;IADA;QAAA,gBACA;QADA;IACA;IADA;QAAA,kBACA;QADA;IACA;IADA;QAAA,kBACA;QADA;IACA;IADA;QAAA,gBACA;QADA;IACA;IADA;QAAA,kBACA;QADA;IACA;IADA;QAAA,gBACA;QADA;IACA;IADA;QAAA,kBACA;QADA;IACA;IADA;QAAA,iBACA;QADA;IACA;IADA;QAAA,iBACA;QADA;IACA;IADA;QAAA,iBACA;QADA;IACA;IADA;QAAA,iBACA;QADA;IACA;IADA;QAAA,mBACA;QADA;IACA;IADA;QAAA,kBACA;QADA;IACA;IADA;QAAA,iBACA;QADA;IACA;IADA;QAAA,iBACA;QADA;IACA;IADA;QAAA,iBACA;QADA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA,eACA;QADA;IACA;IADA;QAAA,eACA;QADA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;AAAA;AADA;IAAA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA,gBACA;QADA;IACA;IADA;QAAA,iBACA;QADA;IACA;IADA;QAAA,iBACA;QADA;IACA;IADA;QAAA,iBACA;QADA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA,gCACA;QADA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA,wBACA;QADA,kEACA;QADA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA,iBACA;QADA;IACA;IADA;QAAA,kBACA;QADA;IACA;IADA;QAAA,kBACA;QADA;IACA;IADA;QAAA,oBACA;QADA;IACA;IADA;QAAA,kBACA;QADA;IACA;IADA;QAAA,kBACA;QADA;IACA;IADA;QAAA,kBACA;QADA;IACA;IADA;QAAA,kBACA;QADA;IACA;IADA;QAAA,iBACA;QADA;IACA;IADA;QAAA,oBACA;QADA;IACA;IADA;QAAA,kBACA;QADA;IACA;IADA;QAAA,kBACA;QADA;IACA;IADA;QAAA,gBACA;QADA;IACA;IADA;QAAA,oBACA;QADA;IACA;IADA;QAAA,kBACA;QADA;IACA;IADA;QAAA,kBACA;QADA;IACA;IADA;QAAA,kBACA;QADA;IACA;IADA;QAAA,kBACA;QADA;IACA;IADA;QAAA,gBACA;QADA;IACA;IADA;QAAA,kBACA;QADA;IACA;IADA;QAAA,kBACA;QADA;IACA;IADA;QAAA,kBACA;QADA;IACA;IADA;QAAA,kBACA;QADA;IACA;IADA;QAAA,gBACA;QADA;IACA;IADA;QAAA,oBACA;QADA;IACA;IADA;QAAA,kBACA;QADA;IACA;IADA;QAAA,oBACA;QADA;IACA;IADA;QAAA,gBACA;QADA;IACA;IADA;QAAA,oBACA;QADA;IACA;IADA;QAAA,gBACA;QADA;IACA;IADA;QAAA,iBACA;QADA;IACA;IADA;QAAA,iBACA;QADA;IACA;IADA;QAAA,iBACA;QADA;IACA;IADA;QAAA,iBACA;QADA;IACA;IADA;QAAA,kBACA;QADA;IACA;IADA;QAAA,kBACA;QADA;IACA;IADA;QAAA,kBACA;QADA;IACA;IADA;QAAA,kBACA;QADA;IACA;IADA;QAAA,kBACA;QADA;IACA;IADA;QAAA,iBACA;QADA;IACA;IADA;QAAA,mBACA;QADA;IACA;IADA;QAAA,iBACA;QADA;IACA;IADA;QAAA,iBACA;QADA;IACA;IADA;QAAA,iBACA;QADA;IACA;IADA;QAAA,iBACA;QADA;IACA;IADA;QAAA,eACA;QADA;IACA;IADA;QAAA,iBACA;QADA;IACA;IADA;QAAA,iBACA;QADA;IACA;IADA;QAAA,eACA;QADA;IACA;IADA;QAAA,iBACA;QADA;IACA;IADA;QAAA,iBACA;QADA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA,eACA;QADA;IACA;IADA;QAAA,eACA;QADA;IACA;IADA;QAAA,eACA;QADA;IACA;IADA;QAAA,eACA;QADA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;AAAA;AADA;IAAA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA,gBACA;QADA;IACA;IADA;QAAA,iBACA;QADA;IACA;IADA;QAAA,iBACA;QADA;IACA;IADA;QAAA,mBACA;QADA;IACA;IADA;QAAA,iBACA;QADA;IACA;IADA;QAAA,iBACA;QADA;IACA;IADA;QAAA,iBACA;QADA;IACA;IADA;QAAA,eACA;QADA;IACA;IADA;QAAA,kBACA;QADA;IACA;IADA;QAAA,gBACA;QADA;IACA;IADA;QAAA,gBACA;QADA;IACA;IADA;QAAA,kBACA;QADA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA,sBACA;QADA;IACA;IADA;QAAA,gBACA;QADA,gBACA;QADA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA,sBACA;QADA;IACA;IADA;QAAA,kBACA;QADA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA,4BACA;QADA;IACA;IADA;QAAA,6BACA;QADA;IACA;IADA;QAAA,2BACA;QADA;IACA;IADA;QAAA,iBACA;QADA;IACA;IADA;QAAA,oBACA;QADA;IACA;IADA;QAAA,kBACA;QADA;IACA;IADA;QAAA,oBACA;QADA;IACA;IADA;QAAA,kBACA;QADA;IACA;IADA;QAAA,kBACA;QADA;IACA;IADA;QAAA,kBACA;QADA;IACA;IADA;QAAA,mBACA;QADA;IACA;IADA;QAAA,kBACA;QADA;IACA;IADA;QAAA,oBACA;QADA;IACA;IADA;QAAA,kBACA;QADA;IACA;IADA;QAAA,kBACA;QADA;IACA;IADA;QAAA,kBACA;QADA;IACA;IADA;QAAA,gBACA;QADA;IACA;IADA;QAAA,oBACA;QADA;IACA;IADA;QAAA,kBACA;QADA;IACA;IADA;QAAA,kBACA;QADA;IACA;IADA;QAAA,kBACA;QADA;IACA;IADA;QAAA,gBACA;QADA;IACA;IADA;QAAA,iBACA;QADA;IACA;IADA;QAAA,gBACA;QADA;IACA;IADA;QAAA,iBACA;QADA;IACA;IADA;QAAA,iBACA;QADA;IACA;IADA;QAAA,iBACA;QADA;IACA;IADA;QAAA,iBACA;QADA;IACA;IADA;QAAA,oBACA;QADA;IACA;IADA;QAAA,iBACA;QADA;IACA;IADA;QAAA,kBACA;QADA;IACA;IADA;QAAA,iBACA;QADA;IACA;IADA;QAAA,iBACA;QADA;IACA;IADA;QAAA,iBACA;QADA;IACA;IADA;QAAA,iBACA;QADA;IACA;IADA;QAAA,iBACA;QADA;IACA;IADA;QAAA,iBACA;QADA;IACA;IADA;QAAA,iBACA;QADA;IACA;IADA;QAAA,iBACA;QADA;IACA;IADA;QAAA,iBACA;QADA;IACA;IADA;QAAA,iBACA;QADA;IACA;IADA;QAAA,iBACA;QADA;IACA;IADA;QAAA,mBACA;QADA;IACA;IADA;QAAA,iBACA;QADA;IACA;IADA;QAAA,iBACA;QADA;IACA;IADA;QAAA,iBACA;QADA;IACA;IADA;QAAA,iBACA;QADA;IACA;IADA;QAAA,gBACA;QADA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA,eACA;QADA;IACA;IADA;QAAA,eACA;QADA;IACA;IADA;QAAA,eACA;QADA;IACA;IADA;QAAA,eACA;QADA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA,oBACA;QADA;IACA;IADA;QAAA,oBACA;QADA;IACA;IADA;QAAA,0BACA;QADA;IACA;IADA;QAAA,kBACA;QADA;IACA;AAAA;AADA;IAAA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA,2BACA;QADA;IACA;IADA;QAAA,gBACA;QADA;IACA;IADA;QAAA,iBACA;QADA;IACA;IADA;QAAA,iBACA;QADA;IACA;IADA;QAAA,iBACA;QADA;IACA;IADA;QAAA,iBACA;QADA;IACA;IADA;QAAA,eACA;QADA;IACA;IADA;QAAA,gBACA;QADA;IACA;IADA;QAAA,kBACA;QADA;IACA;IADA;QAAA,gBACA;QADA;IACA;IADA;QAAA,gBACA;QADA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA,iBACA;QADA,iBACA;QADA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA,sBACA;QADA;IACA;IADA;QAAA;IACA;IADA;QAAA,kBACA;QADA;IACA;IADA;QAAA,kBACA;QADA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA,4BACA;QADA;IACA;IADA;QAAA,6BACA;QADA;IACA;IADA;QAAA,4BACA;QADA;IACA;IADA;QAAA,iBACA;QADA;IACA;IADA;QAAA,oBACA;QADA;IACA;IADA;QAAA,kBACA;QADA;IACA;IADA;QAAA,kBACA;QADA;IACA;IADA;QAAA,kBACA;QADA;IACA;IADA;QAAA,kBACA;QADA;IACA;IADA;QAAA,kBACA;QADA;IACA;IADA;QAAA,iBACA;QADA;IACA;IADA;QAAA,mBACA;QADA;IACA;IADA;QAAA,kBACA;QADA;IACA;IADA;QAAA,kBACA;QADA;IACA;IADA;QAAA,oBACA;QADA;IACA;IADA;QAAA,kBACA;QADA;IACA;IADA;QAAA,kBACA;QADA;IACA;IADA;QAAA,kBACA;QADA;IACA;IADA;QAAA,kBACA;QADA;IACA;IADA;QAAA,kBACA;QADA;IACA;IADA;QAAA,kBACA;QADA;IACA;IADA;QAAA,oBACA;QADA;IACA;IADA;QAAA,iBACA;QADA;IACA;IADA;QAAA,kBACA;QADA;IACA;IADA;QAAA,iBACA;QADA;IACA;IADA;QAAA,gBACA;QADA;IACA;IADA;QAAA,iBACA;QADA;IACA;IADA;QAAA,iBACA;QADA;IACA;IADA;QAAA,gBACA;QADA;IACA;IADA;QAAA,iBACA;QADA;IACA;IADA;QAAA,iBACA;QADA;IACA;IADA;QAAA,iBACA;QADA;IACA;IADA;QAAA,iBACA;QADA;IACA;IADA;QAAA,iBACA;QADA;IACA;IADA;QAAA,iBACA;QADA;IACA;IADA;QAAA,iBACA;QADA;IACA;IADA;QAAA,iBACA;QADA;IACA;IADA;QAAA,iBACA;QADA;IACA;IADA;QAAA,iBACA;QADA;IACA;IADA;QAAA,iBACA;QADA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA,eACA;QADA;IACA;IADA;QAAA,eACA;QADA;IACA;IADA;QAAA,eACA;QADA;IACA;IADA;QAAA,eACA;QADA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA,sBACA;QADA,8BACA;QADA;IACA;IADA;QAAA,0BACA;QADA;IACA;IADA;QAAA,0BACA;QADA;IACA;AAAA;AADA;IAAA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA,4BACA;QADA;IACA;IADA;QAAA,2BACA;QADA;IACA;IADA;QAAA,gBACA;QADA;IACA;IADA;QAAA,iBACA;QADA;IACA;IADA;QAAA,iBACA;QADA;IACA;IADA;QAAA,iBACA;QADA;IACA;IADA;QAAA,eACA;QADA;IACA;IADA;QAAA,gBACA;QADA;IACA;IADA;QAAA,gBACA;QADA;IACA;IADA;QAAA,gBACA;QADA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA,uBACA;QADA;IACA;IADA;QAAA;IACA;IADA;QAAA,2BACA;QADA;IACA;IADA;QAAA,sBACA;QADA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA,qBACA;QADA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA,4BACA;QADA;IACA;IADA;QAAA,6BACA;QADA;IACA;IADA;QAAA,6BACA;QADA;IACA;IADA;QAAA,4BACA;QADA;IACA;IADA;QAAA,4BACA;QADA;IACA;IADA;QAAA,iBACA;QADA;IACA;IADA;QAAA,oBACA;QADA;IACA;IADA;QAAA,kBACA;QADA;IACA;IADA;QAAA,kBACA;QADA;IACA;IADA;QAAA,kBACA;QADA;IACA;IADA;QAAA,qBACA;QADA;IACA;IADA;QAAA,qBACA;QADA;IACA;IADA;QAAA,kBACA;QADA;IACA;IADA;QAAA,eACA;QADA;IACA;IADA;QAAA,kBACA;QADA;IACA;IADA;QAAA,gBACA;QADA;IACA;IADA;QAAA,kBACA;QADA;IACA;IADA;QAAA,kBACA;QADA;IACA;IADA;QAAA,kBACA;QADA;IACA;IADA;QAAA,oBACA;QADA;IACA;IADA;QAAA,kBACA;QADA;IACA;IADA;QAAA,kBACA;QADA;IACA;IADA;QAAA,kBACA;QADA;IACA;IADA;QAAA,gBACA;QADA;IACA;IADA;QAAA,iBACA;QADA;IACA;IADA;QAAA,gBACA;QADA;IACA;IADA;QAAA,iBACA;QADA;IACA;IADA;QAAA,iBACA;QADA;IACA;IADA;QAAA,iBACA;QADA;IACA;IADA;QAAA,iBACA;QADA;IACA;IADA;QAAA,iBACA;QADA;IACA;IADA;QAAA,iBACA;QADA;IACA;IADA;QAAA,iBACA;QADA;IACA;IADA;QAAA,iBACA;QADA;IACA;IADA;QAAA,mBACA;QADA;IACA;IADA;QAAA,iBACA;QADA;IACA;IADA;QAAA,eACA;QADA;IACA;IADA;QAAA,iBACA;QADA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA,eACA;QADA;IACA;IADA;QAAA,eACA;QADA;IACA;IADA;QAAA,eACA;QADA;IACA;IADA;QAAA,eACA;QADA;IACA;IADA;QAAA,eACA;QADA;IACA;IADA;QAAA,eACA;QADA;IACA;IADA;QAAA,eACA;QADA;IACA;IADA;QAAA,eACA;QADA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA,sCACA;QADA,oDACA;QADA;IACA;IADA;QAAA;IACA;AAAA;AADA;IAAA;QAAA;IACA;IADA;QAAA,gBACA;QADA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA,iBACA;QADA;IACA;IADA;QAAA,kBACA;QADA;IACA;IADA;QAAA,iBACA;QADA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;AAAA;AADA;IAAA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;AAAA;AADA;IAAA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;YAAA;QACA;QADA;YAAA;QACA;IAAA;AAAA;AADA;IAAA;QAAA;YAAA;QACA;IAAA;AAAA;AADA;IAAA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA,kBACA;QADA;IACA;IADA;QAAA;IACA;IADA;QAAA;YAAA,kBACA;YADA;QACA;IAAA;IADA;QAAA;YAAA;QACA;QADA;YAAA;QACA;QADA;YAAA,+BACA;YADA;QACA;QADA;YAAA,eACA;YADA;QACA;IAAA;IADA;QAAA;YAAA;QACA;QADA;YAAA;QACA;QADA;YAAA;QACA;QADA;YAAA;QACA;QADA;YAAA;QACA;QADA;YAAA;QACA;QADA;YAAA;QACA;QADA;YAAA;QACA;QADA;YAAA;QACA;QADA;YAAA;QACA;QADA;YAAA;QACA;QADA;YAAA;QACA;QADA;YAAA;QACA;QADA;YAAA;QACA;QADA;YAAA;QACA;QADA;YAAA;QACA;QADA;YAAA;QACA;QADA;YAAA;QACA;QADA;YAAA;QACA;QADA;YAAA;QACA;QADA;YAAA;QACA;QADA;YAAA;QACA;QADA;YAAA;QACA;QADA;YAAA;QACA;QADA;YAAA;QACA;QADA;YAAA;QACA;QADA;YAAA;QACA;IAAA;AAAA;AADA;IAAA;QAAA;YAAA;QACA;QADA;YAAA;QACA;IAAA;AAAA;AADA;IAAA;QAAA;YAAA;QACA;QADA;YAAA;QACA;QADA;YAAA;QACA;QADA;YAAA;QACA;QADA;YAAA,4BACA;YADA;QACA;QADA;YAAA,mBACA;YADA;QACA;IAAA;AAAA;AADA;IAAA;QAAA;YAAA,iBACA;YADA;QACA;IAAA;AAAA;AADA;IAAA;QAAA;YAAA;QACA;QADA;YAAA;QACA;QADA;YAAA;QACA;QADA;YAAA;QACA;QADA;YAAA;QACA;QADA;YAAA;QACA;QADA;YAAA;QACA;QADA;YAAA;QACA;IAAA;IADA;QAAA;YAAA;QACA;IAAA;AAAA","sourcesContent":["@tailwind components;\n@tailwind utilities;"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
